var models = (function (exports, _tools) {
    'use strict';

    (function (ePerm) {
        ePerm["viewUsers"] = "viewUsers";
        ePerm["modifyUsers"] = "modifyUsers";
        ePerm["modifyMedia"] = "modifyMedia";
        ePerm["viewProducts"] = "viewProducts";
        ePerm["modifyProducts"] = "modifyProducts";
        ePerm["viewCustomers"] = "viewCustomers";
        ePerm["modifyCustomers"] = "modifyCustomers";
        ePerm["viewComments"] = "viewComments";
        ePerm["addComments"] = "addComments";
        ePerm["modifyAllComments"] = "modifyAllComments";
        ePerm["viewAttachments"] = "viewAttachments";
        ePerm["addAttachments"] = "addAttachments";
        ePerm["modifyAllAttachments"] = "modifyAllAttachments";
        ePerm["modifyCurrencies"] = "modifyCurrencies";
        ePerm["modifyScenes"] = "modifyScenes";
        ePerm["setQuoteDiscount"] = "setQuoteDiscount";
        ePerm["setQuoteCustomer"] = "setQuoteCustomer";
        ePerm["setQuoteShipping"] = "setQuoteShipping";
        ePerm["setQuoteCurrency"] = "setQuoteCurrency";
        ePerm["viewQuoteDiscount"] = "viewQuoteDiscount";
        ePerm["viewQuoteCustomer"] = "viewQuoteCustomer";
        ePerm["viewQuoteShipping"] = "viewQuoteShipping";
        ePerm["viewQuoteHeader"] = "viewQuoteHeader";
        ePerm["viewQuoteCurrency"] = "viewQuoteCurrency";
        ePerm["viewPrices"] = "viewPrices";
        ePerm["viewCost"] = "viewCost";
        ePerm["loginToOutputBuilder"] = "loginToOutputBuilder";
        ePerm["setQuoteProductDescription"] = "setQuoteProductDescription";
        ePerm["viewQuoteOwner"] = "viewQuoteOwner";
        ePerm["setQuoteOwner"] = "setQuoteOwner";
    })(exports.ePerm || (exports.ePerm = {}));
    (function (eNotificationType) {
        eNotificationType["generic"] = "generic";
        eNotificationType["newUser"] = "newUser";
        eNotificationType["passwordReset"] = "passwordReset";
        eNotificationType["pendingApproval"] = "pendingApproval";
        eNotificationType["quoteApproved"] = "quoteApproved";
        eNotificationType["quoteRejected"] = "quoteRejected";
        eNotificationType["quote"] = "quote";
        eNotificationType["errorLog"] = "errorLog";
    })(exports.eNotificationType || (exports.eNotificationType = {}));
    (function (eNotificationSetting) {
        eNotificationSetting["none"] = "none";
        eNotificationSetting["companyDefault"] = "companyDefault";
        eNotificationSetting["notify"] = "notify";
        eNotificationSetting["email"] = "email";
        eNotificationSetting["notifyAndEmail"] = "notifyAndEmail";
    })(exports.eNotificationSetting || (exports.eNotificationSetting = {}));
    (function (eEnvironment) {
        eEnvironment["prod"] = "prod";
        eEnvironment["test"] = "test";
        eEnvironment["dev"] = "dev";
    })(exports.eEnvironment || (exports.eEnvironment = {}));
    (function (eWorkflowAction) {
        eWorkflowAction["custom"] = "custom";
        eWorkflowAction["save"] = "save";
        eWorkflowAction["deleter"] = "deleter";
        eWorkflowAction["submit"] = "submit";
        eWorkflowAction["unsubmit"] = "unsubmit";
        eWorkflowAction["approve"] = "approve";
        eWorkflowAction["reject"] = "reject";
        eWorkflowAction["entryFail"] = "entryFail";
        eWorkflowAction["completeBuild"] = "completeBuild";
        eWorkflowAction["failBuild"] = "failBuild";
        eWorkflowAction["modifyProducts"] = "modifyProducts";
        eWorkflowAction["modifyDiscount"] = "modifyDiscount";
        eWorkflowAction["modifyName"] = "modifyName";
        eWorkflowAction["modifyCustomer"] = "modifyCustomer";
        eWorkflowAction["modifyAttachments"] = "modifyAttachments";
        eWorkflowAction["addAttachments"] = "addAttachments";
        eWorkflowAction["modifyQuoteHeader"] = "modifyQuoteHeader";
        eWorkflowAction["modifyCurrency"] = "modifyCurrency";
        eWorkflowAction["reorderProducts"] = "reorderProducts";
        eWorkflowAction["modifyQuoteProductDescription"] = "modifyQuoteProductDescription";
        eWorkflowAction["modifyShipping"] = "modifyShipping";
        eWorkflowAction["buildQuoteProduct"] = "buildQuoteProduct";
        eWorkflowAction["assignQuote"] = "assignQuote";
    })(exports.eWorkflowAction || (exports.eWorkflowAction = {}));
    (function (eViewPermission) {
        eViewPermission["viewQuote"] = "viewQuote";
        eViewPermission["viewCost"] = "viewCost";
        eViewPermission["viewPricing"] = "viewPricing";
        eViewPermission["viewDiscount"] = "viewDiscount";
        eViewPermission["viewCustomer"] = "viewCustomer";
        eViewPermission["viewOutput"] = "viewOutput";
        eViewPermission["viewQuoteHeader"] = "viewQuoteHeader";
        eViewPermission["viewCurrency"] = "viewCurrency";
        eViewPermission["viewShipping"] = "viewShipping";
        eViewPermission["viewQuoteProductDetails"] = "viewQuoteProductDetails";
        eViewPermission["submitQuote"] = "submitQuote";
        eViewPermission["viewQuoteOwner"] = "viewQuoteOwner";
    })(exports.eViewPermission || (exports.eViewPermission = {}));
    (function (eOutputType) {
        eOutputType["none"] = "none";
        eOutputType["word"] = "word";
        eOutputType["excel"] = "excel";
        eOutputType["image"] = "image";
        eOutputType["solidworks"] = "solidworks";
        eOutputType["inventor"] = "inventor";
        eOutputType["creo"] = "creo";
        eOutputType["creo3"] = "creo3";
        eOutputType["cadDrawing"] = "cadDrawing";
        eOutputType["bom"] = "bom";
        eOutputType["sceneRender"] = "sceneRender";
        eOutputType["sceneModel"] = "sceneModel";
        eOutputType["pdf"] = "pdf";
        eOutputType["salesforce"] = "salesforce";
        eOutputType["autoCad"] = "autoCad";
        eOutputType["zip"] = "zip";
        eOutputType["svg"] = "svg";
        eOutputType["text"] = "text";
    })(exports.eOutputType || (exports.eOutputType = {}));
    (function (eOutputFieldType) {
        eOutputFieldType["wordText"] = "wordText";
        eOutputFieldType["wordContainer"] = "wordContainer";
        eOutputFieldType["wordImage"] = "wordImage";
        eOutputFieldType["wordList"] = "wordList";
        eOutputFieldType["excelSheet"] = "excelSheet";
        eOutputFieldType["excelCell"] = "excelCell";
        eOutputFieldType["excelImage"] = "excelImage";
        eOutputFieldType["excelTable"] = "excelTable";
        eOutputFieldType["excelChart"] = "excelChart";
        eOutputFieldType["cadReplaceComponent"] = "cadReplaceComponent";
        eOutputFieldType["cadAngleMate"] = "cadAngleMate";
        eOutputFieldType["cadCoincidentMate"] = "cadCoincidentMate";
        eOutputFieldType["cadCoordinateSystemMate"] = "cadCoordinateSystemMate";
        eOutputFieldType["cadDistanceMate"] = "cadDistanceMate";
        eOutputFieldType["cadPositionConstraint"] = "cadPositionConstraint";
        eOutputFieldType["cadDimension"] = "cadDimension";
        eOutputFieldType["cadFeature"] = "cadFeature";
        eOutputFieldType["cadLibFeature"] = "cadLibFeature";
        eOutputFieldType["cadCustomProperty"] = "cadCustomProperty";
        eOutputFieldType["cadComponent"] = "cadComponent";
        eOutputFieldType["cadDrawingView"] = "cadDrawingView";
        eOutputFieldType["cadDrawingSheet"] = "cadDrawingSheet";
        eOutputFieldType["cadDrawingAnnotation"] = "cadDrawingAnnotation";
        eOutputFieldType["cadDynamicDrawingDimension"] = "cadDynamicDrawingDimension";
        eOutputFieldType["cadDynamicDrawingAnnotation"] = "cadDynamicDrawingAnnotation";
        eOutputFieldType["cadDynamicComponent"] = "cadDynamicComponent";
        eOutputFieldType["cadNestedComponent"] = "cadNestedComponent";
        eOutputFieldType["cadScaleFeature"] = "cadScaleFeature";
        eOutputFieldType["cadAnnotation"] = "cadAnnotation";
        eOutputFieldType["cadText"] = "cadText";
        eOutputFieldType["cadParameter"] = "cadParameter";
        eOutputFieldType["cadRepresentation"] = "cadRepresentation";
        eOutputFieldType["cadPoint"] = "cadPoint";
        eOutputFieldType["cadLayer"] = "cadLayer";
        eOutputFieldType["bomMapping"] = "bomMapping";
        eOutputFieldType["salesForceObject"] = "salesForceObject";
        eOutputFieldType["cadDrawingDimension"] = "cadDrawingDimension";
        eOutputFieldType["pdfSection"] = "pdfSection";
        eOutputFieldType["cadLibReference"] = "cadLibReference";
        eOutputFieldType["cadLibDimension"] = "cadLibDimension";
        eOutputFieldType["cadBlock"] = "cadBlock";
        eOutputFieldType["cadBlockArray"] = "cadBlockArray";
        eOutputFieldType["zipSection"] = "zipSection";
    })(exports.eOutputFieldType || (exports.eOutputFieldType = {}));
    (function (eExportType) {
        eExportType["_custom"] = "_custom";
        eExportType["pdf"] = "pdf";
        eExportType["bmp"] = "bmp";
        eExportType["doc"] = "doc";
        eExportType["docm"] = "docm";
        eExportType["dot"] = "dot";
        eExportType["dotm"] = "dotm";
        eExportType["dotx"] = "dotx";
        eExportType["emf"] = "emf";
        eExportType["epub"] = "epub";
        eExportType["html"] = "html";
        eExportType["jpg"] = "jpg";
        eExportType["gif"] = "gif";
        eExportType["tiff"] = "tiff";
        eExportType["dwf"] = "dwf";
        eExportType["edrw"] = "edrw";
        eExportType["png"] = "png";
        eExportType["odt"] = "odt";
        eExportType["rtf"] = "rtf";
        eExportType["tif"] = "tif";
        eExportType["xaml"] = "xaml";
        eExportType["xps"] = "xps";
        eExportType["ods"] = "ods";
        eExportType["svg"] = "svg";
        eExportType["txt"] = "txt";
        eExportType["easm"] = "easm";
        eExportType["prt"] = "prt";
        eExportType["g"] = "g";
        eExportType["dwg"] = "dwg";
        eExportType["dxf"] = "dxf";
        eExportType["glb"] = "glb";
        eExportType["fbx"] = "fbx";
        eExportType["sldprt"] = "sldprt";
        eExportType["sldasm"] = "sldasm";
        eExportType["slddrw"] = "slddrw";
        eExportType["sldlfp"] = "sldlfp";
        eExportType["x_t"] = "x_t";
        eExportType["x_b"] = "x_b";
        eExportType["igs"] = "igs";
        eExportType["stl"] = "stl";
        eExportType["wrl"] = "wrl";
        eExportType["u3d"] = "u3d";
        eExportType["psd"] = "psd";
        eExportType["ai"] = "ai";
        eExportType["cgr"] = "cgr";
        eExportType["asm"] = "asm";
        eExportType["hcg"] = "hcg";
        eExportType["hsf"] = "hsf";
        eExportType["sat"] = "sat";
        eExportType["stp"] = "stp";
        eExportType["step"] = "step";
        eExportType["vda"] = "vda";
        eExportType["neu"] = "neu";
        eExportType["iv"] = "iv";
        eExportType["slp"] = "slp";
        eExportType["eps"] = "eps";
        eExportType["catproduct"] = "catproduct";
        eExportType["jt"] = "jt";
        eExportType["zgl"] = "zgl";
        eExportType["xgl"] = "xgl";
        eExportType["csv"] = "csv";
        eExportType["xml"] = "xml";
    })(exports.eExportType || (exports.eExportType = {}));
    (function (eFileSource) {
        eFileSource["generated"] = "generated";
        eFileSource["uploaded"] = "uploaded";
        eFileSource["media"] = "media";
        eFileSource["fileUploadField"] = "fileUploadField";
    })(exports.eFileSource || (exports.eFileSource = {}));
    (function (eFileStatus) {
        eFileStatus["none"] = "none";
        eFileStatus["generating"] = "generating";
        eFileStatus["complete"] = "complete";
        eFileStatus["failed"] = "failed";
    })(exports.eFileStatus || (exports.eFileStatus = {}));
    (function (eLogType) {
        eLogType["info"] = "info";
        eLogType["error"] = "error";
        eLogType["warning"] = "warning";
    })(exports.eLogType || (exports.eLogType = {}));
    (function (eLogSource) {
        eLogSource["productRule"] = "productRule";
        eLogSource["workflowRule"] = "workflowRule";
        eLogSource["quoteHeaderRule"] = "quoteHeaderRule";
        eLogSource["quoteAction"] = "quoteAction";
        eLogSource["output"] = "output";
        eLogSource["outputRule"] = "outputRule";
        eLogSource["outputDriver"] = "outputDriver";
        eLogSource["safeFunction"] = "safeFunction";
        eLogSource["restHelper"] = "restHelper";
        eLogSource["workerRole"] = "workerRole";
        eLogSource["sceneImporterWatcher"] = "sceneImporterWatcher";
        eLogSource["sceneExporterWatcher"] = "sceneExporterWatcher";
        eLogSource["notificationQueueWatcher"] = "notificationQueueWatcher";
        eLogSource["configuratorPricingRule"] = "configuratorPricingRule";
        eLogSource["configuratorSubmitRule"] = "configuratorSubmitRule";
        eLogSource["configuratorNamingRule"] = "configuratorNamingRule";
        eLogSource["configuratorLoadedRule"] = "configuratorLoadedRule";
        eLogSource["configuratorValueRule"] = "configuratorValueRule";
        eLogSource["configuratorValidationRule"] = "configuratorValidationRule";
        eLogSource["configuratorMethodOfManufactureRule"] = "configuratorMethodOfManufactureRule";
        eLogSource["table"] = "table";
        eLogSource["kineticDocumentRules"] = "kineticDocumentRules";
    })(exports.eLogSource || (exports.eLogSource = {}));
    (function (eFieldType) {
        eFieldType["text"] = "text";
        eFieldType["number"] = "number";
        eFieldType["boolean"] = "boolean";
        eFieldType["color"] = "color";
        eFieldType["date"] = "date";
        eFieldType["upload"] = "upload";
        eFieldType["textArray"] = "textArray";
        eFieldType["numberArray"] = "numberArray";
        eFieldType["colorArray"] = "colorArray";
    })(exports.eFieldType || (exports.eFieldType = {}));
    (function (eFieldControl) {
        eFieldControl["none"] = "none";
        eFieldControl["textbox"] = "textbox";
        eFieldControl["multilineTextbox"] = "multilineTextbox";
        eFieldControl["label"] = "label";
        eFieldControl["numberbox"] = "numberbox";
        eFieldControl["checkbox"] = "checkbox";
        eFieldControl["toggle"] = "toggle";
        eFieldControl["select"] = "select";
        eFieldControl["colorSelect"] = "colorSelect";
        eFieldControl["button"] = "button";
        eFieldControl["upload"] = "upload";
        eFieldControl["slider"] = "slider";
        eFieldControl["imageSelect"] = "imageSelect";
        eFieldControl["colorPicker"] = "colorPicker";
        eFieldControl["swatchSelect"] = "swatchSelect";
        eFieldControl["autoComplete"] = "autoComplete";
        eFieldControl["media"] = "media";
        eFieldControl["html"] = "html";
        eFieldControl["datePicker"] = "datePicker";
        eFieldControl["multiSelect"] = "multiSelect";
        eFieldControl["colorMultiSelect"] = "colorMultiSelect";
        eFieldControl["imageMultiSelect"] = "imageMultiSelect";
        eFieldControl["radio"] = "radio";
        eFieldControl["mediaPicker"] = "mediaPicker";
    })(exports.eFieldControl || (exports.eFieldControl = {}));
    (function (eSort) {
        eSort["none"] = "none";
        eSort["ascending"] = "ascending";
        eSort["descending"] = "descending";
    })(exports.eSort || (exports.eSort = {}));
    (function (eProductSortBy) {
        eProductSortBy["relevance"] = "relevance";
        eProductSortBy["priceLowToHigh"] = "priceLowToHigh";
        eProductSortBy["priceHighToLow"] = "priceHighToLow";
        eProductSortBy["popularity"] = "popularity";
        eProductSortBy["nameAtoZ"] = "nameAtoZ";
    })(exports.eProductSortBy || (exports.eProductSortBy = {}));
    (function (eFormatType) {
        eFormatType["none"] = "none";
        eFormatType["number"] = "number";
        eFormatType["currency"] = "currency";
        eFormatType["percentage"] = "percentage";
    })(exports.eFormatType || (exports.eFormatType = {}));
    (function (eRuleType) {
        eRuleType["value"] = "value";
        eRuleType["visibility"] = "visibility";
        eRuleType["validation"] = "validation";
        eRuleType["pricing"] = "pricing";
        eRuleType["message"] = "message";
        eRuleType["loaded"] = "loaded";
        eRuleType["submit"] = "submit";
        eRuleType["pageChanged"] = "pageChanged";
        eRuleType["tabChanged"] = "tabChanged";
        eRuleType["expanderChanged"] = "expanderChanged";
        eRuleType["output"] = "output";
        eRuleType["action"] = "action";
        eRuleType["function"] = "function";
        eRuleType["global"] = "global";
        eRuleType["globalEvent"] = "globalEvent";
        eRuleType["safeFunction"] = "safeFunction";
        eRuleType["naming"] = "naming";
        eRuleType["field"] = "field";
        eRuleType["button"] = "button";
        eRuleType["svgViewer"] = "svgViewer";
        eRuleType["html"] = "html";
        eRuleType["dragStart"] = "dragStart";
        eRuleType["dragMove"] = "dragMove";
        eRuleType["dragEnd"] = "dragEnd";
        eRuleType["optionFilter"] = "optionFilter";
        eRuleType["nested"] = "nested";
        eRuleType["resize"] = "resize";
        eRuleType["nestedSetSelected"] = "nestedSetSelected";
        eRuleType["keyboard"] = "keyboard";
        eRuleType["manufacture"] = "manufacture";
        eRuleType["bistrackManufacture"] = "bistrackManufacture";
        eRuleType["kineticDocumentRules"] = "kineticDocumentRules";
        eRuleType["layout"] = "layout";
        eRuleType["configuratorAdded"] = "configuratorAdded";
        eRuleType["configuratorRemoved"] = "configuratorRemoved";
        eRuleType["configuratorCopied"] = "configuratorCopied";
        eRuleType["product"] = "product";
        eRuleType["workflow"] = "workflow";
        eRuleType["beforeBuild"] = "beforeBuild";
        eRuleType["globalDefinition"] = "globalDefinition";
        eRuleType["globalFunction"] = "globalFunction";
        eRuleType["quote"] = "quote";
        eRuleType["scene"] = "scene";
        eRuleType["sceneLoaded"] = "sceneLoaded";
        eRuleType["xrEnter"] = "xrEnter";
        eRuleType["xrExit"] = "xrExit";
    })(exports.eRuleType || (exports.eRuleType = {}));
    (function (eClusterEnv) {
        eClusterEnv["prod"] = "prod";
        eClusterEnv["staging"] = "staging";
        eClusterEnv["debug"] = "debug";
        eClusterEnv["next"] = "next";
        eClusterEnv["dev"] = "dev";
    })(exports.eClusterEnv || (exports.eClusterEnv = {}));
    (function (eConfiguratorLayout) {
        eConfiguratorLayout["standard"] = "standard";
        eConfiguratorLayout["immersive"] = "immersive";
    })(exports.eConfiguratorLayout || (exports.eConfiguratorLayout = {}));
    (function (eConfiguratorTabStyle) {
        eConfiguratorTabStyle["cards"] = "cards";
        eConfiguratorTabStyle["tree"] = "tree";
    })(exports.eConfiguratorTabStyle || (exports.eConfiguratorTabStyle = {}));
    (function (eDeploymentStatus) {
        eDeploymentStatus["inProgress"] = "inProgress";
        eDeploymentStatus["success"] = "success";
        eDeploymentStatus["failed"] = "failed";
    })(exports.eDeploymentStatus || (exports.eDeploymentStatus = {}));
    (function (eDifference) {
        eDifference["none"] = "none";
        eDifference["changed"] = "changed";
        eDifference["added"] = "added";
        eDifference["removed"] = "removed";
    })(exports.eDifference || (exports.eDifference = {}));
    (function (eViewerMode) {
        eViewerMode["none"] = "none";
        eViewerMode["media"] = "media";
        eViewerMode["scene"] = "scene";
    })(exports.eViewerMode || (exports.eViewerMode = {}));
    (function (ePosition) {
        ePosition["left"] = "left";
        ePosition["right"] = "right";
    })(exports.ePosition || (exports.ePosition = {}));
    (function (eTabPosition) {
        eTabPosition["left"] = "left";
        eTabPosition["right"] = "right";
        eTabPosition["top"] = "top";
        eTabPosition["bottom"] = "bottom";
    })(exports.eTabPosition || (exports.eTabPosition = {}));
    (function (eColumnType) {
        eColumnType["text"] = "text";
        eColumnType["number"] = "number";
        eColumnType["boolean"] = "boolean";
        eColumnType["color"] = "color";
        eColumnType["date"] = "date";
        eColumnType["media"] = "media";
        eColumnType["translated"] = "translated";
    })(exports.eColumnType || (exports.eColumnType = {}));
    (function (eSelectSource) {
        eSelectSource["simple"] = "simple";
        eSelectSource["optionFilter"] = "optionFilter";
    })(exports.eSelectSource || (exports.eSelectSource = {}));
    (function (eAutoCompleteSource) {
        eAutoCompleteSource["table"] = "table";
        eAutoCompleteSource["database"] = "database";
    })(exports.eAutoCompleteSource || (exports.eAutoCompleteSource = {}));
    (function (eOptionFilterSource) {
        eOptionFilterSource["table"] = "table";
        eOptionFilterSource["database"] = "database";
        eOptionFilterSource["query"] = "query";
        eOptionFilterSource["safeFunction"] = "safeFunction";
        eOptionFilterSource["optionFilter"] = "optionFilter";
    })(exports.eOptionFilterSource || (exports.eOptionFilterSource = {}));
    (function (eDynamicSource) {
        eDynamicSource["media"] = "media";
        eDynamicSource["template"] = "template";
        eDynamicSource["output"] = "output";
        eDynamicSource["nested"] = "nested";
        eDynamicSource["nestedExport"] = "nestedExport";
        eDynamicSource["exprt"] = "exprt";
        eDynamicSource["url"] = "url";
        eDynamicSource["tag"] = "tag";
        eDynamicSource["quoteOutput"] = "quoteOutput";
        eDynamicSource["fileUploadField"] = "fileUploadField";
    })(exports.eDynamicSource || (exports.eDynamicSource = {}));
    (function (eQueryMode) {
        eQueryMode["none"] = "none";
        eQueryMode["table"] = "table";
        eQueryMode["database"] = "database";
        eQueryMode["array"] = "array";
        eQueryMode["optionFilter"] = "optionFilter";
        eQueryMode["parentOptionFilter"] = "parentOptionFilter";
    })(exports.eQueryMode || (exports.eQueryMode = {}));
    (function (eConfiguratorImageSource) {
        eConfiguratorImageSource["none"] = "none";
        eConfiguratorImageSource["media"] = "media";
        eConfiguratorImageSource["scene"] = "scene";
    })(exports.eConfiguratorImageSource || (exports.eConfiguratorImageSource = {}));
    (function (ePricingFillFromSource) {
        ePricingFillFromSource["none"] = "none";
        ePricingFillFromSource["table"] = "table";
        ePricingFillFromSource["database"] = "database";
    })(exports.ePricingFillFromSource || (exports.ePricingFillFromSource = {}));
    (function (eSingleOptionBehavior) {
        eSingleOptionBehavior["nothing"] = "nothing";
        eSingleOptionBehavior["disable"] = "disable";
        eSingleOptionBehavior["hide"] = "hide";
    })(exports.eSingleOptionBehavior || (exports.eSingleOptionBehavior = {}));
    (function (eFilterSource) {
        eFilterSource["none"] = "none";
        eFilterSource["enum"] = "enum";
        eFilterSource["properties"] = "properties";
        eFilterSource["users"] = "users";
        eFilterSource["states"] = "states";
        eFilterSource["configurators"] = "configurators";
        eFilterSource["fields"] = "fields";
        eFilterSource["customers"] = "customers";
        eFilterSource["roles"] = "roles";
        eFilterSource["productSorts"] = "productSorts";
        eFilterSource["manufacturers"] = "manufacturers";
        eFilterSource["attributes"] = "attributes";
        eFilterSource["suggestContacts"] = "suggestContacts";
        eFilterSource["suggestCustomers"] = "suggestCustomers";
        eFilterSource["suggestQuotes"] = "suggestQuotes";
        eFilterSource["suggestProducts"] = "suggestProducts";
        eFilterSource["headerFields"] = "headerFields";
    })(exports.eFilterSource || (exports.eFilterSource = {}));
    (function (eFilterType) {
        eFilterType["property"] = "property";
        eFilterType["fieldValue"] = "fieldValue";
        eFilterType["sort"] = "sort";
        eFilterType["attribute"] = "attribute";
        eFilterType["headerValue"] = "headerValue";
    })(exports.eFilterType || (exports.eFilterType = {}));
    (function (eFilterControl) {
        eFilterControl["none"] = "none";
        eFilterControl["text"] = "text";
        eFilterControl["select"] = "select";
        eFilterControl["multiSelect"] = "multiSelect";
        eFilterControl["dateRange"] = "dateRange";
        eFilterControl["numberRange"] = "numberRange";
        eFilterControl["suggest"] = "suggest";
        eFilterControl["checkbox"] = "checkbox";
    })(exports.eFilterControl || (exports.eFilterControl = {}));
    (function (eLogSetting) {
        eLogSetting["all"] = "all";
        eLogSetting["minimal"] = "minimal";
    })(exports.eLogSetting || (exports.eLogSetting = {}));
    (function (eHotspotSource) {
        eHotspotSource["none"] = "none";
        eHotspotSource["text"] = "text";
        eHotspotSource["media"] = "media";
        eHotspotSource["element"] = "element";
    })(exports.eHotspotSource || (exports.eHotspotSource = {}));
    (function (eHotspotAttach) {
        eHotspotAttach["topLeft"] = "topLeft";
        eHotspotAttach["top"] = "top";
        eHotspotAttach["topRight"] = "topRight";
        eHotspotAttach["left"] = "left";
        eHotspotAttach["center"] = "center";
        eHotspotAttach["right"] = "right";
        eHotspotAttach["bottomLeft"] = "bottomLeft";
        eHotspotAttach["bottom"] = "bottom";
        eHotspotAttach["bottomRight"] = "bottomRight";
    })(exports.eHotspotAttach || (exports.eHotspotAttach = {}));
    (function (eLayerLineWeight) {
        eLayerLineWeight["lnWtByLayer"] = "lnWtByLayer";
        eLayerLineWeight["lnWtByBlock"] = "lnWtByBlock";
        eLayerLineWeight["lnWtByLwDefault"] = "lnWtByLwDefault";
        eLayerLineWeight["lnWt000"] = "lnWt000";
        eLayerLineWeight["lnWt005"] = "lnWt005";
        eLayerLineWeight["lnWt009"] = "lnWt009";
        eLayerLineWeight["lnWt013"] = "lnWt013";
        eLayerLineWeight["lnWt015"] = "lnWt015";
        eLayerLineWeight["lnWt018"] = "lnWt018";
        eLayerLineWeight["lnWt020"] = "lnWt020";
        eLayerLineWeight["lnWt025"] = "lnWt025";
        eLayerLineWeight["lnWt030"] = "lnWt030";
        eLayerLineWeight["lnWt035"] = "lnWt035";
        eLayerLineWeight["lnWt040"] = "lnWt040";
        eLayerLineWeight["lnWt050"] = "lnWt050";
        eLayerLineWeight["lnWt053"] = "lnWt053";
        eLayerLineWeight["lnWt060"] = "lnWt060";
        eLayerLineWeight["lnWt070"] = "lnWt070";
        eLayerLineWeight["lnWt080"] = "lnWt080";
        eLayerLineWeight["lnWt090"] = "lnWt090";
        eLayerLineWeight["lnWt100"] = "lnWt100";
        eLayerLineWeight["lnWt106"] = "lnWt106";
        eLayerLineWeight["lnWt120"] = "lnWt120";
        eLayerLineWeight["lnWt140"] = "lnWt140";
        eLayerLineWeight["lnWt158"] = "lnWt158";
        eLayerLineWeight["lnWt200"] = "lnWt200";
        eLayerLineWeight["lnWt211"] = "lnWt211";
    })(exports.eLayerLineWeight || (exports.eLayerLineWeight = {}));
    (function (eHotspotPosition) {
        eHotspotPosition["manual"] = "manual";
        eHotspotPosition["target"] = "target";
    })(exports.eHotspotPosition || (exports.eHotspotPosition = {}));
    (function (eAnimationEasing) {
        eAnimationEasing["linear"] = "linear";
        eAnimationEasing["easeInQuad"] = "easeInQuad";
        eAnimationEasing["easeOutQuad"] = "easeOutQuad";
        eAnimationEasing["easeInOutQuad"] = "easeInOutQuad";
        eAnimationEasing["easeInCubic"] = "easeInCubic";
        eAnimationEasing["easeOutCubic"] = "easeOutCubic";
        eAnimationEasing["easeInOutCubic"] = "easeInOutCubic";
        eAnimationEasing["easeInQuart"] = "easeInQuart";
        eAnimationEasing["easeOutQuart"] = "easeOutQuart";
        eAnimationEasing["easeInOutQuart"] = "easeInOutQuart";
        eAnimationEasing["easeInQuint"] = "easeInQuint";
        eAnimationEasing["easeOutQuint"] = "easeOutQuint";
        eAnimationEasing["easeInOutQuint"] = "easeInOutQuint";
        eAnimationEasing["easeInSine"] = "easeInSine";
        eAnimationEasing["easeOutSine"] = "easeOutSine";
        eAnimationEasing["easeInOutSine"] = "easeInOutSine";
        eAnimationEasing["easeInExpo"] = "easeInExpo";
        eAnimationEasing["easeOutExpo"] = "easeOutExpo";
        eAnimationEasing["easeInOutExpo"] = "easeInOutExpo";
        eAnimationEasing["easeInCirc"] = "easeInCirc";
        eAnimationEasing["easeOutCirc"] = "easeOutCirc";
        eAnimationEasing["easeInOutCirc"] = "easeInOutCirc";
        eAnimationEasing["easeInElastic"] = "easeInElastic";
        eAnimationEasing["easeOutElastic"] = "easeOutElastic";
        eAnimationEasing["easeInOutElastic"] = "easeInOutElastic";
        eAnimationEasing["easeInBack"] = "easeInBack";
        eAnimationEasing["easeOutBack"] = "easeOutBack";
        eAnimationEasing["easeInOutBack"] = "easeInOutBack";
        eAnimationEasing["easeInBounce"] = "easeInBounce";
        eAnimationEasing["easeOutBounce"] = "easeOutBounce";
        eAnimationEasing["easeInOutBounce"] = "easeInOutBounce";
    })(exports.eAnimationEasing || (exports.eAnimationEasing = {}));
    (function (eQueueMessageType) {
        eQueueMessageType["builder"] = "builder";
        eQueueMessageType["cleanDb"] = "cleanDb";
        eQueueMessageType["completeBuildState"] = "completeBuildState";
        eQueueMessageType["notification"] = "notification";
        eQueueMessageType["render"] = "render";
        eQueueMessageType["pullSfdcProducts"] = "pullSfdcProducts";
        eQueueMessageType["upsertProductsToSfdc"] = "upsertProductsToSfdc";
        eQueueMessageType["submitFromSfdcCpq"] = "submitFromSfdcCpq";
        eQueueMessageType["deployment"] = "deployment";
        eQueueMessageType["deploymentCompare"] = "deploymentCompare";
        eQueueMessageType["completeQuoteProductBuild"] = "completeQuoteProductBuild";
        eQueueMessageType["sceneImport"] = "sceneImport";
        eQueueMessageType["sceneExport"] = "sceneExport";
        eQueueMessageType["sceneConvert"] = "sceneConvert";
    })(exports.eQueueMessageType || (exports.eQueueMessageType = {}));
    (function (eStateType) {
        eStateType["state"] = "state";
        eStateType["approval"] = "approval";
        eStateType["build"] = "build";
        eStateType["unsubmitted"] = "unsubmitted";
    })(exports.eStateType || (exports.eStateType = {}));
    (function (eDescriptorType) {
        eDescriptorType["user"] = "user";
        eDescriptorType["role"] = "role";
        eDescriptorType["email"] = "email";
    })(exports.eDescriptorType || (exports.eDescriptorType = {}));
    (function (eWorkflowBuildType) {
        eWorkflowBuildType["quoteOutput"] = "quoteOutput";
        eWorkflowBuildType["configurator"] = "configurator";
    })(exports.eWorkflowBuildType || (exports.eWorkflowBuildType = {}));
    (function (eWorkflowPermissionType) {
        eWorkflowPermissionType["view"] = "view";
        eWorkflowPermissionType["viewOutput"] = "viewOutput";
    })(exports.eWorkflowPermissionType || (exports.eWorkflowPermissionType = {}));
    (function (eAdminNotificationTarget) {
        eAdminNotificationTarget["companyAdmins"] = "companyAdmins";
        eAdminNotificationTarget["allUsersExceptSelfRegistered"] = "allUsersExceptSelfRegistered";
    })(exports.eAdminNotificationTarget || (exports.eAdminNotificationTarget = {}));
    (function (eConfiguratorEntityType) {
        eConfiguratorEntityType["product"] = "product";
        eConfiguratorEntityType["quoteHeader"] = "quoteHeader";
    })(exports.eConfiguratorEntityType || (exports.eConfiguratorEntityType = {}));
    (function (eHotspotShape) {
        eHotspotShape["circle"] = "circle";
        eHotspotShape["circleWithText"] = "circleWithText";
        eHotspotShape["image"] = "image";
        eHotspotShape["mesh"] = "mesh";
        eHotspotShape["text"] = "text";
    })(exports.eHotspotShape || (exports.eHotspotShape = {}));
    (function (eValidationType) {
        eValidationType["error"] = "error";
        eValidationType["warning"] = "warning";
        eValidationType["info"] = "info";
    })(exports.eValidationType || (exports.eValidationType = {}));
    (function (eIconStyle) {
        eIconStyle["none"] = "none";
        eIconStyle["icon"] = "icon";
        eIconStyle["media"] = "media";
    })(exports.eIconStyle || (exports.eIconStyle = {}));
    (function (eOracleCpqOperation) {
        eOracleCpqOperation["createTransaction"] = "createTransaction";
        eOracleCpqOperation["importFileAttachment"] = "importFileAttachment";
    })(exports.eOracleCpqOperation || (exports.eOracleCpqOperation = {}));
    (function (eOptionLayout) {
        eOptionLayout["wrap"] = "wrap";
        eOptionLayout["vertical"] = "vertical";
        eOptionLayout["scroll"] = "scroll";
    })(exports.eOptionLayout || (exports.eOptionLayout = {}));
    (function (eButtonStyle) {
        eButtonStyle["normal"] = "normal";
        eButtonStyle["link"] = "link";
        eButtonStyle["outline"] = "outline";
    })(exports.eButtonStyle || (exports.eButtonStyle = {}));
    (function (eTableExternalSource) {
        eTableExternalSource["none"] = "none";
        eTableExternalSource["database"] = "database";
    })(exports.eTableExternalSource || (exports.eTableExternalSource = {}));
    (function (eSkin) {
        eSkin["classic"] = "classic";
        eSkin["material"] = "material";
    })(exports.eSkin || (exports.eSkin = {}));
    (function (eGridColumnWidth) {
        eGridColumnWidth["auto"] = "auto";
        eGridColumnWidth["x1"] = "x1";
        eGridColumnWidth["x2"] = "x2";
        eGridColumnWidth["x3"] = "x3";
        eGridColumnWidth["x4"] = "x4";
        eGridColumnWidth["x5"] = "x5";
        eGridColumnWidth["x6"] = "x6";
        eGridColumnWidth["x7"] = "x7";
        eGridColumnWidth["x8"] = "x8";
        eGridColumnWidth["x9"] = "x9";
        eGridColumnWidth["x10"] = "x10";
        eGridColumnWidth["x11"] = "x11";
        eGridColumnWidth["x12"] = "x12";
    })(exports.eGridColumnWidth || (exports.eGridColumnWidth = {}));
    (function (eRelativeSize) {
        eRelativeSize["auto"] = "auto";
        eRelativeSize["x1"] = "x1";
        eRelativeSize["x2"] = "x2";
        eRelativeSize["x3"] = "x3";
        eRelativeSize["x4"] = "x4";
        eRelativeSize["x5"] = "x5";
        eRelativeSize["x6"] = "x6";
        eRelativeSize["x7"] = "x7";
        eRelativeSize["x8"] = "x8";
        eRelativeSize["x9"] = "x9";
        eRelativeSize["x10"] = "x10";
        eRelativeSize["x11"] = "x11";
        eRelativeSize["x12"] = "x12";
        eRelativeSize["custom"] = "custom";
    })(exports.eRelativeSize || (exports.eRelativeSize = {}));
    (function (eVerticalAlignment) {
        eVerticalAlignment["stretch"] = "stretch";
        eVerticalAlignment["top"] = "top";
        eVerticalAlignment["center"] = "center";
        eVerticalAlignment["bottom"] = "bottom";
    })(exports.eVerticalAlignment || (exports.eVerticalAlignment = {}));
    (function (eHorizontalAlignment) {
        eHorizontalAlignment["left"] = "left";
        eHorizontalAlignment["center"] = "center";
        eHorizontalAlignment["right"] = "right";
    })(exports.eHorizontalAlignment || (exports.eHorizontalAlignment = {}));
    (function (ePadding) {
        ePadding["none"] = "none";
        ePadding["small"] = "small";
        ePadding["medium"] = "medium";
        ePadding["large"] = "large";
    })(exports.ePadding || (exports.ePadding = {}));
    (function (eMaskType) {
        eMaskType["none"] = "none";
        eMaskType["phone"] = "phone";
        eMaskType["zipCode"] = "zipCode";
    })(exports.eMaskType || (exports.eMaskType = {}));
    (function (eValidationTiming) {
        eValidationTiming["always"] = "always";
        eValidationTiming["onTouched"] = "onTouched";
    })(exports.eValidationTiming || (exports.eValidationTiming = {}));
    (function (eTextStyle) {
        eTextStyle["normal"] = "normal";
        eTextStyle["h1"] = "h1";
        eTextStyle["h2"] = "h2";
        eTextStyle["h3"] = "h3";
        eTextStyle["h4"] = "h4";
        eTextStyle["h5"] = "h5";
        eTextStyle["subtitle"] = "subtitle";
        eTextStyle["emphasis"] = "emphasis";
        eTextStyle["strong"] = "strong";
    })(exports.eTextStyle || (exports.eTextStyle = {}));
    (function (eTextColor) {
        eTextColor["normal"] = "normal";
        eTextColor["header"] = "header";
        eTextColor["primary"] = "primary";
        eTextColor["accent"] = "accent";
        eTextColor["error"] = "error";
        eTextColor["success"] = "success";
    })(exports.eTextColor || (exports.eTextColor = {}));
    (function (eTextWeight) {
        eTextWeight["f100"] = "f100";
        eTextWeight["f200"] = "f200";
        eTextWeight["f300"] = "f300";
        eTextWeight["f400"] = "f400";
        eTextWeight["f500"] = "f500";
        eTextWeight["f600"] = "f600";
        eTextWeight["f700"] = "f700";
        eTextWeight["f800"] = "f800";
        eTextWeight["f900"] = "f900";
    })(exports.eTextWeight || (exports.eTextWeight = {}));
    (function (eDragMode) {
        eDragMode["plane"] = "plane";
        eDragMode["free"] = "free";
        eDragMode["surface"] = "surface";
    })(exports.eDragMode || (exports.eDragMode = {}));
    (function (eConnectionMode) {
        eConnectionMode["none"] = "none";
        eConnectionMode["world"] = "world";
        eConnectionMode["screen"] = "screen";
    })(exports.eConnectionMode || (exports.eConnectionMode = {}));
    (function (eToolbarPosition) {
        eToolbarPosition["hidden"] = "hidden";
        eToolbarPosition["topLeft"] = "topLeft";
        eToolbarPosition["topRight"] = "topRight";
        eToolbarPosition["bottomLeft"] = "bottomLeft";
        eToolbarPosition["bottomRight"] = "bottomRight";
    })(exports.eToolbarPosition || (exports.eToolbarPosition = {}));
    (function (eContainerItemLayout) {
        eContainerItemLayout["horizontal"] = "horizontal";
        eContainerItemLayout["vertical"] = "vertical";
        eContainerItemLayout["absolute"] = "absolute";
    })(exports.eContainerItemLayout || (exports.eContainerItemLayout = {}));
    (function (eContainerChildAlignment) {
        eContainerChildAlignment["inherit"] = "inherit";
        eContainerChildAlignment["stretch"] = "stretch";
        eContainerChildAlignment["start"] = "start";
        eContainerChildAlignment["center"] = "center";
        eContainerChildAlignment["end"] = "end";
    })(exports.eContainerChildAlignment || (exports.eContainerChildAlignment = {}));
    (function (eContainerItemAlignment) {
        eContainerItemAlignment["stretch"] = "stretch";
        eContainerItemAlignment["start"] = "start";
        eContainerItemAlignment["center"] = "center";
        eContainerItemAlignment["end"] = "end";
    })(exports.eContainerItemAlignment || (exports.eContainerItemAlignment = {}));
    (function (eContainerItemJustify) {
        eContainerItemJustify["start"] = "start";
        eContainerItemJustify["center"] = "center";
        eContainerItemJustify["end"] = "end";
    })(exports.eContainerItemJustify || (exports.eContainerItemJustify = {}));
    (function (eColorShade) {
        eColorShade["default"] = "default";
        eColorShade["lighter1"] = "lighter1";
        eColorShade["lighter2"] = "lighter2";
        eColorShade["lighter3"] = "lighter3";
        eColorShade["lighter4"] = "lighter4";
        eColorShade["darker1"] = "darker1";
        eColorShade["darker2"] = "darker2";
        eColorShade["darker3"] = "darker3";
        eColorShade["darker4"] = "darker4";
    })(exports.eColorShade || (exports.eColorShade = {}));
    (function (eBackgroundColor) {
        eBackgroundColor["background"] = "background";
        eBackgroundColor["primary"] = "primary";
        eBackgroundColor["accent"] = "accent";
        eBackgroundColor["warning"] = "warning";
        eBackgroundColor["success"] = "success";
        eBackgroundColor["input"] = "input";
        eBackgroundColor["header"] = "header";
    })(exports.eBackgroundColor || (exports.eBackgroundColor = {}));
    (function (eElevation) {
        eElevation["none"] = "none";
        eElevation["z1"] = "z1";
        eElevation["z2"] = "z2";
        eElevation["z3"] = "z3";
        eElevation["z4"] = "z4";
        eElevation["z5"] = "z5";
        eElevation["z6"] = "z6";
        eElevation["z7"] = "z7";
        eElevation["z8"] = "z8";
    })(exports.eElevation || (exports.eElevation = {}));
    (function (eSliderValueVisibility) {
        eSliderValueVisibility["visible"] = "visible";
        eSliderValueVisibility["sliding"] = "sliding";
        eSliderValueVisibility["hidden"] = "hidden";
    })(exports.eSliderValueVisibility || (exports.eSliderValueVisibility = {}));
    (function (eOrientation) {
        eOrientation["horizontal"] = "horizontal";
        eOrientation["vertical"] = "vertical";
    })(exports.eOrientation || (exports.eOrientation = {}));
    (function (eTabSelectionStyle) {
        eTabSelectionStyle["line"] = "line";
        eTabSelectionStyle["background"] = "background";
    })(exports.eTabSelectionStyle || (exports.eTabSelectionStyle = {}));
    (function (eSelectionLineColor) {
        eSelectionLineColor["accent"] = "accent";
        eSelectionLineColor["contrast"] = "contrast";
        eSelectionLineColor["primary"] = "primary";
        eSelectionLineColor["header"] = "header";
    })(exports.eSelectionLineColor || (exports.eSelectionLineColor = {}));
    (function (eTabWidth) {
        eTabWidth["custom"] = "custom";
        eTabWidth["fill"] = "fill";
        eTabWidth["auto"] = "auto";
    })(exports.eTabWidth || (exports.eTabWidth = {}));
    (function (eScroll) {
        eScroll["none"] = "none";
        eScroll["auto"] = "auto";
        eScroll["x"] = "x";
        eScroll["y"] = "y";
    })(exports.eScroll || (exports.eScroll = {}));
    (function (eAdminIndexOperation) {
        eAdminIndexOperation["updateQuotes"] = "updateQuotes";
    })(exports.eAdminIndexOperation || (exports.eAdminIndexOperation = {}));
    (function (eAttributeType) {
        eAttributeType["text"] = "text";
        eAttributeType["number"] = "number";
        eAttributeType["boolean"] = "boolean";
        eAttributeType["date"] = "date";
    })(exports.eAttributeType || (exports.eAttributeType = {}));
    (function (eAttributeControl) {
        eAttributeControl["select"] = "select";
        eAttributeControl["imageSelect"] = "imageSelect";
        eAttributeControl["multiSelect"] = "multiSelect";
        eAttributeControl["imageMultiSelect"] = "imageMultiSelect";
        eAttributeControl["checkbox"] = "checkbox";
    })(exports.eAttributeControl || (exports.eAttributeControl = {}));
    (function (eNestedSetDisplay) {
        eNestedSetDisplay["container"] = "container";
        eNestedSetDisplay["group"] = "group";
        eNestedSetDisplay["tabControl"] = "tabControl";
        eNestedSetDisplay["accordion"] = "accordion";
    })(exports.eNestedSetDisplay || (exports.eNestedSetDisplay = {}));
    (function (eUserLicenseType) {
        eUserLicenseType["external"] = "external";
        eUserLicenseType["internal"] = "internal";
        eUserLicenseType["channel"] = "channel";
    })(exports.eUserLicenseType || (exports.eUserLicenseType = {}));
    (function (eJobStatus) {
        eJobStatus["none"] = "none";
        eJobStatus["waiting"] = "waiting";
        eJobStatus["queued"] = "queued";
        eJobStatus["working"] = "working";
        eJobStatus["complete"] = "complete";
        eJobStatus["failed"] = "failed";
    })(exports.eJobStatus || (exports.eJobStatus = {}));
    (function (eJobType) {
        eJobType["build"] = "build";
        eJobType["render"] = "render";
        eJobType["notification"] = "notification";
        eJobType["upsertProductsToSfdc"] = "upsertProductsToSfdc";
        eJobType["pullSfdcProducts"] = "pullSfdcProducts";
        eJobType["submitFromSfdcCpq"] = "submitFromSfdcCpq";
        eJobType["completeBuildState"] = "completeBuildState";
        eJobType["cleanDb"] = "cleanDb";
        eJobType["deploymentCompare"] = "deploymentCompare";
        eJobType["deployment"] = "deployment";
        eJobType["sceneImport"] = "sceneImport";
        eJobType["sceneExport"] = "sceneExport";
        eJobType["sceneConvert"] = "sceneConvert";
        eJobType["completeQuoteProductBuild"] = "completeQuoteProductBuild";
        eJobType["configuratorExport"] = "configuratorExport";
        eJobType["configuratorImport"] = "configuratorImport";
    })(exports.eJobType || (exports.eJobType = {}));
    (function (eValidationSource) {
        eValidationSource["snap"] = "snap";
        eValidationSource["configurator"] = "configurator";
        eValidationSource["scene"] = "scene";
    })(exports.eValidationSource || (exports.eValidationSource = {}));
    (function (eBuildStatus) {
        eBuildStatus["none"] = "none";
        eBuildStatus["generating"] = "generating";
        eBuildStatus["complete"] = "complete";
        eBuildStatus["failed"] = "failed";
    })(exports.eBuildStatus || (exports.eBuildStatus = {}));

    var _allEnums = /*#__PURE__*/Object.freeze({
        __proto__: null,
        get ePerm () { return exports.ePerm; },
        get eNotificationType () { return exports.eNotificationType; },
        get eNotificationSetting () { return exports.eNotificationSetting; },
        get eEnvironment () { return exports.eEnvironment; },
        get eWorkflowAction () { return exports.eWorkflowAction; },
        get eViewPermission () { return exports.eViewPermission; },
        get eOutputType () { return exports.eOutputType; },
        get eOutputFieldType () { return exports.eOutputFieldType; },
        get eExportType () { return exports.eExportType; },
        get eFileSource () { return exports.eFileSource; },
        get eFileStatus () { return exports.eFileStatus; },
        get eLogType () { return exports.eLogType; },
        get eLogSource () { return exports.eLogSource; },
        get eFieldType () { return exports.eFieldType; },
        get eFieldControl () { return exports.eFieldControl; },
        get eSort () { return exports.eSort; },
        get eProductSortBy () { return exports.eProductSortBy; },
        get eFormatType () { return exports.eFormatType; },
        get eRuleType () { return exports.eRuleType; },
        get eClusterEnv () { return exports.eClusterEnv; },
        get eConfiguratorLayout () { return exports.eConfiguratorLayout; },
        get eConfiguratorTabStyle () { return exports.eConfiguratorTabStyle; },
        get eDeploymentStatus () { return exports.eDeploymentStatus; },
        get eDifference () { return exports.eDifference; },
        get eViewerMode () { return exports.eViewerMode; },
        get ePosition () { return exports.ePosition; },
        get eTabPosition () { return exports.eTabPosition; },
        get eColumnType () { return exports.eColumnType; },
        get eSelectSource () { return exports.eSelectSource; },
        get eAutoCompleteSource () { return exports.eAutoCompleteSource; },
        get eOptionFilterSource () { return exports.eOptionFilterSource; },
        get eDynamicSource () { return exports.eDynamicSource; },
        get eQueryMode () { return exports.eQueryMode; },
        get eConfiguratorImageSource () { return exports.eConfiguratorImageSource; },
        get ePricingFillFromSource () { return exports.ePricingFillFromSource; },
        get eSingleOptionBehavior () { return exports.eSingleOptionBehavior; },
        get eFilterSource () { return exports.eFilterSource; },
        get eFilterType () { return exports.eFilterType; },
        get eFilterControl () { return exports.eFilterControl; },
        get eLogSetting () { return exports.eLogSetting; },
        get eHotspotSource () { return exports.eHotspotSource; },
        get eHotspotAttach () { return exports.eHotspotAttach; },
        get eLayerLineWeight () { return exports.eLayerLineWeight; },
        get eHotspotPosition () { return exports.eHotspotPosition; },
        get eAnimationEasing () { return exports.eAnimationEasing; },
        get eQueueMessageType () { return exports.eQueueMessageType; },
        get eStateType () { return exports.eStateType; },
        get eDescriptorType () { return exports.eDescriptorType; },
        get eWorkflowBuildType () { return exports.eWorkflowBuildType; },
        get eWorkflowPermissionType () { return exports.eWorkflowPermissionType; },
        get eAdminNotificationTarget () { return exports.eAdminNotificationTarget; },
        get eConfiguratorEntityType () { return exports.eConfiguratorEntityType; },
        get eHotspotShape () { return exports.eHotspotShape; },
        get eValidationType () { return exports.eValidationType; },
        get eIconStyle () { return exports.eIconStyle; },
        get eOracleCpqOperation () { return exports.eOracleCpqOperation; },
        get eOptionLayout () { return exports.eOptionLayout; },
        get eButtonStyle () { return exports.eButtonStyle; },
        get eTableExternalSource () { return exports.eTableExternalSource; },
        get eSkin () { return exports.eSkin; },
        get eGridColumnWidth () { return exports.eGridColumnWidth; },
        get eRelativeSize () { return exports.eRelativeSize; },
        get eVerticalAlignment () { return exports.eVerticalAlignment; },
        get eHorizontalAlignment () { return exports.eHorizontalAlignment; },
        get ePadding () { return exports.ePadding; },
        get eMaskType () { return exports.eMaskType; },
        get eValidationTiming () { return exports.eValidationTiming; },
        get eTextStyle () { return exports.eTextStyle; },
        get eTextColor () { return exports.eTextColor; },
        get eTextWeight () { return exports.eTextWeight; },
        get eDragMode () { return exports.eDragMode; },
        get eConnectionMode () { return exports.eConnectionMode; },
        get eToolbarPosition () { return exports.eToolbarPosition; },
        get eContainerItemLayout () { return exports.eContainerItemLayout; },
        get eContainerChildAlignment () { return exports.eContainerChildAlignment; },
        get eContainerItemAlignment () { return exports.eContainerItemAlignment; },
        get eContainerItemJustify () { return exports.eContainerItemJustify; },
        get eColorShade () { return exports.eColorShade; },
        get eBackgroundColor () { return exports.eBackgroundColor; },
        get eElevation () { return exports.eElevation; },
        get eSliderValueVisibility () { return exports.eSliderValueVisibility; },
        get eOrientation () { return exports.eOrientation; },
        get eTabSelectionStyle () { return exports.eTabSelectionStyle; },
        get eSelectionLineColor () { return exports.eSelectionLineColor; },
        get eTabWidth () { return exports.eTabWidth; },
        get eScroll () { return exports.eScroll; },
        get eAdminIndexOperation () { return exports.eAdminIndexOperation; },
        get eAttributeType () { return exports.eAttributeType; },
        get eAttributeControl () { return exports.eAttributeControl; },
        get eNestedSetDisplay () { return exports.eNestedSetDisplay; },
        get eUserLicenseType () { return exports.eUserLicenseType; },
        get eJobStatus () { return exports.eJobStatus; },
        get eJobType () { return exports.eJobType; },
        get eValidationSource () { return exports.eValidationSource; },
        get eBuildStatus () { return exports.eBuildStatus; }
    });

    var AllEnums = _allEnums;

    (function (eViewType) {
        eViewType["view"] = "view";
        eViewType["edit"] = "edit";
        eViewType["new"] = "new";
    })(exports.eViewType || (exports.eViewType = {}));
    (function (eAdminType) {
        eAdminType["configurator"] = "configurator";
        eAdminType["quoteOutput"] = "quoteOutput";
        eAdminType["scene"] = "scene";
        eAdminType["productRule"] = "productRule";
        eAdminType["quoteHeader"] = "quoteHeader";
        eAdminType["layout"] = "layout";
    })(exports.eAdminType || (exports.eAdminType = {}));
    (function (eAlertType) {
        eAlertType["info"] = "info";
        eAlertType["error"] = "error";
        eAlertType["success"] = "success";
    })(exports.eAlertType || (exports.eAlertType = {}));
    (function (eColorFormat) {
        eColorFormat["kbcolor"] = "kbcolor";
        eColorFormat["hex"] = "hex";
        eColorFormat["hsl"] = "hsl";
        eColorFormat["hslString"] = "hslString";
        eColorFormat["hsv"] = "hsv";
        eColorFormat["hsvString"] = "hsvString";
        eColorFormat["rgb"] = "rgb";
        eColorFormat["rgbString"] = "rgbString";
    })(exports.eColorFormat || (exports.eColorFormat = {}));
    (function (eColorOperation) {
        eColorOperation["lighten"] = "lighten";
        eColorOperation["brighten"] = "brighten";
        eColorOperation["darken"] = "darken";
        eColorOperation["saturate"] = "saturate";
        eColorOperation["desaturate"] = "desaturate";
    })(exports.eColorOperation || (exports.eColorOperation = {}));

    function Kbo(token) {
        return function (target) {
            ConfiguratorDI.register({ token: token, class: target });
        };
    }
    function KboOutputField(token, outputFieldType) {
        return function (target) {
            ConfiguratorDI.register({ token: token, class: target, outputFieldType: outputFieldType });
        };
    }
    function KboOutput(token) {
        var outputTypes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            outputTypes[_i - 1] = arguments[_i];
        }
        return function (target) {
            ConfiguratorDI.register({ token: token, class: target, outputTypes: outputTypes });
        };
    }
    /**
     * Applied to a getter or setter property, will make it enumerable
     */
    function Enumerable() {
        return function (target, propertyKey, descriptor) {
            descriptor.enumerable = true;
        };
    }
    var ConfiguratorDI = /** @class */ (function () {
        function ConfiguratorDI() {
        }
        ConfiguratorDI.register = function (args) {
            if (ConfiguratorDI.db.hasOwnProperty(args.token.key)) {
                // Phase 2 (Vue migration): when AngularHost (Vue) mounts/unmounts,
                // angular re-bootstraps and oc.lazyLoad re-fetches admin.js. The
                // IIFE re-evaluates and @Kbo* decorators re-call this method. This
                // static `db` is class-level and survives across bootstraps, so
                // the second call would throw without this guard. Keep the
                // existing entry (its `class` reference is still valid — classes
                // defined in admin.js's IIFE close over app-level globals which
                // don't change between evals), and discard the new class object.
                // Skipping the prototype mutations is intentional: the new class
                // is immediately out of scope after the decorator returns, so
                // stamping $type / type on its prototype would just be writing
                // to garbage. Consumers always `new ikbo.class(...)` from
                // ConfiguratorDI.db, which holds the first-registered class.
                //
                // Parallels the @NgService / DI.register idempotency in
                // Client/app/di/decorators.ts. See that file's comment for the
                // full rationale.
                return;
            }
            ConfiguratorDI.db[args.token.key] = args;
            args.class.prototype.$type = args.token.key;
            if (args.outputFieldType)
                args.class.prototype.type = args.outputFieldType;
            if (args.outputTypes && args.outputTypes.length == 1)
                args.class.prototype.type = args.outputTypes[0];
        };
        ConfiguratorDI.get = function (token) {
            return ConfiguratorDI.db[token.key];
        };
        /**
         * Checks if the instance of a class given is an instance of the class represented by it's
         * injectable class key.  If the instance is an instance of a class that was not
         * decorated, or if the class represented by the key was not decorated, then this will
         * return false!
         * @param instance An instance of a class that was decorated
         * @param classKey String key of the class you want to see if the instance is an instance of
         */
        ConfiguratorDI.instanceOf = function (instance, token) {
            // find the injectable
            var inj = this.get(token);
            return inj ? instance instanceof inj.class : false;
        };
        ConfiguratorDI.getNewOutputField = function (fieldType, kom, args) {
            var ikbo = Object.values(ConfiguratorDI.db).find(function (k) { return k.outputFieldType == fieldType; });
            if (!ikbo)
                throw new Error("Cannot not find output field type '".concat(fieldType));
            var f = new ikbo.class(kom);
            if (args) {
                kom.recurse(args, f);
            }
            return f;
        };
        ConfiguratorDI.getNewOutput = function (outputType, kom, args) {
            var ikbo = Object.values(ConfiguratorDI.db).find(function (k) { return k.outputTypes && k.outputTypes.contains(outputType); });
            if (!ikbo)
                throw new Error("Cannot not find output type '".concat(outputType));
            var o = new ikbo.class(kom);
            if (!o.type) {
                o.type = outputType;
            }
            if (args) {
                kom.recurse(args, o);
            }
            o.name = (args && args.name) ? args.name : loc["eoutputtype_" + outputType.toLowerCase() + "_title"];
            return o;
        };
        ConfiguratorDI.getOutputFieldClassName = function (outputFieldType) {
            var ikbo = Object.values(ConfiguratorDI.db).find(function (k) { return k.outputFieldType == outputFieldType; });
            return ikbo.token.key;
        };
        ConfiguratorDI.getOutputClassName = function (outputType) {
            var ikbo = Object.values(ConfiguratorDI.db).find(function (k) { return k.outputTypes && k.outputTypes.contains(outputType); });
            return ikbo.token.key;
        };
        ConfiguratorDI.db = {};
        return ConfiguratorDI;
    }());

    // tslint:disable:variable-name
    var CToken = /** @class */ (function () {
        function CToken(key) {
            this.key = key;
        }
        CToken.withKey = function (key) {
            var token = this[key];
            if (!token)
                throw new Error("Could not find token for key '".concat(key, "'"));
            return token;
        };
        CToken.hasKey = function (key) {
            return this[key] != null;
        };
        // configurator models
        CToken.Accordion = new CToken("Accordion");
        CToken.ActionBar = new CToken("ActionBar");
        CToken.Build = new CToken("Build");
        CToken.Button = new CToken("Button");
        CToken.Configurator = new CToken("Configurator");
        CToken.ConfiguratorAction = new CToken("ConfiguratorAction");
        CToken.ConfiguratorFunction = new CToken("ConfiguratorFunction");
        CToken.Container = new CToken("Container");
        CToken.DropdownButton = new CToken("DropdownButton");
        CToken.Expander = new CToken("Expander");
        CToken.Export = new CToken("Export");
        CToken.Field = new CToken("Field");
        CToken.GridColumn = new CToken("GridColumn");
        CToken.GridRow = new CToken("GridRow");
        CToken.Group = new CToken("Group");
        CToken.Html = new CToken("Html");
        CToken.SvgViewer = new CToken("SvgViewer");
        CToken.Hotspot = new CToken("Hotspot");
        CToken.KbObject = new CToken("KbObject");
        CToken.LayoutConfig = new CToken("LayoutConfig");
        CToken.LayoutContent = new CToken("LayoutContent");
        CToken.Media = new CToken("Media");
        CToken.NestedElement = new CToken("NestedElement");
        CToken.NestedSet = new CToken("NestedSet");
        CToken.OptionFilter = new CToken("OptionFilter");
        CToken.Option = new CToken("Option");
        CToken.OverlayPopup = new CToken("OverlayPopup");
        CToken.OverlayPopupControl = new CToken("OverlayPopupControl");
        CToken.Page = new CToken("Page");
        CToken.PageControl = new CToken("PageControl");
        CToken.PageNavigator = new CToken("PageNavigator");
        CToken.PageTabs = new CToken("PageTabs");
        CToken.Popup = new CToken("Popup");
        CToken.PriceWidget = new CToken("PriceWidget");
        CToken.PricingRuleContainer = new CToken("PricingRuleContainer");
        CToken.ProductRuleContainer = new CToken("ProductRuleContainer");
        CToken.ReferencedConfigurator = new CToken("ReferencedConfigurator");
        CToken.RenderPassExport = new CToken("RenderPassExport");
        CToken.RuleContainer = new CToken("RuleContainer");
        CToken.Rule = new CToken("Rule");
        CToken.Tab = new CToken("Tab");
        CToken.TabControl = new CToken("TabControl");
        CToken.Text = new CToken("Text");
        CToken.Toolbar = new CToken("Toolbar");
        CToken.Viewer = new CToken("Viewer");
        // outputs
        CToken.BomOutput = new CToken("BomOutput");
        CToken.CadDrawingOutput = new CToken("CadDrawingOutput");
        CToken.CadOutput = new CToken("CadOutput");
        CToken.ExcelOutput = new CToken("ExcelOutput");
        CToken.FileOutput = new CToken("FileOutput");
        CToken.ImageOutput = new CToken("ImageOutput");
        CToken.Output = new CToken("Output");
        CToken.PdfOutput = new CToken("PdfOutput");
        CToken.SceneRenderOutput = new CToken("SceneRenderOutput");
        CToken.WordOutput = new CToken("WordOutput");
        CToken.ZipOutput = new CToken("ZipOutput");
        CToken.SvgOutput = new CToken("SvgOutput");
        CToken.TextOutput = new CToken("TextOutput");
        CToken.GlbOutput = new CToken("GlbOutput");
        CToken.FbxOutput = new CToken("FbxOutput");
        // output fields
        CToken.ExcelCellField = new CToken("ExcelCellField");
        CToken.ExcelChartField = new CToken("ExcelChartField");
        CToken.ExcelImageField = new CToken("ExcelImageField");
        CToken.ExcelSheetField = new CToken("ExcelSheetField");
        CToken.ExcelTableField = new CToken("ExcelTableField");
        CToken.OutputField = new CToken("OutputField");
        CToken.PdfSectionField = new CToken("PdfSectionField");
        CToken.WordContainerField = new CToken("WordContainerField");
        CToken.WordImageField = new CToken("WordImageField");
        CToken.WordListField = new CToken("WordListField");
        CToken.WordTextField = new CToken("WordTextField");
        CToken.ZipSectionField = new CToken("ZipSectionField");
        // cad output fields
        CToken.CadAnnotationField = new CToken("CadAnnotationField");
        CToken.CadBlockArrayField = new CToken("CadBlockArrayField");
        CToken.CadBlockField = new CToken("CadBlockField");
        CToken.CadComponentField = new CToken("CadComponentField");
        CToken.CadCustomPropertyField = new CToken("CadCustomPropertyField");
        CToken.CadDimensionField = new CToken("CadDimensionField");
        CToken.CadDrawingAnnotationField = new CToken("CadDrawingAnnotationField");
        CToken.CadDrawingDimensionField = new CToken("CadDrawingDimensionField");
        CToken.CadDrawingSheetField = new CToken("CadDrawingSheetField");
        CToken.CadDrawingViewField = new CToken("CadDrawingViewField");
        CToken.CadDynamicComponentField = new CToken("CadDynamicComponentField");
        CToken.CadDynamicDrawingAnnotationField = new CToken("CadDynamicDrawingAnnotationField");
        CToken.CadDynamicDrawingDimensionField = new CToken("CadDynamicDrawingDimensionField");
        CToken.CadFeatureField = new CToken("CadFeatureField");
        CToken.CadLayerField = new CToken("CadLayerField");
        CToken.CadLibFeatureField = new CToken("CadLibFeatureField");
        CToken.CadParameterField = new CToken("CadParameterField");
        CToken.CadReplaceComponentField = new CToken("CadReplaceComponentField");
        CToken.CadRepresentationField = new CToken("CadRepresentationField");
        CToken.CadScaleFeatureField = new CToken("CadScaleFeatureField");
        CToken.CadTextField = new CToken("CadTextField");
        // mates
        CToken.CadAngleMate = new CToken("CadAngleMate");
        CToken.CadCoincidentMate = new CToken("CadCoincidentMate");
        CToken.CadCoordinateSystemMate = new CToken("CadCoordinateSystemMate");
        CToken.CadDistanceMate = new CToken("CadDistanceMate");
        CToken.CadLibDimension = new CToken("CadLibDimension");
        CToken.CadLibReference = new CToken("CadLibReference");
        CToken.CadPositionConstraint = new CToken("CadPositionConstraint");
        CToken.Constraint = new CToken("Constraint");
        CToken.Mate = new CToken("Mate");
        // manufacture
        CToken.PartRev = new CToken("PartRev");
        CToken.PartMaterial = new CToken("PartMaterial");
        CToken.PartOperation = new CToken("PartOperation");
        CToken.PartOperationDetail = new CToken("PartOperationDetail");
        CToken.MethodOfManufacture = new CToken("MethodOfManufacture");
        CToken.BistrackMethodOfManufacture = new CToken("BistrackMethodOfManufacture");
        CToken.BistrackPartRev = new CToken("BistrackPartRev");
        return CToken;
    }());

    var defaults = {
        Accordion: {
            visible: true,
            left: "auto",
            top: "auto",
            right: "auto",
            bottom: "auto",
            width: "auto",
            height: "auto",
            opacity: 1.0,
            order: 0,
            relativeSize: "auto",
            alignment: "inherit",
        },
        ActionBar: {
            buttonStyle: "link",
            buttonColor: "background",
            iconSize: 24,
            visible: true,
            left: "auto",
            top: "auto",
            right: "auto",
            bottom: "auto",
            width: "auto",
            height: "auto",
            opacity: 1.0,
            order: 0,
            relativeSize: "auto",
            alignment: "inherit",
        },
        Build: {
            idBuildType: 0,
            idQueue: 1,
            cloudBuild: true,
        },
        Button: {
            ruleType: "button",
            enabled: true,
            iconStyle: "none",
            textPosition: "right",
            buttonStyle: "normal",
            color: "background",
            imageHeight: 30,
            imageWidth: 30,
            showLabel: true,
            fullWidth: false,
            relativeWidth: "auto",
            useZeroPadding: false,
            visible: true,
            left: "auto",
            top: "auto",
            right: "auto",
            bottom: "auto",
            width: "auto",
            height: "auto",
            opacity: 1.0,
            order: 0,
            relativeSize: "auto",
            alignment: "inherit",
        },
        Configurator: {
            entityType: "product",
            unitOfMeasure: "ea.",
            price: 0.0,
            cost: 0.0,
            maxDiscountPercentage: 0.0,
            maxQty: 0.0,
            minQty: 1.0,
            allowFractionalQty: false,
            score: 0,
            usePartSelector: false,
            active: true,
            inheritCategoryPermissions: false,
            v: 0,
            snapVersion: 0,
            visible: true,
            alwaysChild: false,
            validationTiming: "always",
            allowSaveWithErrors: true,
            idLayout: -1,
            useMobileDropdowns: true,
            headerColor: "header",
            showMoveAnimation: false,
            viewerMode: "none",
            clearMemoryWhenSwitchingScenes: false,
            sceneToolbarPosition: "bottomRight",
            nestedSceneClickToSelect: true,
            runQuoteRuleUponInsert: false,
            hideQuoteHeaderBasicTab: false,
            quoteHeaderBasicTabIndex: 0,
            imageSource: "none",
            allowUserToRemove: false,
            bubbleRules: false,
            hasPricingRule: false,
            hasQuoteRule: false,
            autoValidation: true,
            addAsQuoteProduct: false,
            kineticViewOnly: false,
            convertToKb3d: false,
            mouseOverEffects: true,
            mouseOverColor: "#131313",
            prefetchImages: true,
            allowOrbit: true,
            allowPan: true,
            allowZoom: true,
            constrainCameraToRadius: false,
            cameraRadius: 0.0,
            isPlaceholder: false,
            scroll: "none",
            itemLayout: "horizontal",
            itemAlignment: "stretch",
            itemJustify: "start",
            spaceBetweenItems: "none",
            padding: "none",
            collapseOnMobile: false,
            backgroundColor: "background",
            backgroundShade: "default",
            backgroundOpacity: 1.0,
            elevation: "none",
            relativeSize: "x1",
            left: "auto",
            top: "auto",
            right: "auto",
            bottom: "auto",
            width: "auto",
            height: "auto",
            opacity: 1.0,
            order: 0,
            alignment: "inherit",
        },
        ConfiguratorAction: {
            iconStyle: "icon",
            textPosition: "right",
            visible: true,
            enabled: true,
            ruleType: "action",
            showLabel: true,
            relativeSize: "auto",
        },
        ConfiguratorFunction: {
            ruleType: "action",
        },
        Container: {
            isPlaceholder: false,
            scroll: "none",
            itemLayout: "horizontal",
            itemAlignment: "stretch",
            itemJustify: "start",
            spaceBetweenItems: "none",
            padding: "none",
            collapseOnMobile: false,
            backgroundColor: "background",
            backgroundShade: "default",
            backgroundOpacity: 1.0,
            elevation: "none",
            relativeSize: "x1",
            visible: true,
            left: "auto",
            top: "auto",
            right: "auto",
            bottom: "auto",
            width: "auto",
            height: "auto",
            opacity: 1.0,
            order: 0,
            alignment: "inherit",
        },
        DropdownButton: {
            ruleType: "button",
            enabled: true,
            iconStyle: "none",
            textPosition: "right",
            buttonStyle: "normal",
            color: "background",
            imageHeight: 30,
            imageWidth: 30,
            showLabel: true,
            fullWidth: false,
            relativeWidth: "auto",
            useZeroPadding: false,
            visible: true,
            left: "auto",
            top: "auto",
            right: "auto",
            bottom: "auto",
            width: "auto",
            height: "auto",
            opacity: 1.0,
            order: 0,
            relativeSize: "auto",
            alignment: "inherit",
        },
        Expander: {
            expanded: true,
            iconStyle: "icon",
            visible: true,
            left: "auto",
            top: "auto",
            right: "auto",
            bottom: "auto",
            width: "auto",
            height: "auto",
            opacity: 1.0,
            order: 0,
            relativeSize: "auto",
            alignment: "inherit",
        },
        Field: {
            ruleType: "field",
            enabled: true,
            required: false,
            type: "text",
            control: "none",
            searchable: false,
            showLabel: true,
            mask: "none",
            precision: 2,
            constrainValue: false,
            min: 0,
            max: 0,
            step: 0,
            sliderAllowDirectEdit: false,
            sliderValueVisibility: "visible",
            dateFormat: "Y-m-d",
            format: "none",
            formatMinPrecision: 0,
            formatCurrency: "USD",
            formatDecimalSeparator: ".",
            formatThousandsSeparator: ",",
            selectSource: "simple",
            autoCompleteSource: "table",
            useFullTextSearch: false,
            constrainToSource: true,
            sort: "none",
            imageHeight: 30,
            imageWidth: 30,
            imageOnly: false,
            optionLayout: "wrap",
            dropdownOptionLayout: "vertical",
            enableSelectedImages: false,
            linkToDynamicAttribute: false,
            useZeroPadding: false,
            hasBeenTouched: false,
            uploadToScene: false,
            convertUploadedSceneImageToMesh: false,
            convertUploadPdfToImage: false,
            uploadImageThreshold: 0.5,
            iconStyle: "icon",
            buttonStyle: "normal",
            visible: true,
            left: "auto",
            top: "auto",
            right: "auto",
            bottom: "auto",
            width: "auto",
            height: "auto",
            opacity: 1.0,
            order: 0,
            relativeSize: "auto",
            alignment: "inherit",
        },
        GridColumn: {
            relativeWidth: "x1",
            verticalAlignment: "stretch",
            visible: true,
            left: "auto",
            top: "auto",
            right: "auto",
            bottom: "auto",
            width: "auto",
            height: "auto",
            opacity: 1.0,
            order: 0,
            relativeSize: "auto",
            alignment: "inherit",
        },
        GridRow: {
            verticalAlignment: "stretch",
            horizontalAlignment: "left",
            spaceBetweenItems: "medium",
            collapseOnMobile: true,
            visible: true,
            left: "auto",
            top: "auto",
            right: "auto",
            bottom: "auto",
            width: "auto",
            height: "auto",
            opacity: 1.0,
            order: 0,
            relativeSize: "auto",
            alignment: "inherit",
        },
        Group: {
            enabled: true,
            showLabel: true,
            visible: true,
            left: "auto",
            top: "auto",
            right: "auto",
            bottom: "auto",
            width: "auto",
            height: "auto",
            opacity: 1.0,
            order: 0,
            relativeSize: "auto",
            alignment: "inherit",
        },
        Hotspot: {
            target: true,
            popupPosition: "target",
            popupAttach: "center",
            keepPopupInViewer: true,
            popupOffsetX: 0,
            popupOffsetY: 0,
            popupTop: "auto",
            popupLeft: "auto",
            popupBottom: "auto",
            popupRight: "auto",
            popupWidth: "auto",
            popupHeight: "auto",
            visible: true,
            open: false,
            alpha: 1,
            allowClose: true,
            showPopupHeader: true,
            showPopupBackground: true,
            showTooltip: true,
            targetColor: "#0A6080",
            targetShape: "circle",
            targetSize: 18,
            source: "text",
            animationDuration: 1000,
            animationEasing: "easeOutCirc",
        },
        Html: {
            visible: true,
            left: "auto",
            top: "auto",
            right: "auto",
            bottom: "auto",
            width: "auto",
            height: "auto",
            opacity: 1.0,
            order: 0,
            relativeSize: "auto",
            alignment: "inherit",
        },
        KbObject: {},
        LayoutConfig: {
            autoValidation: true,
            useMobileDropdowns: true,
            isPlaceholder: false,
            scroll: "none",
            itemLayout: "horizontal",
            itemAlignment: "stretch",
            itemJustify: "start",
            spaceBetweenItems: "none",
            padding: "none",
            collapseOnMobile: false,
            backgroundColor: "background",
            backgroundShade: "default",
            backgroundOpacity: 1.0,
            elevation: "none",
            relativeSize: "x1",
            visible: true,
            left: "auto",
            top: "auto",
            right: "auto",
            bottom: "auto",
            width: "auto",
            height: "auto",
            opacity: 1.0,
            order: 0,
            alignment: "inherit",
        },
        LayoutContent: {
            visible: true,
            left: "auto",
            top: "auto",
            right: "auto",
            bottom: "auto",
            width: "auto",
            height: "auto",
            opacity: 1.0,
            order: 0,
            relativeSize: "auto",
            alignment: "inherit",
        },
        Media: {
            maxHeight: 256,
            maxWidth: 256,
            visible: true,
            left: "auto",
            top: "auto",
            right: "auto",
            bottom: "auto",
            width: "auto",
            height: "auto",
            opacity: 1.0,
            order: 0,
            relativeSize: "auto",
            alignment: "inherit",
        },
        MethodOfManufacture: {},
        MethodOfManufactureRuleContainer: {},
        NestedElement: {
            visible: true,
            left: "auto",
            top: "auto",
            right: "auto",
            bottom: "auto",
            width: "auto",
            height: "auto",
            opacity: 1.0,
            order: 0,
            relativeSize: "auto",
            alignment: "inherit",
        },
        NestedSet: {
            display: "accordion",
            autoNavigateToElement: true,
            visible: true,
            left: "auto",
            top: "auto",
            right: "auto",
            bottom: "auto",
            width: "auto",
            height: "auto",
            opacity: 1.0,
            order: 0,
            relativeSize: "auto",
            alignment: "inherit",
        },
        OptionFilter: {
            ruleType: "optionFilter",
            source: "table",
            optimized: true,
            level: 0,
            queryMode: "table",
            singleOptionBehavior: "nothing",
            visibleToChildren: false,
        },
        BomMappingField: {},
        CadAnnotationField: {
            markedForDrawing: false,
        },
        CadBlockArrayField: {
            insertionPointX: 0,
            insertionPointY: 0,
            insertionPointZ: 0,
            xScale: 1,
            yScale: 1,
            zScale: 1,
            rotation: 0,
            flipX: false,
            flipY: false,
            numRows: 1,
            rowSpacing: 1,
            numColumns: 1,
            columnSpacing: 1,
        },
        CadBlockField: {
            insertionPointX: 0,
            insertionPointY: 0,
            insertionPointZ: 0,
            xScale: 1,
            yScale: 1,
            zScale: 1,
            rotation: 0,
            flipX: false,
            flipY: false,
        },
        CadComponentField: {
            suppressed: false,
            deleted: false,
        },
        CadCustomPropertyField: {},
        CadDimensionField: {
            markedForDrawing: false,
            value: 0,
        },
        CadDrawingAnnotationField: {
            x: 0,
            y: 0,
            visible: true,
        },
        CadDrawingDimensionField: {
            visible: true,
            x: 0,
            y: 0,
        },
        CadDrawingSheetField: {
            scaleNumerator: 1,
            scaleDenominator: 1,
            useCustomScale: false,
            deleted: false,
            scaleAnnoPosition: false,
            scaleAnnoTextHeight: false,
        },
        CadDrawingViewField: {
            useCustomScale: false,
            autoPositionAnnotations: false,
            scaleNumerator: 1,
            scaleDenominator: 1,
            autosize: false,
            autoDimension: false,
            autoBalloon: false,
            ignoreMultipleBalloons: true,
            deleted: false,
            suppressed: false,
            autoPosition: true,
            x: 0,
            y: 0,
            bomRenumber: false,
            allowMultipleBalloonsFirstLevelOnly: true,
            referencedPartFamily: "",
        },
        CadDynamicComponentField: {
            suppressed: false,
            fixed: false,
        },
        CadDynamicDrawingAnnotationField: {
            x: 0,
            y: 0,
        },
        CadDynamicDrawingDimensionField: {
            x: 0,
            y: 0,
            vertical: false,
            dimensionTextPrefix: false,
        },
        CadFeatureField: {
            suppressed: false,
            deleted: false,
        },
        CadLayerField: {
            lineType: "BYLAYER",
            toAdd: true,
            active: true,
            freeze: false,
            lineWeight: "lnWtByBlock",
            lock: false,
            plottable: true,
            visible: true,
        },
        CadLibFeatureField: {},
        CadParameterField: {
            value: 0,
        },
        CadReplaceComponentField: {},
        CadRepresentationField: {},
        CadScaleFeatureField: {
            x: 1,
            y: 1,
            z: 1,
            isUniform: true,
            scaleUniform: 1,
            suppressed: false,
            deleted: false,
        },
        CadTextField: {
            insertionPointX: 0,
            insertionPointY: 0,
            insertionPointZ: 0,
            height: 0,
        },
        CadAngleMate: {
            angle: 0,
            aligned: false,
            alignClosest: false,
        },
        CadCoincidentMate: {
            aligned: false,
            alignClosest: false,
        },
        CadCoordinateSystemMate: {
            aligned: false,
            alignClosest: false,
        },
        CadDistanceMate: {
            distance: 0,
            aligned: false,
            alignClosest: false,
        },
        CadLibDimension: {
            value: 0,
        },
        CadLibReference: {
            referenceType: "0",
        },
        CadPoint: {},
        CadPositionConstraint: {
            x: 0,
            y: 0,
            z: 0,
            xAngle: 0,
            yAngle: 0,
            zAngle: 0,
            aligned: false,
            alignClosest: false,
        },
        Constraint: {},
        Mate: {
            aligned: false,
            alignClosest: false,
        },
        ExcelCellField: {
            deleted: false,
        },
        ExcelChartField: {
            deleted: false,
        },
        ExcelImageField: {},
        ExcelSheetField: {
            deleted: false,
            tryCalculateFormula: false,
            autoFitColumns: false,
            autoFitRows: false,
        },
        ExcelTableField: {
            deleted: false,
        },
        OutputField: {},
        PdfSectionField: {
            source: "tag",
            idTag: 0,
            nestedIdProduct: 0,
        },
        TableOutputField: {},
        WordContainerField: {
            deleted: false,
        },
        WordImageField: {
            deleted: false,
            fixContentControlSize: false,
        },
        WordListField: {
            deleted: false,
        },
        WordTextField: {
            deleted: false,
        },
        ZipSectionField: {
            source: "tag",
            idTag: 0,
            nestedIdProduct: 0,
        },
        BomOutput: {
            mode: "empty",
            ruleType: "output",
            enabled: true,
            autoValidation: true,
        },
        CadDrawingOutput: {
            fileNameAsTopModelName: false,
            ruleType: "output",
            enabled: true,
            autoValidation: true,
        },
        CadOutput: {
            hideCADApplication: false,
            closeCADatEnd: false,
            maxBuildTime: 600,
            copyAllFiles: false,
            deleteOldFiles: false,
            modifyDimensionInAllConfig: true,
            createBOM: false,
            creoVersion: 3,
            ruleType: "output",
            enabled: true,
            autoValidation: true,
        },
        ExcelOutput: {
            ruleType: "output",
            enabled: true,
            autoValidation: true,
        },
        Export: {
            enabled: true,
            postToCloud: true,
        },
        FileOutput: {
            ruleType: "output",
            enabled: true,
            autoValidation: true,
        },
        GlbOutput: {
            ruleType: "output",
            enabled: true,
            autoValidation: true,
        },
        ImageOutput: {
            ruleType: "output",
            enabled: true,
            autoValidation: true,
        },
        Output: {
            ruleType: "output",
            enabled: true,
            autoValidation: true,
        },
        PdfOutput: {
            ruleType: "output",
            enabled: true,
            autoValidation: true,
        },
        RenderPassExport: {
            frameCamera: true,
            framePadding: 1,
            allowEmpty: false,
            width: 800,
            height: 600,
            enabled: true,
            postToCloud: true,
        },
        SceneRenderOutput: {
            frameCamera: true,
            framePadding: 1,
            allowEmpty: false,
            width: 800,
            height: 600,
            ruleType: "output",
            enabled: true,
            autoValidation: true,
        },
        SvgOutput: {
            ruleType: "output",
            enabled: true,
            autoValidation: true,
        },
        TextOutput: {
            ruleType: "output",
            enabled: true,
            autoValidation: true,
        },
        WordOutput: {
            ruleType: "output",
            enabled: true,
            autoValidation: true,
        },
        ZipOutput: {
            ruleType: "output",
            enabled: true,
            autoValidation: true,
        },
        OverlayPopup: {
            enabled: true,
            enableClose: true,
            showLabel: true,
            backgroundColor: "background",
            backgroundShade: "default",
            headerColor: "header",
            headerShade: "default",
            visible: true,
            left: "auto",
            top: "auto",
            right: "auto",
            bottom: "auto",
            width: "auto",
            height: "auto",
            opacity: 1.0,
            order: 0,
            relativeSize: "auto",
            alignment: "inherit",
        },
        OverlayPopupControl: {
            padding: "large",
            visible: true,
            left: "auto",
            top: "auto",
            right: "auto",
            bottom: "auto",
            width: "auto",
            height: "auto",
            opacity: 1.0,
            order: 0,
            relativeSize: "auto",
            alignment: "inherit",
        },
        Page: {
            enabled: true,
            iconStyle: "icon",
            visible: true,
            left: "auto",
            top: "auto",
            right: "auto",
            bottom: "auto",
            width: "auto",
            height: "auto",
            opacity: 1.0,
            order: 0,
            relativeSize: "auto",
            alignment: "inherit",
        },
        PageControl: {
            padding: "large",
            visible: true,
            left: "auto",
            top: "auto",
            right: "auto",
            bottom: "auto",
            width: "auto",
            height: "auto",
            opacity: 1.0,
            order: 0,
            relativeSize: "auto",
            alignment: "inherit",
        },
        PageNavigator: {
            buttonStyle: "normal",
            buttonColor: "background",
            showPageLabel: true,
            labelColor: "normal",
            visible: true,
            left: "auto",
            top: "auto",
            right: "auto",
            bottom: "auto",
            width: "auto",
            height: "auto",
            opacity: 1.0,
            order: 0,
            relativeSize: "auto",
            alignment: "inherit",
        },
        PageTabs: {
            orientation: "vertical",
            tabStyle: "cards",
            iconSize: 34,
            tabWidth: "custom",
            customTabWidth: 63,
            showTabLabels: true,
            backgroundColor: "background",
            backgroundShade: "default",
            selectionStyle: "background",
            selectionColor: "accent",
            selectionShade: "default",
            selectionLineColor: "accent",
            elevation: "none",
            visible: true,
            left: "auto",
            top: "auto",
            right: "auto",
            bottom: "auto",
            width: "auto",
            height: "auto",
            opacity: 1.0,
            order: 0,
            relativeSize: "auto",
            alignment: "inherit",
        },
        Popup: {
            popupWidth: "auto",
            popupHeight: "auto",
            ruleType: "button",
            enabled: true,
            iconStyle: "none",
            textPosition: "right",
            buttonStyle: "normal",
            color: "background",
            imageHeight: 30,
            imageWidth: 30,
            showLabel: true,
            fullWidth: false,
            relativeWidth: "auto",
            useZeroPadding: false,
            visible: true,
            left: "auto",
            top: "auto",
            right: "auto",
            bottom: "auto",
            width: "auto",
            height: "auto",
            opacity: 1.0,
            order: 0,
            relativeSize: "auto",
            alignment: "inherit",
        },
        PriceWidget: {
            showDetails: true,
            visible: true,
            left: "auto",
            top: "auto",
            right: "auto",
            bottom: "auto",
            width: "auto",
            height: "auto",
            opacity: 1.0,
            order: 0,
            relativeSize: "auto",
            alignment: "inherit",
        },
        PricingRuleContainer: {
            requiresUpdate: false,
            fillFromSource: "none",
        },
        ReferencedConfigurator: {
            nestScene: true,
            nestHotspots: false,
            nestPriceObject: true,
            nestMethodOfManufacture: true,
            addAsQuoteProduct: false,
            kineticViewOnly: false,
            runLoadedRule: false,
        },
        Rule: {},
        RuleContainer: {},
        SvgViewer: {
            visible: true,
            left: "auto",
            top: "auto",
            right: "auto",
            bottom: "auto",
            width: "auto",
            height: "auto",
            opacity: 1.0,
            order: 0,
            relativeSize: "auto",
            alignment: "inherit",
        },
        Tab: {
            showLabel: true,
            iconStyle: "icon",
            visible: true,
            left: "auto",
            top: "auto",
            right: "auto",
            bottom: "auto",
            width: "auto",
            height: "auto",
            opacity: 1.0,
            order: 0,
            relativeSize: "auto",
            alignment: "inherit",
        },
        TabControl: {
            tabWidth: "auto",
            customTabWidth: 63,
            visible: true,
            left: "auto",
            top: "auto",
            right: "auto",
            bottom: "auto",
            width: "auto",
            height: "auto",
            opacity: 1.0,
            order: 0,
            relativeSize: "auto",
            alignment: "inherit",
        },
        Text: {
            style: "normal",
            color: "normal",
            weight: "f400",
            visible: true,
            left: "auto",
            top: "auto",
            right: "auto",
            bottom: "auto",
            width: "auto",
            height: "auto",
            opacity: 1.0,
            order: 0,
            relativeSize: "auto",
            alignment: "inherit",
        },
        Toolbar: {
            visible: true,
            left: "auto",
            top: "auto",
            right: "auto",
            bottom: "auto",
            width: "auto",
            height: "auto",
            opacity: 1.0,
            order: 0,
            relativeSize: "auto",
            alignment: "inherit",
        },
        UiObject: {
            visible: true,
            left: "auto",
            top: "auto",
            right: "auto",
            bottom: "auto",
            width: "auto",
            height: "auto",
            opacity: 1.0,
            order: 0,
            relativeSize: "auto",
            alignment: "inherit",
        },
        Viewer: {
            visible: true,
            left: "auto",
            top: "auto",
            right: "auto",
            bottom: "auto",
            width: "auto",
            height: "auto",
            opacity: 1.0,
            order: 0,
            relativeSize: "auto",
            alignment: "inherit",
        },
        ProductRuleContainer: {
            autoValidation: true,
        },
    };

    var PropertyChangedEvent = /** @class */ (function (_super) {
        __extends(PropertyChangedEvent, _super);
        function PropertyChangedEvent() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return PropertyChangedEvent;
    }(_tools.KbEvent));
    var KbObject = /** @class */ (function () {
        function KbObject($manager) {
            var _this = this;
            this.$manager = $manager;
            this.$propertyChanged = new PropertyChangedEvent();
            this.getParent = function () { return _this.$parent; };
            _tools.Utils.guardNotNull($manager);
            // set defaults
            var defaultsClass = defaults[this.$type];
            for (var prop in defaultsClass) {
                this[prop] = defaultsClass[prop];
            }
            this.id = _tools.Utils.shortId();
        }
        KbObject.generateName = function (obj, parentGroup, name) {
            if (!name)
                name = obj.$type;
            var i = 0;
            var resultName = name;
            parentGroup.forEach(function (kb) {
                if (kb.name == resultName) {
                    resultName = name + (++i);
                }
            });
            obj.name = resultName;
        };
        /**
         * a helper that derived classes can call from property setters to enable change detection.
         * NOTE!  Assumes there is a private backing field
         * for the property that is named by the convention "_" + propertyName
         */
        KbObject.prototype.setProperty = function (propertyName, newValue, addToUndoStack) {
            var privateProp = "_" + propertyName;
            var oldValue = this[privateProp];
            var changed = (oldValue !== newValue);
            // set the private backing variable
            this[privateProp] = newValue;
            if (changed) {
                this.$propertyChanged.trigger({
                    oldValue: oldValue,
                    newValue: newValue,
                    property: propertyName
                });
            }
        };
        Object.defineProperty(KbObject.prototype, "id", {
            get: function () {
                return this._id;
            },
            set: function (val) {
                var changed = !_tools.Utils.areEqual(this._id, val);
                if (changed) {
                    // delete from name scope
                    this.$manager.removeKbObjectById(this._id);
                    this.$manager.addKbObjectWithId(val, this);
                }
                this._id = val;
            },
            enumerable: false,
            configurable: true
        });
        KbObject.prototype.getParentOfType = function ($type) {
            var parent = this.$parent;
            while (parent) {
                if (parent.$type == $type)
                    return parent;
                parent = parent.$parent;
            }
            return null;
        };
        KbObject.prototype.findAncestor = function (predicate) {
            var parent = this.$parent;
            while (parent) {
                if (predicate(parent))
                    return parent;
                parent = parent.$parent;
            }
            return null;
        };
        Object.defineProperty(KbObject.prototype, "$parentConfigurator", {
            get: function () {
                if (!this._parentConfigurator) {
                    this._parentConfigurator = this.getParentOfType("Configurator");
                }
                return this._parentConfigurator;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(KbObject.prototype, "name", {
            get: function () {
                return this._name;
            },
            set: function (val) {
                var changed = !_tools.Utils.areEqual(this._name, val);
                if (changed) {
                    val = this.$manager.getUniqueName(this, val);
                    // delete from name scope
                    if (this._name) {
                        this.$manager.removeKbObjectNameReference(this._name);
                    }
                    this.$manager.addKbObjectNameReference(val, this);
                }
                this._name = val;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(KbObject.prototype, "$label", {
            /**
             * for field controls to bind to.  Defaults to name if there is no label
             */
            get: function () {
                var l = this.label ? this.label : this.name;
                return l;
            },
            enumerable: false,
            configurable: true
        });
        KbObject.prototype.serialize = function (modifier) {
            // Not all objects have complex getters and setters, so we'll default to this.
            var result = {};
            result.$type = this.$type; // type needs to be first for the deserialization to happen correctly on the server
            var _loop_1 = function (key) {
                if (key.substr(0, 1) == "$" || (key.substr(0, 1) == "_" && key != "_metadata") || this_1.ignoredProperties().some(function (p) { return p.isEqual(key); }))
                    return "continue";
                var item = this_1[key];
                if (item == this_1)
                    return "continue";
                if (item instanceof Function)
                    return "continue";
                if (item && item.constructor === Array && item[0] && item[0].serialize) {
                    result[key] = item.map(function (i) { return i.serialize(modifier); });
                }
                else if (item && item.serialize) {
                    result[key] = item.serialize(modifier);
                }
                else {
                    result[key] = item;
                }
            };
            var this_1 = this;
            for (var key in this) {
                _loop_1(key);
            }
            result.name = this.name;
            result.label = this.label;
            result.id = this.id;
            if (modifier)
                modifier(this, result);
            return result;
        };
        /**
         * sets property values of the class given an object.  For example:  {name: "field1", value: 15}
         * Used by snap so don't delete!
         * @param values
         */
        KbObject.prototype.setProps = function (values) {
            for (var key in values) {
                this[key] = values[key];
            }
        };
        /**
         * Can be overridden by derived classes to specify properties that should be ignored during
         * serialization
         */
        KbObject.prototype.ignoredProperties = function () {
            return [];
        };
        KbObject.prototype.allowedChildren = function (rootType) {
            return [];
        };
        __decorate([
            Enumerable()
        ], KbObject.prototype, "id", null);
        __decorate([
            Enumerable()
        ], KbObject.prototype, "$parentConfigurator", null);
        __decorate([
            Enumerable()
        ], KbObject.prototype, "name", null);
        __decorate([
            Enumerable()
        ], KbObject.prototype, "$label", null);
        KbObject = __decorate([
            Kbo(CToken.KbObject)
        ], KbObject);
        return KbObject;
    }());

    var RuleContainer = /** @class */ (function (_super) {
        __extends(RuleContainer, _super);
        function RuleContainer(kom, args) {
            var _this = _super.call(this, kom) || this;
            // /**
            //  * the compiled rule, cached here for performance
            //  */
            // public $asyncFn: AsyncRuleFunction<any>;
            // public $syncFn: SyncRuleFunction<any>;
            _this.references = [];
            if (args) {
                _this.ruleType = args.ruleType;
            }
            return _this;
        }
        Object.defineProperty(RuleContainer.prototype, "rules", {
            get: function () {
                if (!this._rules)
                    this._rules = [];
                return this._rules;
            },
            set: function (val) {
                this._rules = val;
            },
            enumerable: false,
            configurable: true
        });
        RuleContainer.prototype.removeRule = function (rule) {
            this.$manager.removeKbObject(rule);
            this.rules.removeWhere(function (r) { return r.id == rule.id; });
        };
        __decorate([
            Enumerable()
        ], RuleContainer.prototype, "rules", null);
        RuleContainer = __decorate([
            Kbo(CToken.RuleContainer)
        ], RuleContainer);
        return RuleContainer;
    }(KbObject));

    var UiObject = /** @class */ (function (_super) {
        __extends(UiObject, _super);
        function UiObject(kom, args) {
            var _this = _super.call(this, kom, args) || this;
            _this.$valid = true;
            return _this;
        }
        UiObject.prototype.getCss = function (prop) {
            var v = this[prop];
            var numeric = (Number(v) == v);
            return numeric ? "".concat(v, "px") : v;
        };
        UiObject.prototype.filterChildren = function (tokens, allChildren) {
            var list = [];
            var _loop_1 = function (c) {
                if (!tokens.length || tokens.some(function (t) { return ConfiguratorDI.instanceOf(c, t); })) {
                    list.push(c);
                }
                c.getChildrenOfType.apply(c, tokens).forEach(function (c2) { return list.push(c2); });
            };
            for (var _i = 0, allChildren_1 = allChildren; _i < allChildren_1.length; _i++) {
                var c = allChildren_1[_i];
                _loop_1(c);
            }
            return list;
        };
        /**
         *
         * @param token Gets all the UI children of the given types.
         * @param allChildren
         */
        UiObject.prototype.getChildrenOfType = function () {
            var tokens = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                tokens[_i] = arguments[_i];
            }
            return [];
        };
        UiObject.prototype.allowedChildren = function (rootType) {
            // implement in derived classes
            return [];
        };
        /**
         * Utility function to get all of the standard allowed elements
         * for container type parents.
         * @param rootType
         */
        UiObject.prototype.containerChildren = function (rootType) {
            if (rootType == CToken.Configurator) {
                return [
                    CToken.Accordion,
                    CToken.Button,
                    CToken.Container,
                    CToken.DropdownButton,
                    CToken.Expander,
                    CToken.Field,
                    CToken.GridRow,
                    CToken.Group,
                    CToken.Html,
                    CToken.SvgViewer,
                    CToken.Media,
                    CToken.Popup,
                    CToken.TabControl,
                    CToken.Text,
                    CToken.Toolbar,
                    CToken.NestedElement,
                    CToken.NestedSet
                ];
            }
            else if (rootType == CToken.LayoutConfig) {
                return [
                    CToken.ActionBar,
                    CToken.Accordion,
                    CToken.Button,
                    CToken.Container,
                    CToken.DropdownButton,
                    CToken.Expander,
                    //CToken.Field,
                    //CToken.GridRow,
                    CToken.Group,
                    CToken.Html,
                    CToken.SvgViewer,
                    CToken.Media,
                    CToken.PageNavigator,
                    CToken.PageControl,
                    CToken.PageTabs,
                    CToken.Popup,
                    CToken.PriceWidget,
                    CToken.TabControl,
                    CToken.Text,
                    CToken.Toolbar,
                    CToken.Viewer,
                ];
            }
            else {
                return [];
            }
        };
        /** calculated validity and stores result in $valid property */
        UiObject.prototype.isValid = function () {
            var fields = this.getChildrenOfType(CToken.Field);
            var valid = !fields.some(function (f) { return !f.isValid(); });
            if (!valid) {
                this.$valid = false;
                return this.$valid;
            }
            this.$valid = true;
            return this.$valid;
        };
        Object.defineProperty(UiObject.prototype, "$domId", {
            /**
             * get's the html id that represents this ui object in the DOM
             */
            get: function () {
                var c = ConfiguratorDI.instanceOf(this, CToken.Configurator) ? this : this.$parentConfigurator;
                var p = c ? c.name.toKebabCase() + "-" : "";
                return p + this.id;
            },
            enumerable: false,
            configurable: true
        });
        __decorate([
            Enumerable()
        ], UiObject.prototype, "$domId", null);
        return UiObject;
    }(RuleContainer));

    var Accordion = /** @class */ (function (_super) {
        __extends(Accordion, _super);
        function Accordion(kom) {
            return _super.call(this, kom) || this;
        }
        Object.defineProperty(Accordion.prototype, "expanders", {
            get: function () {
                if (!this._expanders)
                    this._expanders = [];
                return this._expanders;
            },
            set: function (val) {
                this._expanders = val;
            },
            enumerable: false,
            configurable: true
        });
        Accordion.prototype.getChildrenOfType = function () {
            var tokens = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                tokens[_i] = arguments[_i];
            }
            return this.filterChildren(tokens, this.expanders);
        };
        Accordion.prototype.allowedChildren = function (rootType) {
            return [
                CToken.Expander
            ];
        };
        __decorate([
            Enumerable()
        ], Accordion.prototype, "expanders", null);
        Accordion = __decorate([
            Kbo(CToken.Accordion)
        ], Accordion);
        return Accordion;
    }(UiObject));

    var ActionBar = /** @class */ (function (_super) {
        __extends(ActionBar, _super);
        function ActionBar(kom) {
            return _super.call(this, kom) || this;
        }
        ActionBar = __decorate([
            Kbo(CToken.ActionBar)
        ], ActionBar);
        return ActionBar;
    }(UiObject));

    var BistrackPartRev = /** @class */ (function (_super) {
        __extends(BistrackPartRev, _super);
        function BistrackPartRev(kom, data) {
            return _super.call(this, kom) || this;
        }
        BistrackPartRev = __decorate([
            Kbo(CToken.BistrackPartRev)
        ], BistrackPartRev);
        return BistrackPartRev;
    }(KbObject));

    var Build = /** @class */ (function (_super) {
        __extends(Build, _super);
        function Build(kom) {
            var _this = _super.call(this, kom) || this;
            _this.$outputsNode = { id: _this.id + "_outputs", $type: "OutputsNode", allowedChildren: function () { return [CToken.Output]; }, getParent: function () { return _this; } };
            _this.$rulesNode = { id: _this.id + "_rules", $type: "RulesNode", allowedChildren: function () { return [CToken.Rule]; }, getParent: function () { return _this; } };
            return _this;
        }
        Object.defineProperty(Build.prototype, "ruleContainers", {
            get: function () {
                if (!this._ruleContainers)
                    this._ruleContainers = [];
                return this._ruleContainers;
            },
            set: function (val) {
                this._ruleContainers = val;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Build.prototype, "outputs", {
            get: function () {
                if (!this._outputs)
                    this._outputs = [];
                return this._outputs;
            },
            set: function (val) {
                this._outputs = val;
            },
            enumerable: false,
            configurable: true
        });
        Build.prototype.addOutput = function (outputType) {
            var output = ConfiguratorDI.getNewOutput(outputType, this.$manager);
            this.$manager.addKbObject(output, this);
            this.outputs.push(output);
            return output;
        };
        Build.prototype.removeOutput = function (output) {
            this.outputs.remove(output);
            this.$manager.removeKbObject(output);
        };
        Build.prototype.removeRuleContainer = function (rc) {
            this.$manager.removeKbObject(rc);
            this.ruleContainers.remove(rc);
        };
        __decorate([
            Enumerable()
        ], Build.prototype, "ruleContainers", null);
        __decorate([
            Enumerable()
        ], Build.prototype, "outputs", null);
        Build = __decorate([
            Kbo(CToken.Build)
        ], Build);
        return Build;
    }(KbObject));

    var Button = /** @class */ (function (_super) {
        __extends(Button, _super);
        function Button(kom) {
            return _super.call(this, kom, { ruleType: exports.eRuleType.button }) || this;
        }
        Button = __decorate([
            Kbo(CToken.Button)
        ], Button);
        return Button;
    }(UiObject));

    var ConfiguratorAction = /** @class */ (function (_super) {
        __extends(ConfiguratorAction, _super);
        function ConfiguratorAction(kom) {
            var _this = _super.call(this, kom) || this;
            _this.icon = _tools.icons.action;
            _this.ruleType = exports.eRuleType.action;
            return _this;
        }
        ConfiguratorAction = __decorate([
            Kbo(CToken.ConfiguratorAction)
        ], ConfiguratorAction);
        return ConfiguratorAction;
    }(RuleContainer));

    var ConfiguratorFunction = /** @class */ (function (_super) {
        __extends(ConfiguratorFunction, _super);
        function ConfiguratorFunction(kom) {
            var _this = _super.call(this, kom) || this;
            _this.ruleType = exports.eRuleType.function;
            return _this;
        }
        ConfiguratorFunction = __decorate([
            Kbo(CToken.ConfiguratorFunction)
        ], ConfiguratorFunction);
        return ConfiguratorFunction;
    }(RuleContainer));

    var Container = /** @class */ (function (_super) {
        __extends(Container, _super);
        function Container(kom) {
            return _super.call(this, kom) || this;
        }
        Object.defineProperty(Container.prototype, "children", {
            get: function () {
                if (!this._children)
                    this._children = [];
                return this._children;
            },
            set: function (val) {
                this._children = val;
            },
            enumerable: false,
            configurable: true
        });
        // public visible: boolean;
        Container.prototype.getChildrenOfType = function () {
            var tokens = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                tokens[_i] = arguments[_i];
            }
            return this.filterChildren(tokens, this.children);
        };
        Container.prototype.allowedChildren = function (rootType) {
            return this.containerChildren(rootType);
        };
        __decorate([
            Enumerable()
        ], Container.prototype, "children", null);
        Container = __decorate([
            Kbo(CToken.Container)
        ], Container);
        return Container;
    }(UiObject));

    var Hotspot = /** @class */ (function (_super) {
        __extends(Hotspot, _super);
        function Hotspot(kom) {
            var _this = _super.call(this, kom) || this;
            _this.$uid = _tools.Utils.shortId();
            return _this;
        }
        Hotspot = __decorate([
            Kbo(CToken.Hotspot)
        ], Hotspot);
        return Hotspot;
    }(KbObject));

    var KbObjectManager = /** @class */ (function () {
        function KbObjectManager() {
            this.kbObjects = {};
            this.kbObjectIds = {};
        }
        KbObjectManager.prototype.addKbObject = function (o, parent) {
            o.name = this.getUniqueName(o, o.name);
            o.$parent = parent;
            this.kbObjects[o.name.toLowerCase()] = o;
            // if this is a nested configurator, then we don't add it to the id map.
            // Reasoning being that there will be id collisions.  
            // Like adding multiple instances of the same nested configurator
            // or even cloning a configurator
            if (!(ConfiguratorDI.instanceOf(o, CToken.Configurator) && parent)) {
                this.kbObjectIds[o.id] = o;
            }
        };
        KbObjectManager.prototype.removeKbObject = function (o) {
            var _this = this;
            if (o) {
                // remove all child kbObjects as well
                if (!ConfiguratorDI.instanceOf(o, CToken.Configurator)) {
                    for (var prop in o) {
                        if (prop.substr(0, 1) == "$" || prop.substr(0, 1) == "_")
                            continue;
                        if (Array.isArray(o[prop])) {
                            o[prop].forEach(function (oChild) {
                                if (ConfiguratorDI.instanceOf(oChild, CToken.KbObject)) {
                                    _this.removeKbObject(oChild);
                                }
                            });
                        }
                    }
                }
                delete this.kbObjects[o.name.toLowerCase()];
                // if this is a nested configurator, then we don't add it to the id map.
                // Reasoning being that there will be id collisions.  
                // Like adding multiple instances of the same nested configurator
                // or even cloning a configurator
                //&& parent ** removed this since the function doesn't take a parent but on client this would be the window
                if (!(ConfiguratorDI.instanceOf(o, CToken.Configurator))) {
                    delete this.kbObjectIds[o.id];
                }
            }
        };
        KbObjectManager.prototype.getByName = function (name, throwOnFailure) {
            if (throwOnFailure === void 0) { throwOnFailure = true; }
            var n = name ? name.toLowerCase() : name;
            var o = this.kbObjects[n];
            if (!o && throwOnFailure) {
                throw new Error("object with name " + name + " does not exist");
            }
            return o;
        };
        KbObjectManager.prototype.get = function (id, throwOnFailure) {
            if (throwOnFailure === void 0) { throwOnFailure = true; }
            var o = this.kbObjectIds[id];
            if (!o && throwOnFailure) {
                throw new Error("object with id " + id + " does not exist");
            }
            return o;
        };
        KbObjectManager.prototype.getByIdOrName = function (idOrName, throwOnFailure) {
            if (throwOnFailure === void 0) { throwOnFailure = true; }
            var o = this.get(idOrName, false);
            if (!o)
                o = this.getByName(idOrName, false);
            if (!o && throwOnFailure) {
                throw new Error("object with id or name " + idOrName + " does not exist");
            }
            return o;
        };
        KbObjectManager.prototype.hasNamedObject = function (name) {
            return this.kbObjects.hasOwnProperty(name.toLowerCase());
        };
        KbObjectManager.prototype.removeKbObjectById = function (id) {
            delete this.kbObjectIds[id];
        };
        KbObjectManager.prototype.addKbObjectWithId = function (id, o) {
            this.kbObjectIds[id] = o;
        };
        KbObjectManager.prototype.removeKbObjectNameReference = function (name) {
            delete this.kbObjects[name.toLowerCase()];
        };
        KbObjectManager.prototype.addKbObjectNameReference = function (name, o) {
            this.kbObjects[name.toLowerCase()] = o;
        };
        /**
         * finds a unique name for given object in the context of the collection of kbObjects
         */
        KbObjectManager.prototype.getUniqueName = function (o, proposed) {
            var _this = this;
            var counter = 0;
            proposed = proposed || o.$type || "Object"; // IE does not jive with constructor.name so we need a fallback
            var name = proposed;
            var nameIsUnique = function (proposed, o) {
                return !_this.hasNamedObject(proposed.toLowerCase()) || _this.getByName(proposed) === o;
            };
            while (!nameIsUnique(name, o)) {
                counter++;
                name = proposed + counter.toString();
            }
            return name;
        };
        /**
         * clear out all of the id's and names from this instance
         */
        KbObjectManager.prototype.clear = function () {
            this.kbObjectIds = {};
            this.kbObjects = {};
        };
        KbObjectManager.prototype.create = function (token, kom) {
            var k = ConfiguratorDI.get(token);
            return new k.class(kom);
        };
        KbObjectManager.prototype.recurse = function (source, target) {
            var _this = this;
            var kom = target.$manager;
            var _loop_1 = function (prop) {
                if (source.hasOwnProperty(prop)) {
                    if (Array.isArray(source[prop])) {
                        if (!target[prop]) {
                            target[prop] = [];
                        }
                        source[prop].forEach(function (sourceItem) {
                            var targetItem;
                            if (sourceItem == null) {
                                target[prop].push(sourceItem);
                                return;
                            }
                            // Hack: Because method of manufacture is a dynamic type on the server-side, it is
                            // problemmatic for Newtonsoft to properly assign a $type parameter.
                            if (prop == "materials")
                                sourceItem.$type = CToken.PartMaterial.key;
                            if (prop == "operations")
                                sourceItem.$type = CToken.PartOperation.key;
                            if (sourceItem.$type) {
                                var komArg = kom;
                                if (sourceItem.$type == CToken.Configurator.key) {
                                    komArg = new KbObjectManager();
                                }
                                targetItem = _this.create(CToken.withKey(sourceItem.$type), komArg);
                                target[prop].push(targetItem);
                                // recurse before adding it to the $manager so that the name is already resolved
                                _this.recurse(sourceItem, targetItem);
                                if (ConfiguratorDI.instanceOf(targetItem, CToken.KbObject)) {
                                    kom.addKbObject(targetItem, target);
                                }
                            }
                            else if (typeof sourceItem === "object") {
                                targetItem = {};
                                target[prop].push(targetItem);
                                _this.recurse(sourceItem, targetItem);
                            }
                            else { // must be a value type
                                var propDef = Object.getOwnPropertyDescriptor(target.constructor.prototype, prop);
                                if (!propDef || propDef.set) { //if prop has a setter
                                    // Only do anything to the target if the property has a setter.
                                    target[prop].push(sourceItem);
                                }
                            }
                        });
                    }
                    else {
                        var propDef = Object.getOwnPropertyDescriptor(target.constructor.prototype, prop);
                        if (prop == "rootPartRev" && source[prop])
                            source[prop].$type = CToken.PartRev.key;
                        if (prop == "methodOfManufacture" && source[prop])
                            source[prop].$type = CToken.MethodOfManufacture.key;
                        if (!propDef || propDef.set) { //if prop has a setter
                            // This fixes the following bug:
                            //
                            // If you created two or more nested configurators that had an upload field, then uploading a file to one of them would also upload it for the other.
                            // the reason for this was each upload field was referencing the same default value, which is an empty upload field. This line forces each instance
                            // of an upload field to reference its own default value to break that coupling.
                            if (source.$type == CToken.Field.key && source.type == exports.eFieldType.upload && prop == "value") {
                                target[prop] = _tools.Utils.extend({}, source[prop]);
                            }
                            else if (source[prop] && source[prop].$type) {
                                var targetItem = this_1.create(CToken.withKey(source[prop].$type), kom);
                                target[prop] = targetItem;
                                this_1.recurse(source[prop], targetItem);
                            }
                            else {
                                target[prop] = source[prop];
                            }
                        }
                    }
                }
            };
            var this_1 = this;
            for (var prop in source) {
                _loop_1(prop);
            }
        };
        return KbObjectManager;
    }());

    var OptionFilter = /** @class */ (function (_super) {
        __extends(OptionFilter, _super);
        function OptionFilter(kom) {
            var _this = _super.call(this, kom, { ruleType: exports.eRuleType.optionFilter }) || this;
            _this.dependsOn = [];
            _this.dependsOnThis = [];
            _this.fieldReferences = [];
            return _this;
        }
        OptionFilter = __decorate([
            Kbo(CToken.OptionFilter)
        ], OptionFilter);
        return OptionFilter;
    }(RuleContainer));

    var Field = /** @class */ (function (_super) {
        __extends(Field, _super);
        function Field(kom) {
            var _this = _super.call(this, kom, { ruleType: exports.eRuleType.field }) || this;
            _this.validationErrors = [];
            _this.warnings = [];
            _this.format = exports.eFormatType.none; // none, currency, percentage, number
            return _this;
        }
        Field_1 = Field;
        Object.defineProperty(Field.prototype, "acceptedFileTypes", {
            /** Compatibility alias for the correctly-spelled API/editor property. */
            get: function () {
                return this.acceptedFileTyes;
            },
            set: function (value) {
                this.acceptedFileTyes = value;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Field.prototype, "tags", {
            get: function () {
                if (!this._tags)
                    this._tags = [];
                return this._tags;
            },
            set: function (val) {
                this._tags = val;
            },
            enumerable: false,
            configurable: true
        });
        Field.prototype.convertValue = function (val) {
            return Field_1.convertToType(val, this.type, this.precision);
        };
        Field.prototype.convertForSet = function (val) {
            /* dates need special handling.  Coming from json, they will be ISO strings.
            We need them to be Date objects so they play well with snap rules.  But we
            can't new up a new Date() object in the field get() which is where we handle other conversions
            because it will break the binding system in angular (creates an endless digest).
            So we create the Date object in the field value setter. */
            if (this.type == exports.eFieldType.date && val && !(val instanceof Date)) {
                val = new Date(val);
            }
            if (this.type == exports.eFieldType.upload && (!val || typeof (val.path) == "undefined")) {
                val = {
                    path: null,
                    assetId: null
                };
            }
            return val;
        };
        Object.defineProperty(Field.prototype, "value", {
            get: function () {
                var _this = this;
                var skip = this.$parentConfigurator && this.$parentConfigurator.$freezeFieldValueCalculation && !this._dirty;
                if (!skip) {
                    var val_2 = this.convertValue(this._value);
                    if (this.$parentConfigurator && this.$parentConfigurator.$running && this.isValueConstrainedToOptions()) {
                        if (this.isArrayType()) {
                            var shouldUpdate = false;
                            var _loop_1 = function (v) {
                                if (!this_1.options.some(function (o) { return _this.convertValue(o.value) == v; })) {
                                    shouldUpdate = true;
                                    return "break";
                                }
                            };
                            var this_1 = this;
                            for (var _i = 0, val_1 = val_2; _i < val_1.length; _i++) {
                                var v = val_1[_i];
                                var state_1 = _loop_1(v);
                                if (state_1 === "break")
                                    break;
                            }
                            if (shouldUpdate && this.options.length) { // prevent infinite $digest loop
                                val_2 = val_2.filter(function (v) { return _this.options.some(function (o) { return o.value == v; }); });
                                this._value = val_2;
                            }
                        }
                        else if (!this.options.some(function (o) { return _this.convertValue(o.value) == val_2; })) {
                            val_2 = this.options.length ? this.convertValue(this.options[0].value) : null;
                        }
                    }
                    if (this.isArrayType() && this._value == null) {
                        this._value = val_2;
                    }
                    this._lastCalculatedValue = val_2;
                    this._dirty = false;
                }
                return this._lastCalculatedValue;
            },
            set: function (val) {
                var origValue = this.value;
                this._value = this.convertForSet(val);
                var newValue = this.value;
                if (origValue != newValue && this.$parentConfigurator) {
                    this.$parentConfigurator.$fieldsDirty = true;
                    this.$parentConfigurator.$fieldsDirtyForSceneRules = true;
                }
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Field.prototype, "desiredValue", {
            /**
             * gets the underlying value, not the one calculated by looking at the options.
             * This is needed for passing to the server when running option filters, so the option
             * filter can calculate it's own value for the field correctly and arrive at the same
             * conclusion as the client.
             */
            get: function () {
                return this._value;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Field.prototype, "formattedValue", {
            /**
             * if the field is a number, formattedValue will return a string representation of the value formatted
             * formatted per the format_ properties on the field
             */
            get: function () {
                if (!this.value) {
                    return "";
                }
                else if (this.type === exports.eFieldType.number) {
                    var args = {
                        formatType: this.format,
                        currency: this.formatCurrency,
                        minPrecision: this.formatMinPrecision,
                        maxPrecision: this.precision,
                        decimalSeparator: this.formatDecimalSeparator,
                        thousandsSeparator: this.formatThousandsSeparator,
                        prefix: this.formatPrefix,
                        suffix: this.formatSuffix
                    };
                    return this.value.format(args);
                }
                else {
                    return this.value.toString();
                }
            },
            enumerable: false,
            configurable: true
        });
        /** meant to work with $freezeFieldValueCalculation.  Marks the field value to be recalculated the next time it's asked for */
        Field.prototype.recalculateValue = function () {
            this._dirty = true;
        };
        Object.defineProperty(Field.prototype, "minDate", {
            get: function () {
                return Field_1.convertToType(this._minDate, exports.eFieldType.date, 0);
            },
            set: function (val) {
                this._minDate = this.convertForSet(val);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Field.prototype, "maxDate", {
            get: function () {
                return Field_1.convertToType(this._maxDate, exports.eFieldType.date, 0);
            },
            set: function (val) {
                this._maxDate = this.convertForSet(val);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Field.prototype, "options", {
            get: function () {
                if (!this._options)
                    this._options = [];
                return this._options;
            },
            set: function (val) {
                this._options = val;
                this.recalculateValue();
            },
            enumerable: false,
            configurable: true
        });
        Field.prototype.isValid = function () {
            var timing = exports.eValidationTiming.always;
            if (this.$parentConfigurator) {
                timing = this.$parentConfigurator.validationTiming;
            }
            this.$valid = (timing == exports.eValidationTiming.always || this.hasBeenTouched) ?
                (!this.validationErrors || this.validationErrors.length === 0)
                : true;
            return this.$valid;
        };
        Field.prototype.preValidate = function () {
            // clear validation errors
            this.validationErrors.clear();
            this.warnings.clear();
            // if number field
            if (this.type == exports.eFieldType.number) {
                // validate the value is btw min & max
                if (this.constrainValue && _tools.Utils.isDefined(this.min) && this.value < this.min) {
                    this.addValidation({
                        message: loc.validation_valuemustbegreaterthan.format(this.min.toString())
                    });
                }
                if (this.constrainValue && _tools.Utils.isDefined(this.max) && this.value > this.max) {
                    this.addValidation({
                        message: loc.validation_valuemustbelessthan.format(this.max.toString())
                    });
                }
            }
            else if (this.type == exports.eFieldType.date) {
                if (this.constrainValue && _tools.Utils.isDefined(this.minDate) && this.value < this.minDate) {
                    this.addValidation({
                        message: loc.validation_valuemustbegreaterthan.format(this.minDate.toDateString())
                    });
                }
                if (this.constrainValue && _tools.Utils.isDefined(this.maxDate) && this.value > this.maxDate) {
                    this.addValidation({
                        message: loc.validation_valuemustbelessthan.format(this.maxDate.toDateString())
                    });
                }
            }
            if (this.type == exports.eFieldType.text || this.type == exports.eFieldType.color || this.type == exports.eFieldType.date) {
                if (!this.value && this.required) {
                    this.addValidation({
                        message: loc.validation_required
                    });
                }
            }
        };
        Field.prototype.validateCondition = function (condition, errorMessage, mode, fixThis) {
            if (fixThis === void 0) { fixThis = []; }
            if (!condition) {
                if (mode == "warning") {
                    this.addValidation({ message: errorMessage, fixThisOptions: fixThis }, true);
                }
                else {
                    this.addValidation({ message: errorMessage, fixThisOptions: fixThis });
                }
            }
        };
        Field.prototype.addValidation = function (msg, isWarning) {
            if (isWarning === void 0) { isWarning = false; }
            //don't add if it's a duplicate
            if (isWarning) {
                if (!this.warnings.some(function (w) { return w.message == msg.message; })) {
                    if (!this.warnings)
                        this.warnings = [];
                    this.warnings.push(msg);
                }
            }
            else {
                if (!this.validationErrors.some(function (w) { return w.message == msg.message; })) {
                    if (!this.validationErrors)
                        this.validationErrors = [];
                    this.validationErrors.push(msg);
                }
            }
        };
        /**
         * returns whether a field is allowed to join a select table
         */
        // TODO: This logic is copied in Field.cs... the logic should be defined in only
        // Field.cs and picked up by codegen here.
        Field.prototype.canJoinOptionFilter = function () {
            if (this.control == exports.eFieldControl.imageSelect ||
                this.control == exports.eFieldControl.select ||
                this.control == exports.eFieldControl.radio ||
                this.control == exports.eFieldControl.colorSelect ||
                this.control == exports.eFieldControl.swatchSelect ||
                this.control == exports.eFieldControl.checkbox ||
                this.control == exports.eFieldControl.toggle ||
                this.control == exports.eFieldControl.multiSelect ||
                this.control == exports.eFieldControl.imageMultiSelect ||
                this.control == exports.eFieldControl.colorMultiSelect) {
                return true;
            }
            else {
                return false;
            }
        };
        Field.prototype.isValueConstrainedToOptions = function () {
            return (this.control == exports.eFieldControl.select ||
                this.control == exports.eFieldControl.radio ||
                this.control == exports.eFieldControl.imageSelect ||
                this.control == exports.eFieldControl.colorSelect ||
                this.control == exports.eFieldControl.swatchSelect ||
                this.control == exports.eFieldControl.multiSelect ||
                this.control == exports.eFieldControl.imageMultiSelect ||
                this.control == exports.eFieldControl.colorMultiSelect ||
                ((this.control == exports.eFieldControl.checkbox || this.control == exports.eFieldControl.toggle) &&
                    this.selectSource == exports.eSelectSource.optionFilter &&
                    this.idOptionFilter != null));
        };
        Field.prototype.isArrayType = function () {
            return (this.type.equalsAny(exports.eFieldType.textArray, exports.eFieldType.numberArray, exports.eFieldType.colorArray));
        };
        Field.prototype.getBaseType = function () {
            if (this.isArrayType()) {
                return this.type.substr(0, this.type.length - 5);
            }
            else {
                return this.type;
            }
        };
        Field.convertToType = function (value, toType, precision) {
            var val = value;
            if (value == null) {
                val = null;
            }
            if (toType === exports.eFieldType.number) {
                // convert to a number
                // if (typeof value == "number" || value instanceof Number)
                //    return value;
                val = Number(value);
                // test if NaN : https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isNaN
                if (val != val) {
                    val = 0;
                }
                // round to precision
                if (precision != -1) {
                    val = val.rounder(precision);
                }
            }
            else if (toType === exports.eFieldType.boolean) {
                if (typeof val === "boolean") {
                    return val;
                }
                if (typeof val === "string" || val instanceof String) {
                    val = _tools.Utils.areEqual(val, "true");
                }
                else {
                    val = Boolean(val);
                }
            }
            else if (toType === exports.eFieldType.date) {
                if (value != null && !(value instanceof Date)) {
                    val = new Date(value);
                }
            }
            else if (toType == exports.eFieldType.textArray ||
                toType == exports.eFieldType.numberArray ||
                toType == exports.eFieldType.colorArray) {
                if (value == null) {
                    val = [];
                }
                else if (!Array.isArray(value)) {
                    val = [value];
                }
                // now we should have an array, make sure all items in the array are of the right type
                for (var i = 0; i < val.length; i++) {
                    val[i] = Field_1.convertToType(val[i], toType.substr(0, toType.length - 5), precision);
                }
            }
            else if (toType == exports.eFieldType.upload) {
                if (value == null || typeof (value.path) == 'undefined') {
                    val = {
                        assetId: null,
                        path: null
                    };
                }
            }
            return val;
        };
        var Field_1;
        __decorate([
            Enumerable()
        ], Field.prototype, "tags", null);
        __decorate([
            Enumerable()
        ], Field.prototype, "value", null);
        __decorate([
            Enumerable()
        ], Field.prototype, "desiredValue", null);
        __decorate([
            Enumerable()
        ], Field.prototype, "formattedValue", null);
        __decorate([
            Enumerable()
        ], Field.prototype, "minDate", null);
        __decorate([
            Enumerable()
        ], Field.prototype, "maxDate", null);
        __decorate([
            Enumerable()
        ], Field.prototype, "options", null);
        Field = Field_1 = __decorate([
            Kbo(CToken.Field)
        ], Field);
        return Field;
    }(UiObject));

    var Group = /** @class */ (function (_super) {
        __extends(Group, _super);
        function Group(kom) {
            return _super.call(this, kom) || this;
        }
        Object.defineProperty(Group.prototype, "children", {
            get: function () {
                if (!this._children)
                    this._children = [];
                return this._children;
            },
            set: function (val) {
                this._children = val;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Group.prototype, "fields", {
            /**
             * Fields array has been deprecated.  This readonly property is here for
             * backwards compatibility
             */
            get: function () {
                return this.getChildrenOfType(CToken.Field);
            },
            enumerable: false,
            configurable: true
        });
        Group.prototype.addField = function () {
            var field = new Field(this.$manager);
            this.$manager.addKbObject(field, this);
            this.children.push(field);
            return field;
        };
        Group.prototype.removeField = function (field) {
            this.$manager.removeKbObject(field);
            this.children.remove(field);
        };
        Group.prototype.getChildrenOfType = function () {
            var tokens = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                tokens[_i] = arguments[_i];
            }
            return this.filterChildren(tokens, this.children);
        };
        Group.prototype.allowedChildren = function (rootType) {
            return this.containerChildren(rootType);
        };
        Group.prototype.ignoredProperties = function () {
            return ["fields"];
        };
        __decorate([
            Enumerable()
        ], Group.prototype, "children", null);
        Group = __decorate([
            Kbo(CToken.Group)
        ], Group);
        return Group;
    }(UiObject));

    var Page = /** @class */ (function (_super) {
        __extends(Page, _super);
        function Page(kom) {
            var _this = _super.call(this, kom) || this;
            _this.icon = "";
            if (_tools.icons) {
                _this.icon = _tools.icons.page;
            }
            return _this;
        }
        Page_1 = Page;
        Object.defineProperty(Page.prototype, "children", {
            get: function () {
                if (!this._children)
                    this._children = [];
                return this._children;
            },
            set: function (val) {
                this._children = val;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Page.prototype, "groups", {
            /**
             * Groups array has been deprecated.  This readonly property is here for
             * backwards compatibility
             */
            get: function () {
                return this.getChildrenOfType(CToken.Group);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Page.prototype, "pages", {
            get: function () {
                if (!this._pages)
                    this._pages = [];
                return this._pages;
            },
            set: function (val) {
                this._pages = val;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Page.prototype, "configurators", {
            get: function () {
                if (!this._configurators)
                    this._configurators = [];
                return this._configurators;
            },
            set: function (val) {
                this._configurators = val;
            },
            enumerable: false,
            configurable: true
        });
        Page.prototype.addGroup = function () {
            var group = new Group(this.$manager);
            this.$manager.addKbObject(group, this);
            this.children.push(group);
            return group;
        };
        Page.prototype.removeGroup = function (group) {
            this.$manager.removeKbObject(group);
            this.children.remove(group);
        };
        Page.prototype.addPage = function () {
            var page = new Page_1(this.$manager);
            this.$manager.addKbObject(page, this);
            this.pages.push(page);
            return page;
        };
        Page.prototype.removePage = function (page) {
            this.$manager.removeKbObject(page);
            this.pages.remove(page);
        };
        Page.prototype.allPages = function () {
            return this.getChildrenOfType(CToken.Page);
        };
        Page.prototype.getFields = function (predicate) {
            var fields = this.getChildrenOfType(CToken.Field);
            return predicate ? fields.filter(function (f) { return predicate(f); }) : fields;
        };
        Page.prototype.getChildrenOfType = function () {
            var tokens = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                tokens[_i] = arguments[_i];
            }
            return this.filterChildren(tokens, this.children.concat(this.pages));
        };
        Page.prototype.isValid = function () {
            var fields = this.getFields();
            var valid = !fields.some(function (f) { return !f.isValid(); });
            if (!valid) {
                this.$valid = false;
                return this.$valid;
            }
            for (var _i = 0, _a = this.configurators; _i < _a.length; _i++) {
                var config = _a[_i];
                if (!config.isValid()) {
                    this.$valid = false;
                    return this.$valid;
                }
            }
            var nestedSets = this.getChildrenOfType(CToken.NestedSet);
            for (var _b = 0, nestedSets_1 = nestedSets; _b < nestedSets_1.length; _b++) {
                var ns = nestedSets_1[_b];
                for (var _c = 0, _d = ns.configurators; _c < _d.length; _c++) {
                    var nested = _d[_c];
                    if (!nested.isValid()) {
                        this.$valid = false;
                        return this.$valid;
                    }
                }
            }
            this.$valid = true;
            return this.$valid;
        };
        Page.prototype.allowedChildren = function (rootType) {
            var allowed = this.containerChildren(rootType);
            if (rootType == CToken.Configurator) {
                allowed.splice(0, 0, CToken.Page); //pages can have nested pages
            }
            return allowed;
        };
        Page.prototype.ignoredProperties = function () {
            return ["groups"];
        };
        var Page_1;
        __decorate([
            Enumerable()
        ], Page.prototype, "children", null);
        __decorate([
            Enumerable()
        ], Page.prototype, "pages", null);
        __decorate([
            Enumerable()
        ], Page.prototype, "configurators", null);
        Page = Page_1 = __decorate([
            Kbo(CToken.Page)
        ], Page);
        return Page;
    }(UiObject));

    var OverlayPopup = /** @class */ (function (_super) {
        __extends(OverlayPopup, _super);
        function OverlayPopup(kom, obj) {
            var _this = _super.call(this, kom) || this;
            _this.icon = "";
            if (_tools.icons) {
                _this.icon = _tools.icons.page;
            }
            return _this;
        }
        OverlayPopup_1 = OverlayPopup;
        Object.defineProperty(OverlayPopup.prototype, "enableClose", {
            get: function () {
                return this._enableClose;
            },
            set: function (val) {
                this.setProperty("enableClose", val);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(OverlayPopup.prototype, "showLabel", {
            get: function () {
                return this._showLabel;
            },
            set: function (val) {
                this.setProperty("showLabel", val);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(OverlayPopup.prototype, "children", {
            get: function () {
                if (!this._children)
                    this._children = [];
                return this._children;
            },
            set: function (val) {
                this._children = val;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(OverlayPopup.prototype, "groups", {
            get: function () {
                return this.getChildrenOfType(CToken.Group);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(OverlayPopup.prototype, "overlayPopups", {
            get: function () {
                if (!this._overlayPopups)
                    this._overlayPopups = [];
                return this._overlayPopups;
            },
            set: function (val) {
                this._overlayPopups = val;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(OverlayPopup.prototype, "configurators", {
            get: function () {
                if (!this._configurators)
                    this._configurators = [];
                return this._configurators;
            },
            set: function (val) {
                this._configurators = val;
            },
            enumerable: false,
            configurable: true
        });
        OverlayPopup.prototype.addGroup = function () {
            var group = new Group(this.$manager);
            this.$manager.addKbObject(group, this);
            this.children.push(group);
            return group;
        };
        OverlayPopup.prototype.removeGroup = function (group) {
            this.$manager.removeKbObject(group);
            this.children.remove(group);
        };
        OverlayPopup.prototype.addOverlayPopup = function () {
            var overlayPopup = new OverlayPopup_1(this.$manager);
            this.$manager.addKbObject(overlayPopup, this);
            this.overlayPopups.push(overlayPopup);
            return overlayPopup;
        };
        OverlayPopup.prototype.removeOverlayPopup = function (overlayPopup) {
            this.$manager.removeKbObject(overlayPopup);
            this.overlayPopups.remove(overlayPopup);
        };
        OverlayPopup.prototype.allOverlayPopups = function () {
            return this.getChildrenOfType(CToken.OverlayPopup);
        };
        OverlayPopup.prototype.getFields = function (predicate) {
            var fields = this.getChildrenOfType(CToken.Field);
            return predicate ? fields.filter(function (f) { return predicate(f); }) : fields;
        };
        OverlayPopup.prototype.getChildrenOfType = function () {
            var tokens = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                tokens[_i] = arguments[_i];
            }
            return this.filterChildren(tokens, this.children.concat(this.overlayPopups));
        };
        OverlayPopup.prototype.isValid = function () {
            var fields = this.getFields();
            var valid = !fields.some(function (f) { return !f.isValid(); });
            if (!valid) {
                this.$valid = false;
                return this.$valid;
            }
            for (var _i = 0, _a = this.configurators; _i < _a.length; _i++) {
                var config = _a[_i];
                if (!config.isValid()) {
                    this.$valid = false;
                    return this.$valid;
                }
            }
            var nestedSets = this.getChildrenOfType(CToken.NestedSet);
            for (var _b = 0, nestedSets_1 = nestedSets; _b < nestedSets_1.length; _b++) {
                var ns = nestedSets_1[_b];
                for (var _c = 0, _d = ns.configurators; _c < _d.length; _c++) {
                    var nested = _d[_c];
                    if (!nested.isValid()) {
                        this.$valid = false;
                        return this.$valid;
                    }
                }
            }
            this.$valid = true;
            return this.$valid;
        };
        OverlayPopup.prototype.allowedChildren = function (rootType) {
            var allowed = this.containerChildren(rootType);
            if (rootType == CToken.Configurator) {
                allowed.splice(0, 0, CToken.OverlayPopup);
            }
            return allowed;
        };
        OverlayPopup.prototype.ignoredProperties = function () {
            return ["groups"];
        };
        var OverlayPopup_1;
        __decorate([
            Enumerable()
        ], OverlayPopup.prototype, "enableClose", null);
        __decorate([
            Enumerable()
        ], OverlayPopup.prototype, "showLabel", null);
        __decorate([
            Enumerable()
        ], OverlayPopup.prototype, "children", null);
        __decorate([
            Enumerable()
        ], OverlayPopup.prototype, "overlayPopups", null);
        __decorate([
            Enumerable()
        ], OverlayPopup.prototype, "configurators", null);
        OverlayPopup = OverlayPopup_1 = __decorate([
            Kbo(CToken.OverlayPopup)
        ], OverlayPopup);
        return OverlayPopup;
    }(UiObject));

    var ReferencedConfigurator = /** @class */ (function (_super) {
        __extends(ReferencedConfigurator, _super);
        function ReferencedConfigurator(kom) {
            var _this = _super.call(this, kom) || this;
            _this.ruleContainers = [];
            _this.userCanAddTo = [];
            return _this;
        }
        ReferencedConfigurator.prototype.removeRuleContainer = function (rc) {
            this.$manager.removeKbObject(rc);
            this.ruleContainers.remove(rc);
        };
        ReferencedConfigurator = __decorate([
            Kbo(CToken.ReferencedConfigurator)
        ], ReferencedConfigurator);
        return ReferencedConfigurator;
    }(KbObject));

    var Configurator = /** @class */ (function (_super) {
        __extends(Configurator, _super);
        function Configurator(kom, obj) {
            var _this = this;
            var _a;
            _this = _super.call(this, kom) || this;
            _this.autoValidation = true;
            _this.kineticSettings = {
                createPart: false,
                autoCrtPart: false,
                notUnique: false,
                crtPartUsing: ""
            };
            /**
             * whether mouse over effects are enabled in the scene viewer
             */
            _this.mouseOverEffects = true;
            /**
             * the color that will be used for the emissive property of the mouse over materials
             */
            _this.mouseOverColor = '#131313';
            /**
             * when true, images in the scene will be prefetched to speed up performance of switching images/materials
             */
            _this.prefetchImages = true;
            /**
             * convienence property set by the configurator view to determine if the loaded rule had been
             * run for this configurator to prevent "double loading"
             */
            _this.$ranLoadedRule = false;
            _this._viewerMode = exports.eViewerMode.none;
            kom.recurse(obj, _this);
            _this.$fieldsDirty = false; // reset fields dirty after the recurse
            _this.$fieldsDirtyForSceneRules = true;
            _this.$manager.addKbObject(_this, undefined);
            // make sure the moms are tracked by the kom
            if (_this.methodOfManufacture) {
                _this.methodOfManufacture.name = (_a = _this.methodOfManufacture.name) !== null && _a !== void 0 ? _a : "Default Method";
                _this.methodOfManufacture.company = null;
                _this.methodOfManufacture.isDefault = true;
                _this.$manager.addKbObject(_this.methodOfManufacture, _this);
                _this.$manager.addKbObject(_this.methodOfManufacture.rootPartRev, _this.methodOfManufacture);
            }
            if (_this.methodsOfManufacture) {
                _this.methodsOfManufacture.forEach(function (method) {
                    var _a;
                    method.name = (_a = method.name) !== null && _a !== void 0 ? _a : "Method";
                    method.isDefault = false;
                    _this.$manager.addKbObject(method, _this);
                    _this.$manager.addKbObject(method.rootPartRev, method);
                });
            }
            _this.$rulesNode = { id: _this.id + "_rules", $type: "RulesNode", allowedChildren: function () { return [CToken.RuleContainer]; }, getParent: function () { return _this; } };
            _this.$actionsNode = { id: _this.id + "_actions", $type: "ActionsNode", allowedChildren: function () { return [CToken.ConfiguratorAction]; }, getParent: function () { return _this; } };
            _this.$functionsNode = { id: _this.id + "functions", $type: "FunctionsNode", allowedChildren: function () { return [CToken.ConfiguratorFunction]; }, getParent: function () { return _this; } };
            _this.$optionFiltersNode = { id: _this.id + "_filters", $type: "OptionFiltersNode", allowedChildren: function () { return [CToken.OptionFilter]; }, getParent: function () { return _this; } };
            _this.$referencedConfiguratorsNode = { id: _this.id + "_refConfigs", $type: "ReferencedConfiguratorsNode", allowedChildren: function () { return [CToken.ReferencedConfigurator]; }, getParent: function () { return _this; } };
            _this.$buildsNode = { id: _this.id + "_builds", $type: "BuildsNode", allowedChildren: function () { return [CToken.Build]; }, getParent: function () { return _this; } };
            _this.$hotspotsNode = { id: _this.id + "_hotspots", $type: "HotspotsNode", allowedChildren: function () { return [CToken.Hotspot]; }, getParent: function () { return _this; } };
            _this.$manufactureNode = { id: _this.id + "_manufacture", $type: "ManufactureNode", allowedChildren: function () { return [CToken.MethodOfManufacture]; }, getParent: function () { return _this; } };
            return _this;
        }
        Configurator_1 = Configurator;
        Object.defineProperty(Configurator.prototype, "layoutSettings", {
            get: function () {
                if (!this._layoutSettings)
                    this._layoutSettings = [];
                return this._layoutSettings;
            },
            set: function (val) {
                this._layoutSettings = val;
            },
            enumerable: false,
            configurable: true
        });
        Configurator.prototype.allowedChildren = function (rootType) {
            return [CToken.Page, CToken.OverlayPopup];
        };
        Object.defineProperty(Configurator.prototype, "methodsOfManufacture", {
            get: function () {
                if (!this._methodsOfManufacture)
                    this._methodsOfManufacture = [];
                return this._methodsOfManufacture;
            },
            set: function (val) {
                this._methodsOfManufacture = val;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Configurator.prototype, "viewerMode", {
            get: function () {
                return this._viewerMode;
            },
            set: function (val) {
                this.setProperty('viewerMode', val);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Configurator.prototype, "idScene", {
            get: function () {
                return this._idScene;
            },
            set: function (val) {
                this.setProperty('idScene', val);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Configurator.prototype, "pages", {
            get: function () {
                if (!this._pages)
                    this._pages = [];
                return this._pages;
            },
            set: function (val) {
                this._pages = val;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Configurator.prototype, "overlayPopups", {
            get: function () {
                if (!this._overlayPopups)
                    this._overlayPopups = [];
                return this._overlayPopups;
            },
            set: function (val) {
                this._overlayPopups = val;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Configurator.prototype, "builds", {
            get: function () {
                if (!this._builds)
                    this._builds = [];
                return this._builds;
            },
            set: function (val) {
                this._builds = val;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Configurator.prototype, "optionFilters", {
            get: function () {
                if (!this._optionFilters)
                    this._optionFilters = [];
                return this._optionFilters;
            },
            set: function (val) {
                this._optionFilters = val;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Configurator.prototype, "configurators", {
            get: function () {
                if (!this._configurators)
                    this._configurators = [];
                return this._configurators;
            },
            set: function (val) {
                this._configurators = val;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Configurator.prototype, "referencedConfigurators", {
            get: function () {
                if (!this._referencedConfigurators)
                    this._referencedConfigurators = [];
                return this._referencedConfigurators;
            },
            set: function (val) {
                this._referencedConfigurators = val;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Configurator.prototype, "referencedScenes", {
            get: function () {
                if (!this._referencedScenes)
                    this._referencedScenes = [];
                return this._referencedScenes;
            },
            set: function (val) {
                this._referencedScenes = val;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Configurator.prototype, "actions", {
            get: function () {
                if (!this._actions)
                    this._actions = [];
                return this._actions;
            },
            set: function (val) {
                this._actions = val;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Configurator.prototype, "functions", {
            get: function () {
                if (!this._functions)
                    this._functions = [];
                return this._functions;
            },
            set: function (val) {
                this._functions = val;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Configurator.prototype, "hotspots", {
            get: function () {
                if (!this._hotspots)
                    this._hotspots = [];
                return this._hotspots;
            },
            set: function (val) {
                this._hotspots = val;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Configurator.prototype, "ruleContainers", {
            get: function () {
                if (!this._ruleContainers)
                    this._ruleContainers = [];
                return this._ruleContainers;
            },
            set: function (val) {
                this._ruleContainers = val;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Configurator.prototype, "layoutContents", {
            get: function () {
                if (!this._layoutContents)
                    this._layoutContents = [];
                return this._layoutContents;
            },
            set: function (val) {
                this._layoutContents = val;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Configurator.prototype, "fields", {
            /**
             * v3 (v >= 3): the flat list of fields owned directly by the configurator. Replaces the nested
             * children/pages tree as the field source. Legacy (v < 3) configurators keep their fields in the UI
             * tree and leave this empty.
             */
            get: function () {
                if (!this._fields)
                    this._fields = [];
                return this._fields;
            },
            set: function (val) {
                this._fields = val;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Configurator.prototype, "folders", {
            /**
             * v3 (v >= 3): organizational folders for the admin field tree only. Never affects runtime rendering
             * (the renderer never inspects folderId). Flat array with parentId chains.
             */
            get: function () {
                if (!this._folders)
                    this._folders = [];
                return this._folders;
            },
            set: function (val) {
                this._folders = val;
            },
            enumerable: false,
            configurable: true
        });
        Configurator.prototype.isNested = function () {
            return !!this.$parent;
        };
        Configurator.prototype.allPages = function () {
            return this.getChildrenOfType(CToken.Page);
        };
        Configurator.prototype.allOverlayPopups = function () {
            return this.getChildrenOfType(CToken.OverlayPopup);
        };
        Configurator.prototype.allGroups = function () {
            return this.getChildrenOfType(CToken.Group);
        };
        /**
         *
         * @param token Gets all the UI children of the given types.
         * @param allChildren
         */
        Configurator.prototype.getChildrenOfType = function () {
            var tokens = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                tokens[_i] = arguments[_i];
            }
            // v3: the flat fields[] list is the only UI-child source; the legacy children/pages tree is
            // retained-but-ignored (a migrated scene may still carry v2 children � never surface them).
            // Routing all token queries through fields[] means: no-token => fields, [Field] => fields,
            // [Field,Button,...] => fields, [Page]/[Group]/etc. => [] (none exist in v3). Keyed off v >= 3.
            if (this.v >= 3) {
                return this.filterChildren(tokens, this.fields);
            }
            return this.filterChildren(tokens, this.children
                .concat(this.pages)
                .concat(this.overlayPopups)
                .concat(this.layoutContents.selectMany(function (lc) { return lc.children; })));
        };
        Configurator.prototype.allRuleContainers = function () {
            return this.ruleContainers
                .concat(this.actions)
                .concat(this.optionFilters)
                .concat(this.getFields())
                .concat(this.getOutputs());
        };
        Configurator.prototype.addPage = function () {
            var page = new Page(this.$manager);
            this.$manager.addKbObject(page, this);
            this.pages.push(page);
            return page;
        };
        Configurator.prototype.removePage = function (page) {
            this.$manager.removeKbObject(page);
            this.pages.remove(page);
        };
        Configurator.prototype.addOverlayPopup = function () {
            var overlayPopup = new OverlayPopup(this.$manager);
            this.$manager.addKbObject(overlayPopup, this);
            this.overlayPopups.push(overlayPopup);
            return overlayPopup;
        };
        Configurator.prototype.removeOverlayPopup = function (overlayPopup) {
            this.$manager.removeKbObject(overlayPopup);
            this.overlayPopups.remove(overlayPopup);
        };
        Configurator.prototype.addAction = function () {
            var action = new ConfiguratorAction(this.$manager);
            this.$manager.addKbObject(action, this);
            this.actions.push(action);
            return action;
        };
        Configurator.prototype.removeAction = function (action) {
            this.$manager.removeKbObject(action);
            this.actions.remove(action);
        };
        Configurator.prototype.addFunction = function () {
            var f = new ConfiguratorFunction(this.$manager);
            f.name = 'Function';
            this.$manager.addKbObject(f, this);
            this.functions.push(f);
            return f;
        };
        Configurator.prototype.removeFunction = function (f) {
            this.$manager.removeKbObject(f);
            this.functions.remove(f);
        };
        Configurator.prototype.addOptionFilter = function () {
            var st = new OptionFilter(this.$manager);
            this.$manager.addKbObject(st, this);
            this.optionFilters.push(st);
            return st;
        };
        Configurator.prototype.removeOptionFilter = function (optionFilter) {
            this.$manager.removeKbObject(optionFilter);
            this.optionFilters.remove(optionFilter);
        };
        Configurator.prototype.removeRuleContainer = function (rc) {
            this.$manager.removeKbObject(rc);
            this.ruleContainers.remove(rc);
        };
        Configurator.prototype.addHotspot = function () {
            var ann = new Hotspot(this.$manager);
            this.$manager.addKbObject(ann, this);
            this.hotspots.push(ann);
            return ann;
        };
        Configurator.prototype.removeHotspot = function (ann) {
            this.$manager.removeKbObject(ann);
            this.hotspots.remove(ann);
        };
        Configurator.prototype.addBuild = function (buildType) {
            var build;
            // we should only have one buildtype in a configurator
            var exists = this.builds.some(function (b) { return b.idBuildType == buildType.id; });
            if (!exists) {
                build = new Build(this.$manager);
                build.idBuildType = buildType.id;
                build.name = buildType.name;
                this.$manager.addKbObject(build, this);
                this.builds.push(build);
            }
            return build;
        };
        Configurator.prototype.removeBuild = function (build) {
            this.$manager.removeKbObject(build);
            this.builds.remove(build);
        };
        Configurator.prototype.addReferencedConfigurator = function (idProduct) {
            var rc = this.referencedConfigurators.find(function (rc) { return rc.idProduct == idProduct; });
            if (!rc) {
                rc = new ReferencedConfigurator(this.$manager);
                rc.idProduct = idProduct;
                this.referencedConfigurators.push(rc);
                this.$manager.addKbObject(rc, this);
            }
            return rc;
        };
        Configurator.prototype.removeReferencedConfigurator = function (rc) {
            this.$manager.removeKbObject(rc);
            this.referencedConfigurators.remove(rc);
        };
        Configurator.prototype.addReferencedScene = function (idScene) {
            if (!this.referencedScenes.find(function (rs) { return rs == idScene; })) {
                this.referencedScenes.push(idScene);
            }
        };
        Configurator.prototype.removeReferencedScene = function (rs) {
            this.referencedScenes.remove(rs);
        };
        Configurator.prototype.getNestedConfigurators = function () {
            var result = [];
            this.configurators.forEach(function (n) { return result.push(n); });
            this.allPages().forEach(function (p) {
                p.configurators.forEach(function (n) {
                    result.push(n);
                });
            });
            this.allOverlayPopups().forEach(function (p) {
                p.configurators.forEach(function (n) {
                    result.push(n);
                });
            });
            this.getChildrenOfType(CToken.NestedSet).forEach(function (ns) {
                ns.configurators.forEach(function (n) {
                    result.push(n);
                });
            });
            return result;
        };
        /**
         * get's all configurators, including children of children, etc.
         */
        Configurator.prototype.getAllConfigurators = function () {
            var allNested = [];
            var addToNested = function (config) {
                var nestedConfigs = config.getNestedConfigurators();
                allNested.pushArray(nestedConfigs);
                nestedConfigs.forEach(function (n) { return addToNested(n); });
            };
            addToNested(this);
            return allNested;
        };
        Configurator.prototype.hasRule = function (ruleType) {
            var rc = this.ruleContainers.find(function (rc) {
                return rc.ruleType.isEqual(ruleType);
            });
            return rc != null && rc.js && rc.js.length > 0;
        };
        /**
         * gets a concatinated javascript rule for the specified rule type
         */
        Configurator.prototype.getRuleJs = function (ruleType) {
            var rc = this.ruleContainers.find(function (rc) {
                return rc.ruleType.isEqual(ruleType);
            });
            return rc ? this.getRuleJsFromContainer(rc) : '';
        };
        Configurator.prototype.getRuleJsFromContainer = function (ruleContainer) {
            // global rule should always be included
            var globalRc = this.ruleContainers.find(function (rc) { return rc.ruleType.isEqual(exports.eRuleType.global); });
            var globalJs = globalRc ? globalRc.js + '\n\n' : '';
            return globalJs + ruleContainer.js;
        };
        Configurator.prototype.preValidate = function () {
            this.getFields().forEach(function (field) { return field.preValidate(); });
        };
        Configurator.prototype.isValid = function () {
            var v = true;
            for (var _i = 0, _a = this.pages; _i < _a.length; _i++) {
                var page = _a[_i];
                if (!page.isValid()) {
                    v = false;
                }
            }
            for (var _b = 0, _c = this.overlayPopups; _b < _c.length; _b++) {
                var overlayPopup = _c[_b];
                if (!overlayPopup.isValid()) {
                    v = false;
                }
            }
            for (var _d = 0, _e = this.configurators; _d < _e.length; _d++) {
                var config = _e[_d];
                if (!config.isValid()) {
                    v = false;
                }
            }
            this.$valid = v;
            return this.$valid;
        };
        /**
         * Sets field values based on an object whose properties are field names and values are the field values to set
         */
        Configurator.prototype.setFields = function (fields) {
            for (var prop in fields) {
                if (fields.hasOwnProperty(prop)) {
                    var field = this.$manager.getByIdOrName(prop, false);
                    if (field) {
                        field.value = fields[prop];
                    }
                }
            }
        };
        Configurator.prototype.getOutputs = function (predicate) {
            var result = [];
            var process = function (o) {
                if (predicate) {
                    if (predicate(o)) {
                        result.push(o);
                    }
                }
                else {
                    result.push(o);
                }
            };
            this.builds.forEach(function (b) {
                b.outputs.forEach(function (o) {
                    process(o);
                    if (ConfiguratorDI.instanceOf(o, CToken.CadOutput)) {
                        o.drawings.forEach(process);
                    }
                });
            });
            return result;
        };
        Configurator.prototype.getExports = function (predicate) {
            var exports = [];
            var outputs = this.getOutputs();
            for (var _i = 0, outputs_1 = outputs; _i < outputs_1.length; _i++) {
                var o = outputs_1[_i];
                for (var _a = 0, _b = o.exports; _a < _b.length; _a++) {
                    var exp = _b[_a];
                    if ((predicate && predicate(exp)) || !predicate) {
                        exports.push(exp);
                    }
                }
            }
            return exports;
        };
        Configurator.prototype.getFields = function (predicate) {
            var fields = this.getChildrenOfType(CToken.Field);
            return predicate ? fields.filter(function (f) { return predicate(f); }) : fields;
        };
        Configurator.prototype.getGroups = function (predicate) {
            var groups = this.getChildrenOfType(CToken.Group);
            return predicate ? groups.filter(function (g) { return predicate(g); }) : groups;
        };
        Configurator.prototype.getFieldsObject = function () {
            var fields = this.getFields();
            var o = {};
            fields.forEach(function (field) {
                o[field.name] = field.value;
            });
            return o;
        };
        Configurator.prototype.runConfiguredProduct = function (configProduct, productDb) {
            var _this = this;
            if (configProduct.fields) {
                configProduct.fields.forEach(function (fieldRec) {
                    var field = _this.$manager.get(fieldRec.id, false);
                    if (!field)
                        field = _this.$manager.getByName(fieldRec.name, false);
                    if (field && field.$type == CToken.Field.key) {
                        if (field.type == exports.eFieldType.text || field.type == exports.eFieldType.color) {
                            field.value = fieldRec.stringValue;
                        }
                        else if (field.type == exports.eFieldType.number) {
                            field.value = fieldRec.numberValue;
                        }
                        else if (field.type == exports.eFieldType.boolean) {
                            field.value = fieldRec.booleanValue;
                        }
                        else if (field.type == exports.eFieldType.date) {
                            field.value = fieldRec.dateValue;
                        }
                        else if (field.type == exports.eFieldType.upload) {
                            field.value = fieldRec.uploadValue;
                        }
                        else if (field.type == exports.eFieldType.textArray || field.type == exports.eFieldType.colorArray) {
                            field.value = fieldRec.stringArrayValue;
                        }
                        else if (field.type == exports.eFieldType.numberArray) {
                            field.value = fieldRec.numberArrayValue;
                        }
                        else {
                            throw new Error('not implemented');
                        }
                        // } else if (field.type == eFieldType.date) {
                        //    field.value = (<IDateFieldRecording>fieldRec).dateValue;
                        // } else if (field.type == eFieldType.object) {
                        //    field.value = (<IObjectFieldRecording>fieldRec).objectValue;
                        // } else if (field.type == eFieldType.array) {
                        //    throw "not implemented";
                        // }
                    }
                });
            }
            if (configProduct.configurators) {
                configProduct.configurators.forEach(function (nestRec) {
                    var parent = _this.$manager.get(nestRec.idParent, false) || _this;
                    var nested = parent.configurators.find(function (c) { return c.name.isEqual(nestRec.name); });
                    if (!nested) {
                        nested = new Configurator_1(new KbObjectManager(), productDb[nestRec.idProduct].configurator);
                        nested.$running = _this.$running;
                        nested.name = nestRec.name;
                        parent.configurators.push(nested);
                        _this.$manager.addKbObject(nested, parent);
                        nested.addedByUser = nestRec.addedByUser;
                        nested.allowUserToRemove = nestRec.allowUserToRemove;
                        nested.addAsQuoteProduct = nestRec.addAsQuoteProduct;
                        nested.kineticViewOnly = nestRec.kineticViewOnly;
                    }
                    // v3 nested-set hosts only exist in layoutHtml and are not in
                    // the persistent object graph. Unknown parents therefore fall
                    // back to this configurator while retaining their host id for
                    // the next configured-product round trip.
                    if (parent === _this && nestRec.idParent && nestRec.idParent !== _this.id && _this.v >= 3) {
                        nested.$v3LayoutParentId = nestRec.idParent;
                    }
                    nested.runConfiguredProduct(nestRec, productDb);
                });
            }
        };
        /**
         * gets the configured product of the configurator.  WithDesiredValues should only be
         * set to true when sending to the server to run option filters.  It sends the desiredValue of the fields
         * as opposed to the calculated value based on options.
         * @param withDesiredValues
         */
        Configurator.prototype.getConfiguredProduct = function (withDesiredValues) {
            if (withDesiredValues === void 0) { withDesiredValues = false; }
            var getFieldValue = function (field) {
                if (withDesiredValues && field.idOptionFilter && field.canJoinOptionFilter()) {
                    return field.desiredValue;
                }
                else {
                    return field.value;
                }
            };
            var configProduct = {
                configurators: [],
                fields: [],
                name: this.name,
                entityType: this.entityType,
                idProduct: this.idProduct,
                idQuoteHeader: this.idQuoteHeader,
                addedByUser: this.addedByUser,
                allowUserToRemove: this.allowUserToRemove,
                idParent: this.$v3LayoutParentId || (this.$parent && this.$parent.id),
                idScene: this.idScene,
                validationMessages: [],
                parameters: this.parameters,
                sku: this.sku,
                addAsQuoteProduct: this.addAsQuoteProduct,
                kineticViewOnly: this.kineticViewOnly,
            };
            this.getFields().forEach(function (field) {
                var fieldRec = {
                    id: field.id,
                    name: field.name,
                };
                configProduct.fields.push(fieldRec);
                if (field.type == exports.eFieldType.text || field.type == exports.eFieldType.color) {
                    fieldRec.stringValue = getFieldValue(field);
                }
                else if (field.type == exports.eFieldType.number) {
                    fieldRec.numberValue = getFieldValue(field);
                }
                else if (field.type == exports.eFieldType.boolean) {
                    fieldRec.booleanValue = getFieldValue(field);
                }
                else if (field.type == exports.eFieldType.date) {
                    fieldRec.dateValue = getFieldValue(field);
                }
                else if (field.type == exports.eFieldType.upload) {
                    fieldRec.uploadValue = getFieldValue(field);
                }
                else if (field.type == exports.eFieldType.textArray || field.type == exports.eFieldType.colorArray) {
                    fieldRec.stringArrayValue = getFieldValue(field);
                }
                else if (field.type == exports.eFieldType.numberArray) {
                    fieldRec.numberArrayValue = getFieldValue(field);
                }
                else {
                    throw new Error('not implemented');
                }
                field.validationErrors.forEach(function (err) {
                    configProduct.validationMessages.push({
                        messageType: exports.eValidationType.error,
                        object: { id: field.id, name: field.$label },
                        message: err.message,
                    });
                });
                field.warnings.forEach(function (warn) {
                    configProduct.validationMessages.push({
                        messageType: exports.eValidationType.warning,
                        object: { id: field.id, name: field.$label },
                        message: warn.message,
                    });
                });
                // } else if (field.type == eFieldType.date) {
                //    (<IDateFieldRecording>fieldRec).dateValue = field.value;
                // } else if (field.type == eFieldType.object) {
                //    (<IObjectFieldRecording>fieldRec).objectValue = field.value;
                // } else if (field.type == eFieldType.array) {
                //    throw "not implemented";
                // }
            });
            this.getNestedConfigurators().forEach(function (nested) {
                var configuredNested = nested.getConfiguredProduct(withDesiredValues);
                configProduct.configurators.push(configuredNested);
            });
            return configProduct;
        };
        Configurator.prototype.hasErrors = function () {
            var configProduct = this.getConfiguredProduct();
            var result = configProduct.validationMessages.some(function (m) { return m.messageType === exports.eValidationType.error; }) || this.getNestedConfigurators().some(function (nested) { return nested.hasErrors(); });
            if (result)
                return true;
            return false;
        };
        Configurator.prototype.filtersShouldRunOnClient = function () {
            return !(this.optionFilters.some(function (o) { return o.source == exports.eOptionFilterSource.database; }) ||
                this.optionFilters.some(function (o) { return o.source == exports.eOptionFilterSource.safeFunction; }) ||
                this.optionFilters.some(function (o) { return o.source == exports.eOptionFilterSource.query && o.queryMode == exports.eQueryMode.database; }));
        };
        Configurator.prototype.getPartMaterial = function (mtlPartNum, methodOfManufacture) {
            var result = null;
            var recurse = function (material) {
                if (result)
                    return;
                if (material.mtlPartNum == mtlPartNum)
                    result = material;
                if (material.materials) {
                    for (var i in material.materials) {
                        recurse(material.materials[i]);
                    }
                }
            };
            if (methodOfManufacture) {
                if (methodOfManufacture.partNum == mtlPartNum || methodOfManufacture.mtlPartNum == mtlPartNum)
                    return methodOfManufacture;
                for (var i in methodOfManufacture.materials) {
                    recurse(methodOfManufacture.materials[i]);
                }
            }
            return result;
        };
        Configurator.prototype.getPartOperation = function (opCode, methodOfManufacture) {
            var result = null;
            var recurse = function (material) {
                if (result)
                    return;
                for (var i in material.operations) {
                    if (material.operations[i].opCode == opCode)
                        result = material.operations[i];
                }
                if (material.materials) {
                    for (var i in material.materials) {
                        recurse(material.materials[i]);
                    }
                }
            };
            if (methodOfManufacture) {
                for (var i in methodOfManufacture.operations) {
                    if (methodOfManufacture.operations[i].opCode == opCode)
                        result = methodOfManufacture.operations[i];
                }
                for (var i in methodOfManufacture.materials) {
                    recurse(methodOfManufacture.materials[i]);
                }
            }
            return result;
        };
        Configurator.prototype.getPartOperationDetail = function (id, methodOfManufacture) {
            var result = null;
            var recurse = function (material) {
                if (result)
                    return;
                for (var i in material.operations) {
                    for (var j in material.operations[i]) {
                        var opDtl = material.operations[i].operationDetails[j];
                        if (opDtl.resourceID == id || opDtl.resourceGrpID == id)
                            result = opDtl;
                    }
                }
                if (material.materials) {
                    for (var i in material.materials) {
                        recurse(material.materials[i]);
                    }
                }
            };
            if (methodOfManufacture) {
                for (var i in methodOfManufacture.operations) {
                    for (var j in methodOfManufacture.operations[i].operationDetails) {
                        var opDtl = methodOfManufacture.operations[i].operationDetails[j];
                        if (opDtl.resourceID == id || opDtl.resourceGrpID == id)
                            result = opDtl;
                    }
                }
                for (var i in methodOfManufacture.materials) {
                    recurse(methodOfManufacture.materials[i]);
                }
            }
            return result;
        };
        var Configurator_1;
        __decorate([
            Enumerable()
        ], Configurator.prototype, "layoutSettings", null);
        __decorate([
            Enumerable()
        ], Configurator.prototype, "methodsOfManufacture", null);
        __decorate([
            Enumerable()
        ], Configurator.prototype, "viewerMode", null);
        __decorate([
            Enumerable()
        ], Configurator.prototype, "idScene", null);
        __decorate([
            Enumerable()
        ], Configurator.prototype, "pages", null);
        __decorate([
            Enumerable()
        ], Configurator.prototype, "overlayPopups", null);
        __decorate([
            Enumerable()
        ], Configurator.prototype, "builds", null);
        __decorate([
            Enumerable()
        ], Configurator.prototype, "optionFilters", null);
        __decorate([
            Enumerable()
        ], Configurator.prototype, "configurators", null);
        __decorate([
            Enumerable()
        ], Configurator.prototype, "referencedConfigurators", null);
        __decorate([
            Enumerable()
        ], Configurator.prototype, "referencedScenes", null);
        __decorate([
            Enumerable()
        ], Configurator.prototype, "actions", null);
        __decorate([
            Enumerable()
        ], Configurator.prototype, "functions", null);
        __decorate([
            Enumerable()
        ], Configurator.prototype, "hotspots", null);
        __decorate([
            Enumerable()
        ], Configurator.prototype, "ruleContainers", null);
        __decorate([
            Enumerable()
        ], Configurator.prototype, "layoutContents", null);
        __decorate([
            Enumerable()
        ], Configurator.prototype, "fields", null);
        __decorate([
            Enumerable()
        ], Configurator.prototype, "folders", null);
        Configurator = Configurator_1 = __decorate([
            Kbo(CToken.Configurator)
        ], Configurator);
        return Configurator;
    }(Container));

    var DropdownButton = /** @class */ (function (_super) {
        __extends(DropdownButton, _super);
        function DropdownButton(kom) {
            return _super.call(this, kom) || this;
        }
        Object.defineProperty(DropdownButton.prototype, "buttons", {
            get: function () {
                if (!this._buttons)
                    this._buttons = [];
                return this._buttons;
            },
            set: function (val) {
                this._buttons = val;
            },
            enumerable: false,
            configurable: true
        });
        DropdownButton.prototype.getChildrenOfType = function () {
            var tokens = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                tokens[_i] = arguments[_i];
            }
            return this.filterChildren(tokens, this.buttons);
        };
        DropdownButton.prototype.allowedChildren = function (rootType) {
            return [
                CToken.Button
            ];
        };
        __decorate([
            Enumerable()
        ], DropdownButton.prototype, "buttons", null);
        DropdownButton = __decorate([
            Kbo(CToken.DropdownButton)
        ], DropdownButton);
        return DropdownButton;
    }(Button));

    var Expander = /** @class */ (function (_super) {
        __extends(Expander, _super);
        function Expander(kom) {
            return _super.call(this, kom) || this;
        }
        Object.defineProperty(Expander.prototype, "children", {
            get: function () {
                if (!this._children)
                    this._children = [];
                return this._children;
            },
            set: function (val) {
                this._children = val;
            },
            enumerable: false,
            configurable: true
        });
        Expander.prototype.getChildrenOfType = function () {
            var tokens = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                tokens[_i] = arguments[_i];
            }
            return this.filterChildren(tokens, this.children);
        };
        Expander.prototype.allowedChildren = function (rootType) {
            var c = this.containerChildren(rootType);
            c.removeWhere(function (c) { return c.key.equalsAny(//don't allow expanders in expanders
            CToken.Accordion.key, CToken.Expander.key); });
            return c;
        };
        __decorate([
            Enumerable()
        ], Expander.prototype, "children", null);
        Expander = __decorate([
            Kbo(CToken.Expander)
        ], Expander);
        return Expander;
    }(UiObject));

    var GridColumn = /** @class */ (function (_super) {
        __extends(GridColumn, _super);
        function GridColumn(kom) {
            return _super.call(this, kom) || this;
        }
        Object.defineProperty(GridColumn.prototype, "children", {
            get: function () {
                if (!this._children)
                    this._children = [];
                return this._children;
            },
            set: function (val) {
                this._children = val;
            },
            enumerable: false,
            configurable: true
        });
        GridColumn.prototype.getChildrenOfType = function () {
            var tokens = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                tokens[_i] = arguments[_i];
            }
            return this.filterChildren(tokens, this.children);
        };
        GridColumn.prototype.allowedChildren = function (rootType) {
            return this.containerChildren(rootType);
        };
        __decorate([
            Enumerable()
        ], GridColumn.prototype, "children", null);
        GridColumn = __decorate([
            Kbo(CToken.GridColumn)
        ], GridColumn);
        return GridColumn;
    }(UiObject));

    var GridRow = /** @class */ (function (_super) {
        __extends(GridRow, _super);
        function GridRow(kom) {
            return _super.call(this, kom) || this;
        }
        Object.defineProperty(GridRow.prototype, "columns", {
            get: function () {
                if (!this._columns)
                    this._columns = [];
                return this._columns;
            },
            set: function (val) {
                this._columns = val;
            },
            enumerable: false,
            configurable: true
        });
        // public visible: boolean;
        GridRow.prototype.getChildrenOfType = function () {
            var tokens = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                tokens[_i] = arguments[_i];
            }
            return this.filterChildren(tokens, this.columns);
        };
        GridRow.prototype.allowedChildren = function (rootType) {
            // implement in derived classes
            return [
                CToken.GridColumn
            ];
        };
        __decorate([
            Enumerable()
        ], GridRow.prototype, "columns", null);
        GridRow = __decorate([
            Kbo(CToken.GridRow)
        ], GridRow);
        return GridRow;
    }(UiObject));

    var Html = /** @class */ (function (_super) {
        __extends(Html, _super);
        function Html(kom) {
            var _this = _super.call(this, kom, { ruleType: exports.eRuleType.html }) || this;
            _this.ruleContainers = [];
            _this.$rulesNode = { id: _this.id + "_rules", $type: "RulesNode", allowedChildren: function () { return [CToken.Rule]; }, getParent: function () { return _this; } };
            return _this;
        }
        Html = __decorate([
            Kbo(CToken.Html)
        ], Html);
        return Html;
    }(UiObject));

    var LayoutConfig = /** @class */ (function (_super) {
        __extends(LayoutConfig, _super);
        function LayoutConfig(kom, obj) {
            var _this = _super.call(this, kom) || this;
            kom.recurse(obj, _this);
            _this.$manager.addKbObject(_this, undefined);
            _this.$layoutSettingsDirty = false; // reset fields dirty after the recurse
            _this.$rulesNode = { id: _this.id + "_rules", $type: "RulesNode", allowedChildren: function () { return [CToken.Rule]; }, getParent: function () { return _this; } };
            _this.$settingsNode = { id: _this.id + "_settings", $type: "SettingsNode", allowedChildren: function () { return []; }, getParent: function () { return _this; } };
            return _this;
        }
        Object.defineProperty(LayoutConfig.prototype, "ruleContainers", {
            get: function () {
                if (!this._ruleContainers)
                    this._ruleContainers = [];
                return this._ruleContainers;
            },
            set: function (val) {
                this._ruleContainers = val;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(LayoutConfig.prototype, "settings", {
            get: function () {
                if (!this._settings)
                    this._settings = [];
                return this._settings;
            },
            set: function (val) {
                this._settings = val;
            },
            enumerable: false,
            configurable: true
        });
        LayoutConfig.prototype.filterChildren = function (tokens, allChildren) {
            var list = [];
            var _loop_1 = function (c) {
                if (!tokens.length || tokens.some(function (t) { return ConfiguratorDI.instanceOf(c, t); })) {
                    list.push(c);
                }
                c.getChildrenOfType.apply(c, tokens).forEach(function (c2) { return list.push(c2); });
            };
            for (var _i = 0, allChildren_1 = allChildren; _i < allChildren_1.length; _i++) {
                var c = allChildren_1[_i];
                _loop_1(c);
            }
            return list;
        };
        /**
         *
         * @param token Gets all the UI children of the given types.
         * @param allChildren
         */
        LayoutConfig.prototype.getChildrenOfType = function () {
            var tokens = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                tokens[_i] = arguments[_i];
            }
            return this.filterChildren(tokens, this.children);
        };
        LayoutConfig.prototype.hasRule = function (ruleType) {
            var rc = this.ruleContainers.find(function (rc) {
                return rc.ruleType.isEqual(ruleType);
            });
            return (rc != null && rc.js && rc.js.length > 0);
        };
        /**
         * gets a concatinated javascript rule for the specified rule type
         */
        LayoutConfig.prototype.getRuleJs = function (ruleType) {
            var rc = this.ruleContainers.find(function (rc) {
                return rc.ruleType.isEqual(ruleType);
            });
            return rc ? this.getRuleJsFromContainer(rc) : "";
        };
        LayoutConfig.prototype.getRuleJsFromContainer = function (ruleContainer) {
            // global rule should always be included
            var globalRc = this.ruleContainers.find(function (rc) { return rc.ruleType.isEqual(exports.eRuleType.global); });
            var globalJs = globalRc ? globalRc.js + "\n\n" : "";
            return globalJs + ruleContainer.js;
        };
        LayoutConfig.prototype.addSettingsGroup = function () {
            var g = new Group(this.$manager);
            this.$manager.addKbObject(g, this);
            this.settings.push(g);
            return g;
        };
        LayoutConfig.prototype.removeSettingsGroup = function (g) {
            this.$manager.removeKbObject(g);
            this.settings.remove(g);
        };
        LayoutConfig.prototype.addSettingsField = function (group) {
            var f = new Field(this.$manager);
            this.$manager.addKbObject(f, group);
            group.children.push(f);
            return f;
        };
        LayoutConfig.prototype.removeSettingsField = function (f) {
            this.$manager.removeKbObject(f);
            f.$parent.children.remove(f);
        };
        LayoutConfig.prototype.removeRuleContainer = function (rc) {
            this.$manager.removeKbObject(rc);
            this.ruleContainers.remove(rc);
        };
        /**
         * returns a flat array of the layout children that are
         * content containers meant for consumers to fill in with content
         */
        LayoutConfig.prototype.getContentContainers = function () {
            var children = this.getChildrenOfType(CToken.Container, CToken.PageControl, CToken.OverlayPopupControl);
            return this.getChildrenOfType(CToken.Container, CToken.PageControl, CToken.OverlayPopupControl).filter(function (c) { return !ConfiguratorDI.instanceOf(c, CToken.Container) || c.isPlaceholder; });
        };
        __decorate([
            Enumerable()
        ], LayoutConfig.prototype, "ruleContainers", null);
        __decorate([
            Enumerable()
        ], LayoutConfig.prototype, "settings", null);
        LayoutConfig = __decorate([
            Kbo(CToken.LayoutConfig)
        ], LayoutConfig);
        return LayoutConfig;
    }(Container));

    var LayoutContent = /** @class */ (function (_super) {
        __extends(LayoutContent, _super);
        function LayoutContent(kom) {
            return _super.call(this, kom) || this;
        }
        Object.defineProperty(LayoutContent.prototype, "children", {
            get: function () {
                if (!this._children)
                    this._children = [];
                return this._children;
            },
            set: function (val) {
                this._children = val;
            },
            enumerable: false,
            configurable: true
        });
        LayoutContent.prototype.getChildrenOfType = function () {
            var tokens = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                tokens[_i] = arguments[_i];
            }
            return this.filterChildren(tokens, this.children);
        };
        LayoutContent.prototype.allowedChildren = function (rootType) {
            if (rootType == CToken.Configurator && this.contentType == CToken.Container.key) {
                return this.containerChildren(rootType);
            }
            else {
                return [];
            }
        };
        __decorate([
            Enumerable()
        ], LayoutContent.prototype, "children", null);
        LayoutContent = __decorate([
            Kbo(CToken.LayoutContent)
        ], LayoutContent);
        return LayoutContent;
    }(UiObject));

    var Media = /** @class */ (function (_super) {
        __extends(Media, _super);
        function Media(kom) {
            return _super.call(this, kom) || this;
        }
        Media = __decorate([
            Kbo(CToken.Media)
        ], Media);
        return Media;
    }(UiObject));

    var PartRev = /** @class */ (function (_super) {
        __extends(PartRev, _super);
        function PartRev(kom, data) {
            var _this = _super.call(this, kom) || this;
            _this._metadata = {};
            _this.$materialsNode = { id: _this.id + "_materials", $type: "MaterialsNode", allowedChildren: function () { return [CToken.PartMaterial]; }, getParent: function () { return _this; } };
            _this.$operationsNode = { id: _this.id + "_operations", $type: "OperationsNode", allowedChildren: function () { return [CToken.PartOperation]; }, getParent: function () { return _this; } };
            _this._metadata = {};
            for (var key in data) {
                var value = data[key];
                if (!Array.isArray(value))
                    _this[key] = value;
            }
            return _this;
        }
        PartRev.getMetadataProperties = function () {
            return [];
        };
        Object.defineProperty(PartRev.prototype, "materials", {
            get: function () {
                if (!this._materials)
                    this._materials = [];
                return this._materials;
            },
            set: function (val) {
                this._materials = val;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(PartRev.prototype, "operations", {
            get: function () {
                if (!this._operations)
                    this._operations = [];
                return this._operations;
            },
            set: function (val) {
                this._operations = val;
            },
            enumerable: false,
            configurable: true
        });
        PartRev.prototype.getIdentifyingProperty = function () {
            return "partNum";
        };
        __decorate([
            Enumerable()
        ], PartRev.prototype, "materials", null);
        __decorate([
            Enumerable()
        ], PartRev.prototype, "operations", null);
        PartRev = __decorate([
            Kbo(CToken.PartRev)
        ], PartRev);
        return PartRev;
    }(KbObject));

    var MethodOfManufacture = /** @class */ (function (_super) {
        __extends(MethodOfManufacture, _super);
        function MethodOfManufacture(kom) {
            var _this = _super.call(this, kom) || this;
            _this.rootPartRev = new PartRev(kom, { partNum: "Part Revision" });
            _this.ruleType = exports.eRuleType.manufacture;
            _this.company = null;
            _this.isDefault = false;
            _this.$rulesNode = { id: _this.id + "_rules", $type: "RulesNode", allowedChildren: function () { return [CToken.Rule]; }, getParent: function () { return _this; } };
            return _this;
        }
        MethodOfManufacture = __decorate([
            Kbo(CToken.MethodOfManufacture)
        ], MethodOfManufacture);
        return MethodOfManufacture;
    }(RuleContainer));
    var BistrackMethodOfManufacture = /** @class */ (function (_super) {
        __extends(BistrackMethodOfManufacture, _super);
        function BistrackMethodOfManufacture(kom) {
            var _this = _super.call(this, kom) || this;
            _this.rootPartRev = new BistrackPartRev(kom, { partNum: "Part Revision" });
            _this.ruleType = exports.eRuleType.bistrackManufacture;
            _this.$rulesNode = { id: _this.id + "_rules", $type: "RulesNode", allowedChildren: function () { return [CToken.Rule]; }, getParent: function () { return _this; } };
            return _this;
        }
        BistrackMethodOfManufacture = __decorate([
            Kbo(CToken.BistrackMethodOfManufacture)
        ], BistrackMethodOfManufacture);
        return BistrackMethodOfManufacture;
    }(RuleContainer));

    var NestedElement = /** @class */ (function (_super) {
        __extends(NestedElement, _super);
        function NestedElement(kom) {
            return _super.call(this, kom) || this;
        }
        Object.defineProperty(NestedElement.prototype, "configurator", {
            get: function () {
                return this._configurator;
            },
            set: function (val) {
                this._configurator = val;
            },
            enumerable: false,
            configurable: true
        });
        NestedElement = __decorate([
            Kbo(CToken.NestedElement)
        ], NestedElement);
        return NestedElement;
    }(UiObject));

    var NestedSet = /** @class */ (function (_super) {
        __extends(NestedSet, _super);
        function NestedSet(kom) {
            return _super.call(this, kom, { ruleType: exports.eRuleType.nestedSetSelected }) || this;
        }
        Object.defineProperty(NestedSet.prototype, "configurators", {
            get: function () {
                if (!this._configurators)
                    this._configurators = [];
                return this._configurators;
            },
            set: function (val) {
                this._configurators = val;
            },
            enumerable: false,
            configurable: true
        });
        __decorate([
            Enumerable()
        ], NestedSet.prototype, "configurators", null);
        NestedSet = __decorate([
            Kbo(CToken.NestedSet)
        ], NestedSet);
        return NestedSet;
    }(UiObject));

    var Option = /** @class */ (function () {
        function Option() {
        }
        Option = __decorate([
            Kbo(CToken.Option)
        ], Option);
        return Option;
    }());

    var OutputField = /** @class */ (function (_super) {
        __extends(OutputField, _super);
        function OutputField(kom) {
            return _super.call(this, kom) || this;
        }
        /**
         * OBSOLETE - use ConfiguratorDI.getNewOutputField instead
         * This is here for backwards compatibility
         * @param fieldType
         * @param kom
         * @param args
         */
        OutputField.getNewOutputFieldOfType = function (fieldType, kom, args) {
            return ConfiguratorDI.getNewOutputField(fieldType, kom, args);
        };
        OutputField = __decorate([
            Kbo(CToken.OutputField)
        ], OutputField);
        return OutputField;
    }(KbObject));

    var CadAnnotationField = /** @class */ (function (_super) {
        __extends(CadAnnotationField, _super);
        function CadAnnotationField(kom) {
            return _super.call(this, kom) || this;
        }
        CadAnnotationField = __decorate([
            KboOutputField(CToken.CadAnnotationField, exports.eOutputFieldType.cadAnnotation)
        ], CadAnnotationField);
        return CadAnnotationField;
    }(OutputField));

    var CadBlockArrayField = /** @class */ (function (_super) {
        __extends(CadBlockArrayField, _super);
        function CadBlockArrayField(kom) {
            return _super.call(this, kom) || this;
        }
        CadBlockArrayField = __decorate([
            KboOutputField(CToken.CadBlockArrayField, exports.eOutputFieldType.cadBlockArray)
        ], CadBlockArrayField);
        return CadBlockArrayField;
    }(OutputField));

    var CadBlockField = /** @class */ (function (_super) {
        __extends(CadBlockField, _super);
        function CadBlockField(kom) {
            return _super.call(this, kom) || this;
        }
        CadBlockField = __decorate([
            KboOutputField(CToken.CadBlockField, exports.eOutputFieldType.cadBlock)
        ], CadBlockField);
        return CadBlockField;
    }(OutputField));

    var CadComponentField = /** @class */ (function (_super) {
        __extends(CadComponentField, _super);
        function CadComponentField(kom) {
            return _super.call(this, kom) || this;
        }
        CadComponentField = __decorate([
            KboOutputField(CToken.CadComponentField, exports.eOutputFieldType.cadComponent)
        ], CadComponentField);
        return CadComponentField;
    }(OutputField));

    var CadCustomPropertyField = /** @class */ (function (_super) {
        __extends(CadCustomPropertyField, _super);
        function CadCustomPropertyField(kom) {
            return _super.call(this, kom) || this;
        }
        CadCustomPropertyField = __decorate([
            KboOutputField(CToken.CadCustomPropertyField, exports.eOutputFieldType.cadCustomProperty)
        ], CadCustomPropertyField);
        return CadCustomPropertyField;
    }(OutputField));

    var CadDimensionField = /** @class */ (function (_super) {
        __extends(CadDimensionField, _super);
        function CadDimensionField(kom) {
            return _super.call(this, kom) || this;
        }
        CadDimensionField = __decorate([
            KboOutputField(CToken.CadDimensionField, exports.eOutputFieldType.cadDimension)
        ], CadDimensionField);
        return CadDimensionField;
    }(OutputField));

    var CadDrawingAnnotationField = /** @class */ (function (_super) {
        __extends(CadDrawingAnnotationField, _super);
        function CadDrawingAnnotationField(kom) {
            return _super.call(this, kom) || this;
        }
        CadDrawingAnnotationField = __decorate([
            KboOutputField(CToken.CadDrawingAnnotationField, exports.eOutputFieldType.cadDrawingAnnotation)
        ], CadDrawingAnnotationField);
        return CadDrawingAnnotationField;
    }(OutputField));

    var CadDrawingDimensionField = /** @class */ (function (_super) {
        __extends(CadDrawingDimensionField, _super);
        function CadDrawingDimensionField(kom) {
            return _super.call(this, kom) || this;
        }
        CadDrawingDimensionField = __decorate([
            KboOutputField(CToken.CadDrawingDimensionField, exports.eOutputFieldType.cadDrawingDimension)
        ], CadDrawingDimensionField);
        return CadDrawingDimensionField;
    }(OutputField));

    var CadDrawingSheetField = /** @class */ (function (_super) {
        __extends(CadDrawingSheetField, _super);
        function CadDrawingSheetField(kom) {
            return _super.call(this, kom) || this;
        }
        CadDrawingSheetField = __decorate([
            KboOutputField(CToken.CadDrawingSheetField, exports.eOutputFieldType.cadDrawingSheet)
        ], CadDrawingSheetField);
        return CadDrawingSheetField;
    }(OutputField));

    var CadDrawingViewField = /** @class */ (function (_super) {
        __extends(CadDrawingViewField, _super);
        function CadDrawingViewField(kom) {
            return _super.call(this, kom) || this;
        }
        CadDrawingViewField = __decorate([
            KboOutputField(CToken.CadDrawingViewField, exports.eOutputFieldType.cadDrawingView)
        ], CadDrawingViewField);
        return CadDrawingViewField;
    }(OutputField));

    var CadDynamicComponentField = /** @class */ (function (_super) {
        __extends(CadDynamicComponentField, _super);
        function CadDynamicComponentField(kom) {
            var _this = _super.call(this, kom) || this;
            _this.addConstraint = function (constraintType, args) {
                var constraint = OutputField.getNewOutputFieldOfType(constraintType, _this.$manager, args);
                constraint.type = constraintType;
                _this.$manager.addKbObject(constraint, _this);
                _this.constraints.push(constraint);
                return constraint;
            };
            _this.removeConstraint = function (constraint) {
                _this.$manager.removeKbObject(constraint);
                _this.constraints.remove(constraint);
            };
            return _this;
        }
        Object.defineProperty(CadDynamicComponentField.prototype, "constraints", {
            get: function () {
                if (!this._constraints)
                    this._constraints = [];
                return this._constraints;
            },
            set: function (val) {
                this._constraints = val;
            },
            enumerable: false,
            configurable: true
        });
        __decorate([
            Enumerable()
        ], CadDynamicComponentField.prototype, "constraints", null);
        CadDynamicComponentField = __decorate([
            KboOutputField(CToken.CadDynamicComponentField, exports.eOutputFieldType.cadDynamicComponent)
        ], CadDynamicComponentField);
        return CadDynamicComponentField;
    }(OutputField));

    var CadDynamicDrawingAnnotationField = /** @class */ (function (_super) {
        __extends(CadDynamicDrawingAnnotationField, _super);
        function CadDynamicDrawingAnnotationField(kom) {
            return _super.call(this, kom) || this;
        }
        CadDynamicDrawingAnnotationField = __decorate([
            KboOutputField(CToken.CadDynamicDrawingAnnotationField, exports.eOutputFieldType.cadDynamicDrawingAnnotation)
        ], CadDynamicDrawingAnnotationField);
        return CadDynamicDrawingAnnotationField;
    }(OutputField));

    var CadDynamicDrawingDimensionField = /** @class */ (function (_super) {
        __extends(CadDynamicDrawingDimensionField, _super);
        function CadDynamicDrawingDimensionField(kom) {
            return _super.call(this, kom) || this;
        }
        CadDynamicDrawingDimensionField = __decorate([
            KboOutputField(CToken.CadDynamicDrawingDimensionField, exports.eOutputFieldType.cadDynamicDrawingDimension)
        ], CadDynamicDrawingDimensionField);
        return CadDynamicDrawingDimensionField;
    }(OutputField));

    var CadFeatureField = /** @class */ (function (_super) {
        __extends(CadFeatureField, _super);
        function CadFeatureField(kom) {
            return _super.call(this, kom) || this;
        }
        CadFeatureField = __decorate([
            KboOutputField(CToken.CadFeatureField, exports.eOutputFieldType.cadFeature)
        ], CadFeatureField);
        return CadFeatureField;
    }(OutputField));

    var CadLayerField = /** @class */ (function (_super) {
        __extends(CadLayerField, _super);
        function CadLayerField(kom) {
            return _super.call(this, kom) || this;
        }
        CadLayerField = __decorate([
            KboOutputField(CToken.CadLayerField, exports.eOutputFieldType.cadLayer)
        ], CadLayerField);
        return CadLayerField;
    }(OutputField));

    var CadLibFeatureField = /** @class */ (function (_super) {
        __extends(CadLibFeatureField, _super);
        function CadLibFeatureField(kom) {
            var _this = _super.call(this, kom) || this;
            _this.addConstraint = function (constraintType, args) {
                var constraint = OutputField.getNewOutputFieldOfType(constraintType, _this.$manager, args);
                constraint.type = constraintType;
                _this.$manager.addKbObject(constraint, _this);
                if (constraint.type == exports.eOutputFieldType.cadLibReference) {
                    _this.references.push(constraint);
                }
                else {
                    _this.dimensions.push(constraint);
                }
                return constraint;
            };
            _this.removeConstraint = function (constraint) {
                _this.$manager.removeKbObject(constraint);
                if (constraint.type == exports.eOutputFieldType.cadLibReference) {
                    _this.references.remove(constraint);
                }
                else {
                    _this.dimensions.remove(constraint);
                }
            };
            return _this;
        }
        Object.defineProperty(CadLibFeatureField.prototype, "references", {
            get: function () {
                if (!this._references)
                    this._references = [];
                return this._references;
            },
            set: function (val) {
                this._references = val;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(CadLibFeatureField.prototype, "dimensions", {
            get: function () {
                if (!this._dimensions)
                    this._dimensions = [];
                return this._dimensions;
            },
            set: function (val) {
                this._dimensions = val;
            },
            enumerable: false,
            configurable: true
        });
        __decorate([
            Enumerable()
        ], CadLibFeatureField.prototype, "references", null);
        __decorate([
            Enumerable()
        ], CadLibFeatureField.prototype, "dimensions", null);
        CadLibFeatureField = __decorate([
            KboOutputField(CToken.CadLibFeatureField, exports.eOutputFieldType.cadLibFeature)
        ], CadLibFeatureField);
        return CadLibFeatureField;
    }(OutputField));

    var CadParameterField = /** @class */ (function (_super) {
        __extends(CadParameterField, _super);
        function CadParameterField(kom) {
            return _super.call(this, kom) || this;
        }
        CadParameterField = __decorate([
            KboOutputField(CToken.CadParameterField, exports.eOutputFieldType.cadParameter)
        ], CadParameterField);
        return CadParameterField;
    }(OutputField));

    var CadReplaceComponentField = /** @class */ (function (_super) {
        __extends(CadReplaceComponentField, _super);
        function CadReplaceComponentField(kom) {
            return _super.call(this, kom) || this;
        }
        CadReplaceComponentField = __decorate([
            KboOutputField(CToken.CadReplaceComponentField, exports.eOutputFieldType.cadReplaceComponent)
        ], CadReplaceComponentField);
        return CadReplaceComponentField;
    }(OutputField));

    var CadRepresentationField = /** @class */ (function (_super) {
        __extends(CadRepresentationField, _super);
        function CadRepresentationField(kom) {
            return _super.call(this, kom) || this;
        }
        CadRepresentationField = __decorate([
            KboOutputField(CToken.CadRepresentationField, exports.eOutputFieldType.cadRepresentation)
        ], CadRepresentationField);
        return CadRepresentationField;
    }(OutputField));

    var CadScaleFeatureField = /** @class */ (function (_super) {
        __extends(CadScaleFeatureField, _super);
        function CadScaleFeatureField(kom) {
            return _super.call(this, kom) || this;
        }
        CadScaleFeatureField = __decorate([
            KboOutputField(CToken.CadScaleFeatureField, exports.eOutputFieldType.cadScaleFeature)
        ], CadScaleFeatureField);
        return CadScaleFeatureField;
    }(OutputField));

    var CadTextField = /** @class */ (function (_super) {
        __extends(CadTextField, _super);
        function CadTextField(kom) {
            return _super.call(this, kom) || this;
        }
        CadTextField = __decorate([
            KboOutputField(CToken.CadTextField, exports.eOutputFieldType.cadText)
        ], CadTextField);
        return CadTextField;
    }(OutputField));

    var Constraint = /** @class */ (function (_super) {
        __extends(Constraint, _super);
        function Constraint(kom) {
            return _super.call(this, kom) || this;
        }
        Constraint = __decorate([
            Kbo(CToken.Constraint)
        ], Constraint);
        return Constraint;
    }(OutputField));

    var Mate = /** @class */ (function (_super) {
        __extends(Mate, _super);
        function Mate(kom) {
            return _super.call(this, kom) || this;
        }
        Mate = __decorate([
            Kbo(CToken.Mate)
        ], Mate);
        return Mate;
    }(Constraint));

    var CadAngleMate = /** @class */ (function (_super) {
        __extends(CadAngleMate, _super);
        function CadAngleMate(kom) {
            return _super.call(this, kom) || this;
        }
        CadAngleMate = __decorate([
            KboOutputField(CToken.CadAngleMate, exports.eOutputFieldType.cadAngleMate)
        ], CadAngleMate);
        return CadAngleMate;
    }(Mate));

    var CadCoincidentMate = /** @class */ (function (_super) {
        __extends(CadCoincidentMate, _super);
        function CadCoincidentMate(kom) {
            return _super.call(this, kom) || this;
        }
        CadCoincidentMate = __decorate([
            KboOutputField(CToken.CadCoincidentMate, exports.eOutputFieldType.cadCoincidentMate)
        ], CadCoincidentMate);
        return CadCoincidentMate;
    }(Mate));

    var CadCoordinateSystemMate = /** @class */ (function (_super) {
        __extends(CadCoordinateSystemMate, _super);
        function CadCoordinateSystemMate(kom) {
            return _super.call(this, kom) || this;
        }
        CadCoordinateSystemMate = __decorate([
            KboOutputField(CToken.CadCoordinateSystemMate, exports.eOutputFieldType.cadCoordinateSystemMate)
        ], CadCoordinateSystemMate);
        return CadCoordinateSystemMate;
    }(Mate));

    var CadDistanceMate = /** @class */ (function (_super) {
        __extends(CadDistanceMate, _super);
        function CadDistanceMate(kom) {
            return _super.call(this, kom) || this;
        }
        CadDistanceMate = __decorate([
            KboOutputField(CToken.CadDistanceMate, exports.eOutputFieldType.cadDistanceMate)
        ], CadDistanceMate);
        return CadDistanceMate;
    }(Mate));

    var CadLibDimension = /** @class */ (function (_super) {
        __extends(CadLibDimension, _super);
        function CadLibDimension(kom) {
            return _super.call(this, kom) || this;
        }
        CadLibDimension = __decorate([
            KboOutputField(CToken.CadLibDimension, exports.eOutputFieldType.cadLibDimension)
        ], CadLibDimension);
        return CadLibDimension;
    }(Constraint));

    var CadLibReference = /** @class */ (function (_super) {
        __extends(CadLibReference, _super);
        function CadLibReference(kom) {
            return _super.call(this, kom) || this;
        }
        CadLibReference = __decorate([
            KboOutputField(CToken.CadLibReference, exports.eOutputFieldType.cadLibReference)
        ], CadLibReference);
        return CadLibReference;
    }(Constraint));

    var CadPositionConstraint = /** @class */ (function (_super) {
        __extends(CadPositionConstraint, _super);
        function CadPositionConstraint(kom) {
            return _super.call(this, kom) || this;
        }
        CadPositionConstraint = __decorate([
            KboOutputField(CToken.CadPositionConstraint, exports.eOutputFieldType.cadPositionConstraint)
        ], CadPositionConstraint);
        return CadPositionConstraint;
    }(Mate));

    var ExcelCellField = /** @class */ (function (_super) {
        __extends(ExcelCellField, _super);
        function ExcelCellField(kom) {
            return _super.call(this, kom) || this;
        }
        ExcelCellField = __decorate([
            KboOutputField(CToken.ExcelCellField, exports.eOutputFieldType.excelCell)
        ], ExcelCellField);
        return ExcelCellField;
    }(OutputField));

    var ExcelChartField = /** @class */ (function (_super) {
        __extends(ExcelChartField, _super);
        function ExcelChartField(kom) {
            return _super.call(this, kom) || this;
        }
        ExcelChartField = __decorate([
            KboOutputField(CToken.ExcelChartField, exports.eOutputFieldType.excelChart)
        ], ExcelChartField);
        return ExcelChartField;
    }(OutputField));

    var ExcelImageField = /** @class */ (function (_super) {
        __extends(ExcelImageField, _super);
        function ExcelImageField(kom) {
            var _this = _super.call(this, kom) || this;
            _this.source = exports.eDynamicSource.template;
            return _this;
        }
        ExcelImageField = __decorate([
            KboOutputField(CToken.ExcelImageField, exports.eOutputFieldType.excelImage)
        ], ExcelImageField);
        return ExcelImageField;
    }(OutputField));

    var ExcelSheetField = /** @class */ (function (_super) {
        __extends(ExcelSheetField, _super);
        function ExcelSheetField(kom) {
            return _super.call(this, kom) || this;
        }
        ExcelSheetField = __decorate([
            KboOutputField(CToken.ExcelSheetField, exports.eOutputFieldType.excelSheet)
        ], ExcelSheetField);
        return ExcelSheetField;
    }(OutputField));

    var ExcelTableField = /** @class */ (function (_super) {
        __extends(ExcelTableField, _super);
        function ExcelTableField(kom) {
            return _super.call(this, kom) || this;
        }
        ExcelTableField = __decorate([
            KboOutputField(CToken.ExcelTableField, exports.eOutputFieldType.excelTable)
        ], ExcelTableField);
        return ExcelTableField;
    }(OutputField));

    var PdfSectionField = /** @class */ (function (_super) {
        __extends(PdfSectionField, _super);
        function PdfSectionField(kom) {
            return _super.call(this, kom) || this;
        }
        PdfSectionField = __decorate([
            KboOutputField(CToken.PdfSectionField, exports.eOutputFieldType.pdfSection)
        ], PdfSectionField);
        return PdfSectionField;
    }(OutputField));

    var WordContainerField = /** @class */ (function (_super) {
        __extends(WordContainerField, _super);
        function WordContainerField(kom) {
            return _super.call(this, kom) || this;
        }
        WordContainerField = __decorate([
            KboOutputField(CToken.WordContainerField, exports.eOutputFieldType.wordContainer)
        ], WordContainerField);
        return WordContainerField;
    }(OutputField));

    var WordImageField = /** @class */ (function (_super) {
        __extends(WordImageField, _super);
        function WordImageField(kom) {
            var _this = _super.call(this, kom) || this;
            _this.source = exports.eDynamicSource.template;
            return _this;
        }
        WordImageField = __decorate([
            KboOutputField(CToken.WordImageField, exports.eOutputFieldType.wordImage)
        ], WordImageField);
        return WordImageField;
    }(OutputField));

    var WordListField = /** @class */ (function (_super) {
        __extends(WordListField, _super);
        function WordListField(kom) {
            return _super.call(this, kom) || this;
        }
        WordListField = __decorate([
            KboOutputField(CToken.WordListField, exports.eOutputFieldType.wordList)
        ], WordListField);
        return WordListField;
    }(OutputField));

    var WordTextField = /** @class */ (function (_super) {
        __extends(WordTextField, _super);
        function WordTextField(kom) {
            return _super.call(this, kom) || this;
        }
        WordTextField = __decorate([
            KboOutputField(CToken.WordTextField, exports.eOutputFieldType.wordText)
        ], WordTextField);
        return WordTextField;
    }(OutputField));

    var ZipSectionField = /** @class */ (function (_super) {
        __extends(ZipSectionField, _super);
        function ZipSectionField(kom) {
            return _super.call(this, kom) || this;
        }
        ZipSectionField = __decorate([
            KboOutputField(CToken.ZipSectionField, exports.eOutputFieldType.zipSection)
        ], ZipSectionField);
        return ZipSectionField;
    }(OutputField));

    var Export = /** @class */ (function (_super) {
        __extends(Export, _super);
        function Export(kom) {
            var _this = _super.call(this, kom) || this;
            _this.postToCloud = true;
            _this.enabled = true;
            return _this;
        }
        Object.defineProperty(Export.prototype, "tags", {
            get: function () {
                if (!this._tags)
                    this._tags = [];
                return this._tags;
            },
            set: function (val) {
                this._tags = val;
            },
            enumerable: false,
            configurable: true
        });
        Export.ImageTypes = function () {
            return [exports.eExportType.bmp, exports.eExportType.gif, exports.eExportType.jpg, exports.eExportType.png, exports.eExportType.tiff];
        };
        __decorate([
            Enumerable()
        ], Export.prototype, "tags", null);
        Export = __decorate([
            Kbo(CToken.Export)
        ], Export);
        return Export;
    }(KbObject));

    var Output = /** @class */ (function (_super) {
        __extends(Output, _super);
        function Output(kom, args) {
            var _this = _super.call(this, kom) || this;
            _this.ruleType = exports.eRuleType.output;
            if (args) {
                kom.recurse(args, _this);
            }
            _this.$manager.addKbObject(_this, undefined);
            _this.$fieldsNode = { id: _this.id + "_fields", $type: "FieldsNode", allowedChildren: function () { return [CToken.OutputField]; }, getParent: function () { return _this; } };
            _this.$rulesNode = { id: _this.id + "_rules", $type: "RulesNode", allowedChildren: function () { return [CToken.Rule]; }, getParent: function () { return _this; } };
            _this.$exportsNode = { id: _this.id + "_exports", $type: "ExportsNode", allowedChildren: function () { return [CToken.Export]; }, getParent: function () { return _this; } };
            _this.$drawingsNode = { id: _this.id + "_drawings", $type: "DrawingsNode", allowedChildren: function () { return [CToken.CadDrawingOutput]; }, getParent: function () { return _this; } };
            _this.ruleType = exports.eRuleType.output;
            return _this;
        }
        Output_1 = Output;
        Output.isCadOutput = function (outputType) {
            return outputType == exports.eOutputType.inventor ||
                outputType == exports.eOutputType.solidworks ||
                outputType == exports.eOutputType.creo ||
                outputType == exports.eOutputType.autoCad;
        };
        Output.supportsCadDrawings = function (outputType) {
            return outputType == exports.eOutputType.inventor ||
                outputType == exports.eOutputType.solidworks ||
                outputType == exports.eOutputType.creo;
        };
        Output.getOutputExportTypes = function (output) {
            var _this = this;
            if (!output)
                return [];
            var et = function (extension, name) {
                return _this.createExportType(extension, name);
            };
            switch (output.type) {
                case exports.eOutputType.word:
                    return [
                        et(exports.eExportType.pdf, "Adobe Portable Document Format"),
                        et(exports.eExportType.bmp, "Bitmap"),
                        et(exports.eExportType.doc, "Word Document 97-2003"),
                        et(exports.eExportType.docm, "Macro-Enabled Word Document"),
                        et(exports.eExportType.dot, "Word Template 97-2003"),
                        et(exports.eExportType.dotm, "Macro-Enabled Word Template 97-2003"),
                        et(exports.eExportType.dotx, "Word Template"),
                        et(exports.eExportType.emf, "EMF"),
                        et(exports.eExportType.epub, "EPUB"),
                        et(exports.eExportType.html, "HTML"),
                        et(exports.eExportType.jpg, "JPEG"),
                        et(exports.eExportType.png, "PNG"),
                        et(exports.eExportType.rtf, "Rich Text Format"),
                        et(exports.eExportType.txt, "Text"),
                        et(exports.eExportType.tiff, "TIFF"),
                        et(exports.eExportType.xaml, "XAML"),
                        et(exports.eExportType.xps, "XPS"),
                        et(exports.eExportType.odt, "Open Document Text")
                    ];
                case exports.eOutputType.excel:
                    return [
                        et(exports.eExportType.pdf, "Adobe Portable Document Format"),
                        et(exports.eExportType.csv, "CSV File"),
                        et(exports.eExportType.xml, "Xml"),
                        et(exports.eExportType.html, "HTML"),
                        et(exports.eExportType.ods, "Open Document Spreadsheet"),
                        et(exports.eExportType.svg, "SVG File"),
                        et(exports.eExportType.txt, "Tab Delimited Text File"),
                        et(exports.eExportType.tiff, "TIFF"),
                        et(exports.eExportType.xps, "XPS")
                    ];
                case exports.eOutputType.creo:
                    return [
                        et(exports.eExportType.x_t, "Parasolid"),
                        et(exports.eExportType.igs, "IGES"),
                        et(exports.eExportType.step, "STEP"),
                        et(exports.eExportType.sat, "ACIS"),
                        et(exports.eExportType.stl, "STL"),
                        et(exports.eExportType.wrl, "VRML"),
                        et(exports.eExportType.vda, "VDA"),
                        et(exports.eExportType.pdf, "Adobe Portable Document Format"),
                        et(exports.eExportType.eps, "eps"),
                        et(exports.eExportType.neu, "Neutral"),
                        et(exports.eExportType.jpg, "JPEG"),
                        et(exports.eExportType.tif, "Tif"),
                        et(exports.eExportType.iv, "Inventor"),
                        et(exports.eExportType.slp, "Render")
                    ];
                case exports.eOutputType.inventor:
                    return [
                        et(exports.eExportType.jpg, "JPEG"),
                        et(exports.eExportType.bmp, "BMP"),
                        et(exports.eExportType.gif, "GIF"),
                        et(exports.eExportType.png, "PNG"),
                        et(exports.eExportType.tiff, "TIFF"),
                        et(exports.eExportType.pdf, "Adobe Portable Document Format"),
                        et(exports.eExportType.catproduct, "CATIA V5 Product File"),
                        et(exports.eExportType.igs, "IGES"),
                        et(exports.eExportType.jt, "JT"),
                        et(exports.eExportType.x_b, "Parasolid Binary"),
                        et(exports.eExportType.x_t, "Parasolid Text"),
                        et(exports.eExportType.g, "Pro/Engineer Granite Files"),
                        et(exports.eExportType.neu, "Pro/Engineer NEutral File"),
                        et(exports.eExportType.sat, "SAT"),
                        et(exports.eExportType.step, "STEP"),
                        et(exports.eExportType.stl, "STL"),
                        et(exports.eExportType.xgl, "XGL"),
                        et(exports.eExportType.zgl, "ZGL"),
                        et(exports.eExportType.dwf, "DWF")
                    ];
                case exports.eOutputType.solidworks:
                    return [
                        et(exports.eExportType.sldprt, "Solidworks Part"),
                        et(exports.eExportType.x_t, "Parasolid"),
                        et(exports.eExportType.x_b, "Parasolid Binary"),
                        et(exports.eExportType.igs, "IGES"),
                        et(exports.eExportType.step, "STEP"),
                        et(exports.eExportType.sat, "ACIS"),
                        et(exports.eExportType.stl, "STL"),
                        et(exports.eExportType.wrl, "VRML"),
                        et(exports.eExportType.easm, "eDrawings Assembly"),
                        et(exports.eExportType.pdf, "Adobe Portable Document Format"),
                        et(exports.eExportType.u3d, "Universal 3D"),
                        et(exports.eExportType.psd, "Adobe Photoshop File"),
                        et(exports.eExportType.ai, "Adobe Illustrator File"),
                        et(exports.eExportType.xaml, "Microsoft XAML"),
                        et(exports.eExportType.cgr, "Catia Graphics"),
                        et(exports.eExportType.asm, "ProE Assembly"),
                        et(exports.eExportType.jpg, "JPEG"),
                        et(exports.eExportType.hcg, "HCG"),
                        et(exports.eExportType.hsf, "HOOPS HSF"),
                        et(exports.eExportType.tif, "Tif")
                    ];
                case exports.eOutputType.autoCad:
                    return [
                        et(exports.eExportType.dxf, "DXF"),
                        et(exports.eExportType.pdf, "PDF"),
                        // et(eExportType.dgn, "DGN"),
                        et(exports.eExportType.dwf, "DWF"),
                        et(exports.eExportType.bmp, "BMP"),
                        et(exports.eExportType.stl, "STL"),
                        et(exports.eExportType.igs, "IGS")
                    ];
                case exports.eOutputType.cadDrawing:
                    return Output_1.getCadDrawingExportTypes(output);
                case exports.eOutputType.bom:
                    return [
                        et(exports.eExportType.xml, "XML"),
                        et(exports.eExportType.txt, "Text")
                    ];
                case exports.eOutputType.svg:
                    return [
                        et(exports.eExportType.jpg, "JPEG"),
                        et(exports.eExportType.bmp, "BMP"),
                        et(exports.eExportType.gif, "GIF"),
                        et(exports.eExportType.png, "PNG"),
                        et(exports.eExportType.pdf, "PDF")
                    ];
                case exports.eOutputType.sceneModel:
                    return [
                        et(exports.eExportType.glb, "GLB"),
                        // et(eExportType.fbx, "FBX"),
                    ];
                case exports.eOutputType.text:
                    return [
                        et(exports.eExportType._custom, "Custom File Extension")
                    ];
            }
            return [];
        };
        Output.getCadDrawingExportTypes = function (output) {
            var _this = this;
            var et = function (extension, name) {
                return _this.createExportType(extension, name);
            };
            switch (output.$parent.type) {
                case exports.eOutputType.solidworks:
                    return [
                        et(exports.eExportType.dxf, "DXF"),
                        et(exports.eExportType.dwg, "DWG"),
                        et(exports.eExportType.psd, "Adobe Photoshop File"),
                        et(exports.eExportType.ai, "Adobe Illustrator File"),
                        et(exports.eExportType.pdf, "Adobe Portable Document Format"),
                        et(exports.eExportType.edrw, "EDrawings"),
                        et(exports.eExportType.jpg, "JPEG"),
                        et(exports.eExportType.tif, "Tif")
                    ];
                case exports.eOutputType.inventor:
                    return [
                        et(exports.eExportType.jpg, "JPEG"),
                        et(exports.eExportType.bmp, "BMP"),
                        et(exports.eExportType.gif, "GIF"),
                        et(exports.eExportType.png, "PNG"),
                        et(exports.eExportType.tiff, "TIFF"),
                        et(exports.eExportType.pdf, "PDF"),
                        et(exports.eExportType.dwg, "DWG"),
                        et(exports.eExportType.dwf, "DWF")
                    ];
                case exports.eOutputType.creo:
                    return [
                        et(exports.eExportType.dwg, "DWG"),
                        et(exports.eExportType.dxf, "DXF"),
                        et(exports.eExportType.pdf, "Adobe Portable Document Format"),
                        et(exports.eExportType.tiff, "TIFF")
                    ];
            }
            return [];
        };
        Output.createExportType = function (extension, name) {
            return {
                extension: extension,
                name: name + " (." + extension + ")"
            };
        };
        Output.getOutputFieldTypes = function (output) {
            if (!output)
                return [];
            return Output_1.getOutputFieldTypesByOutputType(output.type);
        };
        Output.getOutputFieldTypesByOutputType = function (outputType) {
            switch (outputType) {
                case exports.eOutputType.word:
                    return [
                        exports.eOutputFieldType.wordText,
                        exports.eOutputFieldType.wordImage,
                        exports.eOutputFieldType.wordContainer,
                        exports.eOutputFieldType.wordList
                    ];
                case exports.eOutputType.excel:
                    return [
                        exports.eOutputFieldType.excelCell,
                        exports.eOutputFieldType.excelImage,
                        exports.eOutputFieldType.excelSheet,
                        exports.eOutputFieldType.excelTable,
                        exports.eOutputFieldType.excelChart
                    ];
                case exports.eOutputType.creo:
                case exports.eOutputType.solidworks:
                    return [
                        exports.eOutputFieldType.cadAnnotation,
                        exports.eOutputFieldType.cadComponent,
                        exports.eOutputFieldType.cadCustomProperty,
                        exports.eOutputFieldType.cadDimension,
                        exports.eOutputFieldType.cadDynamicComponent,
                        exports.eOutputFieldType.cadFeature,
                        exports.eOutputFieldType.cadLibFeature,
                        exports.eOutputFieldType.cadReplaceComponent,
                        exports.eOutputFieldType.cadScaleFeature
                    ];
                case exports.eOutputType.autoCad:
                    return [
                        exports.eOutputFieldType.cadLayer,
                        exports.eOutputFieldType.cadBlock,
                        exports.eOutputFieldType.cadBlockArray,
                        exports.eOutputFieldType.cadDimension,
                        exports.eOutputFieldType.cadText
                    ];
                case exports.eOutputType.inventor:
                    return [
                        exports.eOutputFieldType.cadAnnotation,
                        exports.eOutputFieldType.cadComponent,
                        exports.eOutputFieldType.cadCustomProperty,
                        exports.eOutputFieldType.cadDimension,
                        exports.eOutputFieldType.cadDynamicComponent,
                        exports.eOutputFieldType.cadFeature,
                        exports.eOutputFieldType.cadLibFeature,
                        exports.eOutputFieldType.cadReplaceComponent,
                        exports.eOutputFieldType.cadScaleFeature,
                        exports.eOutputFieldType.cadParameter
                    ];
                case exports.eOutputType.cadDrawing:
                    return [
                        exports.eOutputFieldType.cadDrawingAnnotation,
                        exports.eOutputFieldType.cadDrawingDimension,
                        exports.eOutputFieldType.cadDynamicDrawingDimension,
                        exports.eOutputFieldType.cadDynamicDrawingAnnotation,
                        exports.eOutputFieldType.cadDrawingSheet,
                        exports.eOutputFieldType.cadDrawingView,
                        exports.eOutputFieldType.cadCustomProperty,
                        exports.eOutputFieldType.cadLayer
                    ];
                case exports.eOutputType.pdf:
                    return [
                        exports.eOutputFieldType.pdfSection
                    ];
                case exports.eOutputType.zip:
                    return [
                        exports.eOutputFieldType.zipSection
                    ];
            }
            return [];
        };
        Output.getConstraintFieldTypes = function () {
            return [
                exports.eOutputFieldType.cadDistanceMate,
                exports.eOutputFieldType.cadAngleMate,
                exports.eOutputFieldType.cadCoordinateSystemMate,
                exports.eOutputFieldType.cadCoincidentMate,
                exports.eOutputFieldType.cadPositionConstraint
            ];
        };
        Output.getLibFeatureConstraintTypes = function () {
            return [
                exports.eOutputFieldType.cadLibDimension,
                exports.eOutputFieldType.cadLibReference
            ];
        };
        Output.usesTemplate = function (outputType) {
            switch (outputType) {
                case exports.eOutputType.solidworks:
                case exports.eOutputType.inventor:
                case exports.eOutputType.creo:
                case exports.eOutputType.cadDrawing:
                case exports.eOutputType.word:
                case exports.eOutputType.excel:
                case exports.eOutputType.autoCad:
                    return true;
            }
            return false;
        };
        Object.defineProperty(Output.prototype, "fields", {
            get: function () {
                if (!this._fields)
                    this._fields = [];
                return this._fields;
            },
            set: function (val) {
                this._fields = val;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Output.prototype, "exports", {
            get: function () {
                if (!this._exports)
                    this._exports = [];
                return this._exports;
            },
            set: function (val) {
                this._exports = val;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Output.prototype, "tags", {
            get: function () {
                if (!this._tags)
                    this._tags = [];
                return this._tags;
            },
            set: function (val) {
                this._tags = val;
            },
            enumerable: false,
            configurable: true
        });
        Output.prototype.addExport = function (type) {
            var exprt = new Export(this.$manager);
            exprt.type = type;
            exprt.name = this.type == exports.eOutputType.sceneRender ? "Render" : exprt.type + " Export";
            this.$manager.addKbObject(exprt, this);
            this.exports.push(exprt);
            return exprt;
        };
        Output.prototype.removeExport = function (exp) {
            this.$manager.removeKbObject(exp);
            this.exports.remove(exp);
        };
        Output.prototype.addOutputField = function (fieldType, args) {
            var field = ConfiguratorDI.getNewOutputField(fieldType, this.$manager, args);
            this.$manager.addKbObject(field, this);
            this.fields.push(field);
            return field;
        };
        Output.prototype.removeOutputField = function (outputField) {
            this.$manager.removeKbObject(outputField);
            this.fields.remove(outputField);
        };
        Output.prototype.allRuleContainers = function () {
            var containers = [this];
            if (ConfiguratorDI.instanceOf(this, CToken.CadOutput)) {
                containers.concat(this.drawings);
            }
            return containers;
        };
        var Output_1;
        __decorate([
            Enumerable()
        ], Output.prototype, "fields", null);
        __decorate([
            Enumerable()
        ], Output.prototype, "exports", null);
        __decorate([
            Enumerable()
        ], Output.prototype, "tags", null);
        Output = Output_1 = __decorate([
            Kbo(CToken.Output)
        ], Output);
        return Output;
    }(RuleContainer));

    var FileOutput = /** @class */ (function (_super) {
        __extends(FileOutput, _super);
        function FileOutput(kom, args) {
            var _this = _super.call(this, kom, args) || this;
            if (!args) {
                _this.postToCloud = true;
            }
            return _this;
        }
        FileOutput = __decorate([
            Kbo(CToken.FileOutput)
        ], FileOutput);
        return FileOutput;
    }(Output));

    var BomOutput = /** @class */ (function (_super) {
        __extends(BomOutput, _super);
        function BomOutput(kom, args) {
            return _super.call(this, kom, args) || this;
        }
        BomOutput = __decorate([
            KboOutput(CToken.BomOutput, exports.eOutputType.bom)
        ], BomOutput);
        return BomOutput;
    }(FileOutput));

    var CadDrawingOutput = /** @class */ (function (_super) {
        __extends(CadDrawingOutput, _super);
        function CadDrawingOutput(kom, args) {
            return _super.call(this, kom, args) || this;
        }
        CadDrawingOutput = __decorate([
            KboOutput(CToken.CadDrawingOutput, exports.eOutputType.cadDrawing)
        ], CadDrawingOutput);
        return CadDrawingOutput;
    }(FileOutput));

    var CadOutput = /** @class */ (function (_super) {
        __extends(CadOutput, _super);
        function CadOutput(kom, args) {
            var _this = _super.call(this, kom, args) || this;
            _this.drawings = [];
            return _this;
        }
        CadOutput.prototype.addDrawing = function () {
            var drw = new CadDrawingOutput(this.$manager);
            drw.name = "Drawing";
            this.$manager.addKbObject(drw, this);
            this.drawings.push(drw);
            return drw;
        };
        CadOutput.prototype.removeDrawing = function (drawing) {
            this.drawings.remove(drawing);
            this.$manager.removeKbObject(drawing);
        };
        CadOutput.prototype.removeOutput = function (drawing) {
            this.removeDrawing(drawing);
        };
        CadOutput = __decorate([
            KboOutput(CToken.CadOutput, exports.eOutputType.solidworks, exports.eOutputType.autoCad, exports.eOutputType.creo, exports.eOutputType.creo3, exports.eOutputType.inventor, exports.eOutputType.salesforce)
        ], CadOutput);
        return CadOutput;
    }(FileOutput));

    var ExcelOutput = /** @class */ (function (_super) {
        __extends(ExcelOutput, _super);
        function ExcelOutput(kom, args) {
            var _this = _super.call(this, kom, args) || this;
            _this.type = exports.eOutputType.excel;
            return _this;
        }
        ExcelOutput = __decorate([
            KboOutput(CToken.ExcelOutput, exports.eOutputType.excel)
        ], ExcelOutput);
        return ExcelOutput;
    }(FileOutput));

    var glbOutput = /** @class */ (function (_super) {
        __extends(glbOutput, _super);
        function glbOutput(kom, args) {
            var _this = _super.call(this, kom, args) || this;
            _this.type = exports.eOutputType.sceneModel;
            return _this;
        }
        glbOutput = __decorate([
            KboOutput(CToken.GlbOutput, exports.eOutputType.sceneModel)
        ], glbOutput);
        return glbOutput;
    }(FileOutput));

    var ImageOutput = /** @class */ (function (_super) {
        __extends(ImageOutput, _super);
        function ImageOutput(kom, args) {
            return _super.call(this, kom, args) || this;
        }
        ImageOutput = __decorate([
            KboOutput(CToken.ImageOutput, exports.eOutputType.image)
        ], ImageOutput);
        return ImageOutput;
    }(FileOutput));

    var PdfOutput = /** @class */ (function (_super) {
        __extends(PdfOutput, _super);
        function PdfOutput(kom, args) {
            var _this = _super.call(this, kom, args) || this;
            _this.type = exports.eOutputType.pdf;
            return _this;
        }
        PdfOutput = __decorate([
            KboOutput(CToken.PdfOutput, exports.eOutputType.pdf)
        ], PdfOutput);
        return PdfOutput;
    }(FileOutput));

    var RenderPassExport = /** @class */ (function (_super) {
        __extends(RenderPassExport, _super);
        function RenderPassExport(kom) {
            return _super.call(this, kom) || this;
        }
        RenderPassExport = __decorate([
            Kbo(CToken.RenderPassExport)
        ], RenderPassExport);
        return RenderPassExport;
    }(Export));

    var SceneRenderOutput = /** @class */ (function (_super) {
        __extends(SceneRenderOutput, _super);
        function SceneRenderOutput(kom, args) {
            var _this = _super.call(this, kom, args) || this;
            _this.type = exports.eOutputType.sceneRender;
            return _this;
        }
        SceneRenderOutput.prototype.addRenderPass = function () {
            var exprt = new RenderPassExport(this.$manager);
            exprt.type = exports.eExportType.png;
            exprt.name = "Render Pass";
            this.$manager.addKbObject(exprt, this);
            this.exports.push(exprt);
            return exprt;
        };
        SceneRenderOutput = __decorate([
            KboOutput(CToken.SceneRenderOutput, exports.eOutputType.sceneRender)
        ], SceneRenderOutput);
        return SceneRenderOutput;
    }(FileOutput));

    var SvgOutput = /** @class */ (function (_super) {
        __extends(SvgOutput, _super);
        function SvgOutput(kom, args) {
            var _this = _super.call(this, kom, args) || this;
            _this.type = exports.eOutputType.svg;
            return _this;
        }
        SvgOutput = __decorate([
            KboOutput(CToken.SvgOutput, exports.eOutputType.svg)
        ], SvgOutput);
        return SvgOutput;
    }(FileOutput));

    var TextOutput = /** @class */ (function (_super) {
        __extends(TextOutput, _super);
        function TextOutput(kom, args) {
            var _this = _super.call(this, kom, args) || this;
            _this.textContent = "";
            _this.type = exports.eOutputType.text;
            return _this;
        }
        TextOutput = __decorate([
            KboOutput(CToken.TextOutput, exports.eOutputType.text)
        ], TextOutput);
        return TextOutput;
    }(FileOutput));

    var WordOutput = /** @class */ (function (_super) {
        __extends(WordOutput, _super);
        function WordOutput(kom, args) {
            var _this = _super.call(this, kom, args) || this;
            _this.type = exports.eOutputType.word;
            return _this;
        }
        WordOutput = __decorate([
            KboOutput(CToken.WordOutput, exports.eOutputType.word)
        ], WordOutput);
        return WordOutput;
    }(FileOutput));

    var ZipOutput = /** @class */ (function (_super) {
        __extends(ZipOutput, _super);
        function ZipOutput(kom, args) {
            var _this = _super.call(this, kom, args) || this;
            _this.type = exports.eOutputType.zip;
            return _this;
        }
        ZipOutput = __decorate([
            KboOutput(CToken.ZipOutput, exports.eOutputType.zip)
        ], ZipOutput);
        return ZipOutput;
    }(FileOutput));

    var OverlayPopupControl = /** @class */ (function (_super) {
        __extends(OverlayPopupControl, _super);
        function OverlayPopupControl(kom) {
            return _super.call(this, kom) || this;
        }
        OverlayPopupControl.prototype.allowedChildren = function (rootType) {
            if (rootType == CToken.Configurator) {
                return [
                    CToken.OverlayPopup
                ];
            }
            else {
                return [];
            }
        };
        OverlayPopupControl = __decorate([
            Kbo(CToken.OverlayPopupControl)
        ], OverlayPopupControl);
        return OverlayPopupControl;
    }(UiObject));

    var PageControl = /** @class */ (function (_super) {
        __extends(PageControl, _super);
        function PageControl(kom) {
            return _super.call(this, kom) || this;
        }
        PageControl.prototype.allowedChildren = function (rootType) {
            if (rootType == CToken.Configurator) {
                return [
                    CToken.Page
                ];
            }
            else {
                return []; // pages are filled in by the consumer, not in the layout
            }
        };
        PageControl = __decorate([
            Kbo(CToken.PageControl)
        ], PageControl);
        return PageControl;
    }(UiObject));

    var PageNavigator = /** @class */ (function (_super) {
        __extends(PageNavigator, _super);
        function PageNavigator(kom) {
            return _super.call(this, kom) || this;
        }
        PageNavigator = __decorate([
            Kbo(CToken.PageNavigator)
        ], PageNavigator);
        return PageNavigator;
    }(UiObject));

    var PageTabs = /** @class */ (function (_super) {
        __extends(PageTabs, _super);
        function PageTabs(kom) {
            return _super.call(this, kom) || this;
        }
        PageTabs = __decorate([
            Kbo(CToken.PageTabs)
        ], PageTabs);
        return PageTabs;
    }(UiObject));

    var PartMaterial = /** @class */ (function (_super) {
        __extends(PartMaterial, _super);
        function PartMaterial(kom, data) {
            return _super.call(this, kom, data) || this;
        }
        PartMaterial.prototype.getIdentifyingProperty = function () {
            return "mtlPartNum";
        };
        PartMaterial.getMetadataProperties = function () {
            return ["getDetails"];
        };
        PartMaterial = __decorate([
            Kbo(CToken.PartMaterial)
        ], PartMaterial);
        return PartMaterial;
    }(PartRev));

    var PartOperationDetail = /** @class */ (function (_super) {
        __extends(PartOperationDetail, _super);
        function PartOperationDetail(kom, data) {
            var _this = _super.call(this, kom) || this;
            _this._metadata = {};
            _this._metadata = {};
            for (var key in data) {
                var value = data[key];
                if (!Array.isArray(value))
                    _this[key] = value;
            }
            return _this;
        }
        PartOperationDetail.prototype.getIdentifyingProperty = function () {
            return (this.resourceGrpID ? "resourceGrpID" : "resourceID");
        };
        PartOperationDetail.getMetadataProperties = function () {
            return [];
        };
        PartOperationDetail = __decorate([
            Kbo(CToken.PartOperationDetail)
        ], PartOperationDetail);
        return PartOperationDetail;
    }(KbObject));

    var PartOperation = /** @class */ (function (_super) {
        __extends(PartOperation, _super);
        function PartOperation(kom, data) {
            var _this = _super.call(this, kom) || this;
            _this._metadata = {};
            _this._metadata = {};
            for (var key in data) {
                var value = data[key];
                if (!Array.isArray(value))
                    _this[key] = value;
            }
            return _this;
        }
        PartOperation.getMetadataProperties = function () {
            return [];
        };
        Object.defineProperty(PartOperation.prototype, "operationDetails", {
            get: function () {
                if (!this._operationDetails)
                    this._operationDetails = [];
                return this._operationDetails;
            },
            set: function (val) {
                this._operationDetails = val;
            },
            enumerable: false,
            configurable: true
        });
        PartOperation.prototype.getIdentifyingProperty = function () {
            return "opDesc";
        };
        __decorate([
            Enumerable()
        ], PartOperation.prototype, "operationDetails", null);
        PartOperation = __decorate([
            Kbo(CToken.PartOperation)
        ], PartOperation);
        return PartOperation;
    }(KbObject));

    var Popup = /** @class */ (function (_super) {
        __extends(Popup, _super);
        function Popup(kom) {
            return _super.call(this, kom) || this;
        }
        Object.defineProperty(Popup.prototype, "children", {
            get: function () {
                if (!this._children)
                    this._children = [];
                return this._children;
            },
            set: function (val) {
                this._children = val;
            },
            enumerable: false,
            configurable: true
        });
        Popup.prototype.getChildrenOfType = function () {
            var tokens = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                tokens[_i] = arguments[_i];
            }
            return this.filterChildren(tokens, this.children);
        };
        Popup.prototype.allowedChildren = function (rootType) {
            return this.containerChildren(rootType);
        };
        __decorate([
            Enumerable()
        ], Popup.prototype, "children", null);
        Popup = __decorate([
            Kbo(CToken.Popup)
        ], Popup);
        return Popup;
    }(Button));

    var PriceWidget = /** @class */ (function (_super) {
        __extends(PriceWidget, _super);
        function PriceWidget(kom) {
            return _super.call(this, kom) || this;
        }
        PriceWidget = __decorate([
            Kbo(CToken.PriceWidget)
        ], PriceWidget);
        return PriceWidget;
    }(UiObject));

    var PricingRuleContainer = /** @class */ (function (_super) {
        __extends(PricingRuleContainer, _super);
        function PricingRuleContainer(kom) {
            return _super.call(this, kom, { ruleType: exports.eRuleType.pricing }) || this;
        }
        Object.defineProperty(PricingRuleContainer.prototype, "columnMaps", {
            get: function () {
                if (!this._columnMaps)
                    this._columnMaps = [];
                return this._columnMaps;
            },
            set: function (val) {
                this._columnMaps = val;
            },
            enumerable: false,
            configurable: true
        });
        __decorate([
            Enumerable()
        ], PricingRuleContainer.prototype, "columnMaps", null);
        PricingRuleContainer = __decorate([
            Kbo(CToken.PricingRuleContainer)
        ], PricingRuleContainer);
        return PricingRuleContainer;
    }(RuleContainer));

    var Rule = /** @class */ (function (_super) {
        __extends(Rule, _super);
        function Rule(kom) {
            return _super.call(this, kom) || this;
        }
        Rule = __decorate([
            Kbo(CToken.Rule)
        ], Rule);
        return Rule;
    }(KbObject));

    var SvgViewer = /** @class */ (function (_super) {
        __extends(SvgViewer, _super);
        function SvgViewer(kom) {
            var _this = _super.call(this, kom, { ruleType: exports.eRuleType.svgViewer }) || this;
            _this.ruleContainers = [];
            _this.$rulesNode = { id: _this.id + "_rules", $type: "RulesNode", allowedChildren: function () { return [CToken.Rule]; }, getParent: function () { return _this; } };
            return _this;
        }
        SvgViewer = __decorate([
            Kbo(CToken.SvgViewer)
        ], SvgViewer);
        return SvgViewer;
    }(UiObject));

    var TabControl = /** @class */ (function (_super) {
        __extends(TabControl, _super);
        function TabControl(kom) {
            return _super.call(this, kom) || this;
        }
        Object.defineProperty(TabControl.prototype, "tabs", {
            get: function () {
                if (!this._tabs)
                    this._tabs = [];
                return this._tabs;
            },
            set: function (val) {
                this._tabs = val;
            },
            enumerable: false,
            configurable: true
        });
        TabControl.prototype.getChildrenOfType = function () {
            var tokens = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                tokens[_i] = arguments[_i];
            }
            return this.filterChildren(tokens, this.tabs);
        };
        TabControl.prototype.allowedChildren = function (rootType) {
            return [
                CToken.Tab
            ];
        };
        __decorate([
            Enumerable()
        ], TabControl.prototype, "tabs", null);
        TabControl = __decorate([
            Kbo(CToken.TabControl)
        ], TabControl);
        return TabControl;
    }(UiObject));

    var Tab = /** @class */ (function (_super) {
        __extends(Tab, _super);
        function Tab(kom) {
            return _super.call(this, kom) || this;
        }
        Object.defineProperty(Tab.prototype, "children", {
            get: function () {
                if (!this._children)
                    this._children = [];
                return this._children;
            },
            set: function (val) {
                this._children = val;
            },
            enumerable: false,
            configurable: true
        });
        Tab.prototype.getChildrenOfType = function () {
            var tokens = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                tokens[_i] = arguments[_i];
            }
            return this.filterChildren(tokens, this.children);
        };
        Tab.prototype.allowedChildren = function (rootType) {
            return this.containerChildren(rootType);
        };
        __decorate([
            Enumerable()
        ], Tab.prototype, "children", null);
        Tab = __decorate([
            Kbo(CToken.Tab)
        ], Tab);
        return Tab;
    }(UiObject));

    var Text = /** @class */ (function (_super) {
        __extends(Text, _super);
        function Text(kom) {
            return _super.call(this, kom) || this;
        }
        Text = __decorate([
            Kbo(CToken.Text)
        ], Text);
        return Text;
    }(UiObject));

    var Toolbar = /** @class */ (function (_super) {
        __extends(Toolbar, _super);
        function Toolbar(kom) {
            return _super.call(this, kom) || this;
        }
        Object.defineProperty(Toolbar.prototype, "children", {
            get: function () {
                if (!this._children)
                    this._children = [];
                return this._children;
            },
            set: function (val) {
                this._children = val;
            },
            enumerable: false,
            configurable: true
        });
        Toolbar.prototype.getChildrenOfType = function () {
            var tokens = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                tokens[_i] = arguments[_i];
            }
            return this.filterChildren(tokens, this.children);
        };
        Toolbar.prototype.allowedChildren = function (rootType) {
            return [
                CToken.Button,
                CToken.DropdownButton
            ];
        };
        __decorate([
            Enumerable()
        ], Toolbar.prototype, "children", null);
        Toolbar = __decorate([
            Kbo(CToken.Toolbar)
        ], Toolbar);
        return Toolbar;
    }(UiObject));

    var Viewer = /** @class */ (function (_super) {
        __extends(Viewer, _super);
        function Viewer(kom) {
            return _super.call(this, kom) || this;
        }
        Viewer = __decorate([
            Kbo(CToken.Viewer)
        ], Viewer);
        return Viewer;
    }(UiObject));

    (function (eInputDialogType) {
        eInputDialogType["text"] = "text";
        eInputDialogType["html"] = "html";
        eInputDialogType["textArea"] = "textArea";
        eInputDialogType["select"] = "select";
        eInputDialogType["snap"] = "snap";
    })(exports.eInputDialogType || (exports.eInputDialogType = {}));
    (function (eMediaFilter) {
        eMediaFilter[eMediaFilter["all"] = 0] = "all";
        eMediaFilter[eMediaFilter["images"] = 1] = "images";
        eMediaFilter[eMediaFilter["videos"] = 2] = "videos";
        eMediaFilter[eMediaFilter["imagesAndVideos"] = 3] = "imagesAndVideos";
        eMediaFilter[eMediaFilter["environments"] = 4] = "environments";
    })(exports.eMediaFilter || (exports.eMediaFilter = {}));
    var DialogButtonArgs = /** @class */ (function () {
        function DialogButtonArgs() {
            this.close = true;
        }
        return DialogButtonArgs;
    }());
    var InputDialogButtonArgs = /** @class */ (function (_super) {
        __extends(InputDialogButtonArgs, _super);
        function InputDialogButtonArgs() {
            return _super.call(this) || this;
        }
        return InputDialogButtonArgs;
    }(DialogButtonArgs));
    var MediaDialogButtonArgs = /** @class */ (function (_super) {
        __extends(MediaDialogButtonArgs, _super);
        function MediaDialogButtonArgs() {
            return _super.call(this) || this;
        }
        return MediaDialogButtonArgs;
    }(DialogButtonArgs));
    var DialogButton = /** @class */ (function () {
        function DialogButton(title, icon, callback, visible) {
            if (callback === void 0) { callback = null; }
            if (visible === void 0) { visible = true; }
            this.title = title;
            this.icon = icon;
            this.callback = callback;
            this.visible = visible;
        }
        return DialogButton;
    }());
    var InputDialogButton = /** @class */ (function (_super) {
        __extends(InputDialogButton, _super);
        function InputDialogButton() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return InputDialogButton;
    }(DialogButton));
    var MediaDialogButton = /** @class */ (function (_super) {
        __extends(MediaDialogButton, _super);
        function MediaDialogButton() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return MediaDialogButton;
    }(DialogButton));

    // tslint:disable:max-line-length
    var meta = {
        Configurator: {
            $name: "Configurator",
        },
        KineticSettings: {
            $name: "KineticSettings",
        },
        LayoutConfig: {
            $name: "LayoutConfig",
        },
        DbTable: {
            $name: "DbTable",
        },
        BuildType: {
            $name: "BuildType",
        },
        Channel: {
            $name: "Channel",
        },
        Company: {
            $name: "Company",
        },
        Contact: {
            $name: "Contact",
        },
        CustomAction: {
            $name: "CustomAction",
        },
        Customer: {
            $name: "Customer",
        },
        EmailTemplate: {
            $name: "EmailTemplate",
        },
        Generator: {
            $name: "Generator",
        },
        GlobalDefinition: {
            $name: "GlobalDefinition",
        },
        GlobalFunction: {
            $name: "GlobalFunction",
            id: { name: "id", type: "number", control: "none", source: "none" },
            name: { name: "name", type: "text", control: "none", source: "none" },
            description: { name: "description", type: "text", control: "none", source: "none" },
            returnType: { name: "returnType", type: "text", control: "none", source: "none" },
            dynamicTypeJson: { name: "dynamicTypeJson", type: "text", control: "none", source: "none" },
            functionType: { name: "functionType", type: "text", control: "none", source: "none" },
            modifiedDate: { name: "modifiedDate", type: "text", control: "none", source: "none" },
            modifiedByName: { name: "modifiedByName", type: "text", control: "none", source: "none" },
        },
        Job: {
            $name: "Job",
            type: { name: "type", type: "text", control: "select", source: "enum", default: true, enumType: "eJobType" },
            status: { name: "status", type: "text", control: "select", source: "enum", enumType: "eJobStatus" },
            createdDate: { name: "createdDate", type: "text", control: "dateRange", source: "none" },
            completedDate: { name: "completedDate", type: "text", control: "dateRange", source: "none" },
        },
        KbRole: {
            $name: "KbRole",
        },
        KbUserEdit: {
            $name: "KbUserEdit",
            id: { name: "id", type: "number", control: "none", source: "none" },
            firstName: { name: "firstName", type: "text", control: "none", source: "none" },
            lastName: { name: "lastName", type: "text", control: "none", source: "none" },
            email: { name: "email", type: "text", control: "none", source: "none" },
            isApproved: { name: "isApproved", type: "boolean", control: "checkbox", source: "none" },
            licenseType: { name: "licenseType", type: "text", control: "select", source: "enum", default: true, enumType: "eUserLicenseType" },
            createdDate: { name: "createdDate", type: "text", control: "dateRange", source: "none" },
            modifiedDate: { name: "modifiedDate", type: "text", control: "dateRange", source: "none" },
            lastLoginDate: { name: "lastLoginDate", type: "text", control: "dateRange", source: "none" },
        },
        Layout: {
            $name: "Layout",
        },
        Log: {
            $name: "Log",
            type: { name: "type", type: "text", control: "select", source: "enum", default: true, enumType: "eLogType" },
            source: { name: "source", type: "text", control: "select", source: "enum", enumType: "eLogSource" },
        },
        Material: {
            $name: "Material",
        },
        MatTag: {
            $name: "MatTag",
            id: { name: "id", type: "number", control: "none", source: "none" },
            name: { name: "name", type: "text", control: "none", source: "none" },
        },
        Notification: {
            $name: "Notification",
        },
        OutputBuilder: {
            $name: "OutputBuilder",
        },
        PriceColumn: {
            $name: "PriceColumn",
        },
        Product: {
            $name: "Product",
            id: { name: "id", type: "number", control: "none", source: "none" },
            name: { name: "name", type: "text", control: "suggest", source: "suggestProducts" },
            shortDescription: { name: "shortDescription", type: "text", control: "text", source: "none" },
            sku: { name: "sku", type: "text", control: "text", source: "none" },
            mfgPartNumber: { name: "mfgPartNumber", type: "text", control: "text", source: "none" },
            manufacturer: { name: "manufacturer", type: "text", control: "select", source: "manufacturers" },
            unitOfMeasure: { name: "unitOfMeasure", type: "text", control: "none", source: "none" },
            price: { name: "price", type: "number", control: "numberRange", source: "none" },
            maxQty: { name: "maxQty", type: "number", control: "none", source: "none" },
            minQty: { name: "minQty", type: "number", control: "none", source: "none" },
            allowFractionalQty: { name: "allowFractionalQty", type: "boolean", control: "none", source: "none" },
            score: { name: "score", type: "number", control: "none", source: "none" },
            createdDate: { name: "createdDate", type: "text", control: "dateRange", source: "none" },
            modifiedByName: { name: "modifiedByName", type: "text", control: "none", source: "none" },
            isConfigured: { name: "isConfigured", type: "boolean", control: "none", source: "none" },
            images: { name: "images", type: "ProductImage[]", control: "none", source: "none" },
            templates: { name: "templates", type: "ProductTemplate[]", control: "none", source: "none" },
            translations: { name: "translations", type: "ProductTranslation[]", control: "none", source: "none" },
        },
        ProductHistory: {
            $name: "ProductHistory",
            id: { name: "id", type: "number", control: "none", source: "none" },
            name: { name: "name", type: "text", control: "suggest", source: "suggestProducts" },
            shortDescription: { name: "shortDescription", type: "text", control: "text", source: "none" },
            sku: { name: "sku", type: "text", control: "text", source: "none" },
            mfgPartNumber: { name: "mfgPartNumber", type: "text", control: "text", source: "none" },
            manufacturer: { name: "manufacturer", type: "text", control: "select", source: "manufacturers" },
            unitOfMeasure: { name: "unitOfMeasure", type: "text", control: "none", source: "none" },
            price: { name: "price", type: "number", control: "numberRange", source: "none" },
            maxQty: { name: "maxQty", type: "number", control: "none", source: "none" },
            minQty: { name: "minQty", type: "number", control: "none", source: "none" },
            allowFractionalQty: { name: "allowFractionalQty", type: "boolean", control: "none", source: "none" },
            score: { name: "score", type: "number", control: "none", source: "none" },
            createdDate: { name: "createdDate", type: "text", control: "dateRange", source: "none" },
            modifiedByName: { name: "modifiedByName", type: "text", control: "none", source: "none" },
            isConfigured: { name: "isConfigured", type: "boolean", control: "none", source: "none" },
            images: { name: "images", type: "ProductImage[]", control: "none", source: "none" },
            templates: { name: "templates", type: "ProductTemplate[]", control: "none", source: "none" },
            translations: { name: "translations", type: "ProductTranslation[]", control: "none", source: "none" },
        },
        ProductImage: {
            $name: "ProductImage",
            id: { name: "id", type: "number", control: "none", source: "none" },
            imagePath: { name: "imagePath", type: "text", control: "none", source: "none" },
            imageOrder: { name: "imageOrder", type: "number", control: "none", source: "none" },
        },
        ProductRule: {
            $name: "ProductRule",
        },
        ProductTemplate: {
            $name: "ProductTemplate",
            id: { name: "id", type: "number", control: "none", source: "none" },
            templatePath: { name: "templatePath", type: "text", control: "none", source: "none" },
        },
        Queue: {
            $name: "Queue",
        },
        Quote: {
            $name: "Quote",
            id: { name: "id", type: "number", control: "none", source: "none" },
            state: { name: "state", type: "text", control: "multiSelect", source: "states", default: true },
            ownedBy: { name: "ownedBy", type: "number", control: "multiSelect", source: "users", default: true, permissions: [exports.ePerm.viewUsers] },
            idCustomer: { name: "idCustomer", type: "number", control: "multiSelect", source: "customers", permissions: [exports.ePerm.viewCustomers] },
            idContact: { name: "idContact", type: "number", control: "suggest", source: "suggestContacts", permissions: [exports.ePerm.viewCustomers] },
            name: { name: "name", type: "text", control: "suggest", source: "suggestQuotes" },
            description: { name: "description", type: "text", control: "text", source: "none" },
            currency: { name: "currency", type: "text", control: "none", source: "none" },
            createdDate: { name: "createdDate", type: "text", control: "dateRange", source: "none" },
            modifiedDate: { name: "modifiedDate", type: "text", control: "dateRange", source: "none" },
            owner: { name: "owner", type: "text", control: "none", source: "none" },
            customer: { name: "customer", type: "text", control: "none", source: "none" },
            contact: { name: "contact", type: "text", control: "none", source: "none" },
            products: { name: "products", type: "QuoteProduct[]", control: "none", source: "none" },
            files: { name: "files", type: "QuoteFile[]", control: "none", source: "none" },
            totalPrice: { name: "totalPrice", type: "number", control: "numberRange", source: "none", permissions: [exports.ePerm.viewPrices] },
        },
        QuoteFile: {
            $name: "QuoteFile",
            tags: { name: "tags", type: "Tag[]", control: "none", source: "none" },
            id: { name: "id", type: "number", control: "none", source: "none" },
            name: { name: "name", type: "text", control: "none", source: "none" },
            source: { name: "source", type: "text", control: "none", source: "none" },
            status: { name: "status", type: "text", control: "none", source: "none" },
            filePath: { name: "filePath", type: "text", control: "none", source: "none" },
        },
        QuoteHeader: {
            $name: "QuoteHeader",
            id: { name: "id", type: "number", control: "none", source: "none" },
            name: { name: "name", type: "text", control: "none", source: "none" },
            description: { name: "description", type: "text", control: "none", source: "none" },
            modifiedByName: { name: "modifiedByName", type: "text", control: "none", source: "none" },
        },
        QuoteOutput: {
            $name: "QuoteOutput",
            id: { name: "id", type: "number", control: "none", source: "none" },
            name: { name: "name", type: "text", control: "none", source: "none" },
            description: { name: "description", type: "text", control: "none", source: "none" },
            modifiedDate: { name: "modifiedDate", type: "text", control: "none", source: "none" },
            modifiedByName: { name: "modifiedByName", type: "text", control: "none", source: "none" },
        },
        QuoteProduct: {
            $name: "QuoteProduct",
            id: { name: "id", type: "number", control: "none", source: "none" },
            idQuote: { name: "idQuote", type: "number", control: "none", source: "none" },
            quote: { name: "quote", type: "text", control: "none", source: "none" },
            currency: { name: "currency", type: "text", control: "none", source: "none" },
            isConfigured: { name: "isConfigured", type: "boolean", control: "none", source: "none" },
            price: { name: "price", type: "number", control: "numberRange", source: "none", permissions: [exports.ePerm.viewPrices] },
            createdDate: { name: "createdDate", type: "text", control: "dateRange", source: "none" },
            modifiedDate: { name: "modifiedDate", type: "text", control: "dateRange", source: "none" },
            createdBy: { name: "createdBy", type: "number", control: "select", source: "users", permissions: [exports.ePerm.viewUsers] },
            files: { name: "files", type: "QuoteProductFile[]", control: "none", source: "none" },
            name: { name: "name", type: "text", control: "text", source: "none" },
            description: { name: "description", type: "text", control: "text", source: "none" },
            shortDescription: { name: "shortDescription", type: "text", control: "none", source: "none" },
            sku: { name: "sku", type: "text", control: "text", source: "none" },
            imagePath: { name: "imagePath", type: "text", control: "none", source: "none" },
            idParent: { name: "idParent", type: "number", control: "none", source: "none" },
            idMainParent: { name: "idMainParent", type: "number", control: "none", source: "none" },
        },
        RootUser: {
            $name: "RootUser",
            email: { name: "email", type: "text", control: "none", source: "none" },
        },
        SafeFunction: {
            $name: "SafeFunction",
            id: { name: "id", type: "number", control: "none", source: "none" },
            name: { name: "name", type: "text", control: "none", source: "none" },
            description: { name: "description", type: "text", control: "none", source: "none" },
            modifiedDate: { name: "modifiedDate", type: "text", control: "none", source: "none" },
            modifiedByName: { name: "modifiedByName", type: "text", control: "none", source: "none" },
        },
        Scene: {
            $name: "Scene",
            id: { name: "id", type: "number", control: "none", source: "none" },
            name: { name: "name", type: "text", control: "none", source: "none" },
            description: { name: "description", type: "text", control: "none", source: "none" },
            modifiedBy: { name: "modifiedBy", type: "number", control: "none", source: "none" },
            createdDate: { name: "createdDate", type: "text", control: "dateRange", source: "none" },
            modifiedDate: { name: "modifiedDate", type: "text", control: "dateRange", source: "none" },
            external: { name: "external", type: "boolean", control: "none", source: "none" },
            modifiedByName: { name: "modifiedByName", type: "text", control: "none", source: "none" },
        },
        SnapAssistantFeedback: {
            $name: "SnapAssistantFeedback",
        },
        SsoGroupRoleMapping: {
            $name: "SsoGroupRoleMapping",
        },
        Table: {
            $name: "Table",
            id: { name: "id", type: "number", control: "none", source: "none" },
            name: { name: "name", type: "text", control: "none", source: "none" },
            description: { name: "description", type: "text", control: "none", source: "none" },
            modifiedByName: { name: "modifiedByName", type: "text", control: "none", source: "none" },
            createdDate: { name: "createdDate", type: "text", control: "dateRange", source: "none" },
            modifiedDate: { name: "modifiedDate", type: "text", control: "dateRange", source: "none" },
            source: { name: "source", type: "text", control: "select", source: "enum", enumType: "eTableExternalSource" },
            dbTable: { name: "dbTable", type: "text", control: "none", source: "none" },
        },
        Tag: {
            $name: "Tag",
            id: { name: "id", type: "number", control: "none", source: "none" },
            name: { name: "name", type: "text", control: "none", source: "none" },
        },
        TestBuild: {
            $name: "TestBuild",
            id: { name: "id", type: "number", control: "none", source: "none" },
            idProduct: { name: "idProduct", type: "number", control: "none", source: "none" },
            idBuildType: { name: "idBuildType", type: "number", control: "none", source: "none" },
            name: { name: "name", type: "text", control: "none", source: "none" },
            createdDate: { name: "createdDate", type: "text", control: "dateRange", source: "none" },
            status: { name: "status", type: "text", control: "select", source: "enum", enumType: "eBuildStatus" },
            creatorName: { name: "creatorName", type: "text", control: "none", source: "none" },
        },
        Theme: {
            $name: "Theme",
        },
        Workflow: {
            $name: "Workflow",
            id: { name: "id", type: "number", control: "none", source: "none" },
            name: { name: "name", type: "text", control: "none", source: "none" },
            description: { name: "description", type: "text", control: "none", source: "none" },
            modifiedByName: { name: "modifiedByName", type: "text", control: "none", source: "none" },
            valid: { name: "valid", type: "boolean", control: "none", source: "none" },
            isDefault: { name: "isDefault", type: "boolean", control: "none", source: "none" },
        },
        WorkflowSelector: {
            $name: "WorkflowSelector",
        },
        SceneHistory: {
            $name: "SceneHistory",
            id: { name: "id", type: "number", control: "none", source: "none" },
            name: { name: "name", type: "text", control: "none", source: "none" },
            description: { name: "description", type: "text", control: "none", source: "none" },
            modifiedBy: { name: "modifiedBy", type: "number", control: "none", source: "none" },
            createdDate: { name: "createdDate", type: "text", control: "dateRange", source: "none" },
            modifiedDate: { name: "modifiedDate", type: "text", control: "dateRange", source: "none" },
            external: { name: "external", type: "boolean", control: "none", source: "none" },
            modifiedByName: { name: "modifiedByName", type: "text", control: "none", source: "none" },
        },
        FeedbackRequest: {
            $name: "FeedbackRequest",
        },
        SnapConversation: {
            $name: "SnapConversation",
        },
    };

    var Table = /** @class */ (function () {
        function Table(o) {
            var _this = this;
            this.columns = [];
            this.data = [[]];
            this._columnDb = {};
            if (o) {
                this.id = o.id;
                o.columns.forEach(function (c) {
                    _this.addColumn(c);
                });
                this.name = o.name;
                this.description = o.description;
                this.data = o.data;
            }
        }
        /**
         * use this instead of pushing directly to columns array so that
         * the columnDb can be maintained for fast searching
         */
        Table.prototype.addColumn = function (col) {
            this.columns.push(col);
            this._columnDb[col.name] = this.columns.length - 1;
        };
        // public addStandardColumns() {
        //    this.data = [[]];
        //    this.columns.clear();
        //    this.columns.pushArray([
        //        { name: "value", type: eColumnType.text },
        //        { name: "label", type: eColumnType.text },
        //        { name: "image", type: eColumnType.media }
        //    ]);
        // }
        Table.prototype.addRow = function (row) {
            var rowArr = [];
            for (var _i = 0, _a = this.columns; _i < _a.length; _i++) {
                var col = _a[_i];
                rowArr.push(row[col.name]);
            }
            this.data.push(rowArr);
        };
        Table.prototype.getCell = function (rowIndex, colName) {
            return this.data[rowIndex][this._columnDb[colName]];
        };
        Table.prototype.toObjectArray = function () {
            var _this = this;
            var d = [];
            var columnScrubMap = {};
            this.columns.forEach(function (col, i) {
                columnScrubMap[i] = _tools.Utils.scrubName(col.name);
            });
            this.data.forEach(function (row, r) {
                var o = {};
                _this.columns.forEach(function (col, c) {
                    o[columnScrubMap[c]] = row[c];
                });
                d.push(o);
            });
            return {
                columns: this.columns,
                data: d
            };
        };
        return Table;
    }());

    exports.Accordion = Accordion;
    exports.ActionBar = ActionBar;
    exports.AllEnums = AllEnums;
    exports.BistrackMethodOfManufacture = BistrackMethodOfManufacture;
    exports.BistrackPartRev = BistrackPartRev;
    exports.BomOutput = BomOutput;
    exports.Build = Build;
    exports.Button = Button;
    exports.CToken = CToken;
    exports.CadAngleMate = CadAngleMate;
    exports.CadAnnotationField = CadAnnotationField;
    exports.CadBlockArrayField = CadBlockArrayField;
    exports.CadBlockField = CadBlockField;
    exports.CadCoincidentMate = CadCoincidentMate;
    exports.CadComponentField = CadComponentField;
    exports.CadCoordinateSystemMate = CadCoordinateSystemMate;
    exports.CadCustomPropertyField = CadCustomPropertyField;
    exports.CadDimensionField = CadDimensionField;
    exports.CadDistanceMate = CadDistanceMate;
    exports.CadDrawingAnnotationField = CadDrawingAnnotationField;
    exports.CadDrawingDimensionField = CadDrawingDimensionField;
    exports.CadDrawingOutput = CadDrawingOutput;
    exports.CadDrawingSheetField = CadDrawingSheetField;
    exports.CadDrawingViewField = CadDrawingViewField;
    exports.CadDynamicComponentField = CadDynamicComponentField;
    exports.CadDynamicDrawingAnnotationField = CadDynamicDrawingAnnotationField;
    exports.CadDynamicDrawingDimensionField = CadDynamicDrawingDimensionField;
    exports.CadFeatureField = CadFeatureField;
    exports.CadLayerField = CadLayerField;
    exports.CadLibDimension = CadLibDimension;
    exports.CadLibFeatureField = CadLibFeatureField;
    exports.CadLibReference = CadLibReference;
    exports.CadOutput = CadOutput;
    exports.CadParameterField = CadParameterField;
    exports.CadPositionConstraint = CadPositionConstraint;
    exports.CadReplaceComponentField = CadReplaceComponentField;
    exports.CadRepresentationField = CadRepresentationField;
    exports.CadScaleFeatureField = CadScaleFeatureField;
    exports.CadTextField = CadTextField;
    exports.Configurator = Configurator;
    exports.ConfiguratorAction = ConfiguratorAction;
    exports.ConfiguratorDI = ConfiguratorDI;
    exports.ConfiguratorFunction = ConfiguratorFunction;
    exports.Constraint = Constraint;
    exports.Container = Container;
    exports.DialogButton = DialogButton;
    exports.DialogButtonArgs = DialogButtonArgs;
    exports.DropdownButton = DropdownButton;
    exports.Enumerable = Enumerable;
    exports.ExcelCellField = ExcelCellField;
    exports.ExcelChartField = ExcelChartField;
    exports.ExcelImageField = ExcelImageField;
    exports.ExcelOutput = ExcelOutput;
    exports.ExcelSheetField = ExcelSheetField;
    exports.ExcelTableField = ExcelTableField;
    exports.Expander = Expander;
    exports.Export = Export;
    exports.Field = Field;
    exports.FileOutput = FileOutput;
    exports.GridColumn = GridColumn;
    exports.GridRow = GridRow;
    exports.Group = Group;
    exports.Hotspot = Hotspot;
    exports.Html = Html;
    exports.ImageOutput = ImageOutput;
    exports.InputDialogButton = InputDialogButton;
    exports.InputDialogButtonArgs = InputDialogButtonArgs;
    exports.KbObject = KbObject;
    exports.KbObjectManager = KbObjectManager;
    exports.Kbo = Kbo;
    exports.KboOutput = KboOutput;
    exports.KboOutputField = KboOutputField;
    exports.LayoutConfig = LayoutConfig;
    exports.LayoutContent = LayoutContent;
    exports.Mate = Mate;
    exports.Media = Media;
    exports.MediaDialogButton = MediaDialogButton;
    exports.MediaDialogButtonArgs = MediaDialogButtonArgs;
    exports.MethodOfManufacture = MethodOfManufacture;
    exports.NestedElement = NestedElement;
    exports.NestedSet = NestedSet;
    exports.Option = Option;
    exports.OptionFilter = OptionFilter;
    exports.Output = Output;
    exports.OutputField = OutputField;
    exports.OverlayPopup = OverlayPopup;
    exports.OverlayPopupControl = OverlayPopupControl;
    exports.Page = Page;
    exports.PageControl = PageControl;
    exports.PageNavigator = PageNavigator;
    exports.PageTabs = PageTabs;
    exports.PartMaterial = PartMaterial;
    exports.PartOperation = PartOperation;
    exports.PartOperationDetail = PartOperationDetail;
    exports.PartRev = PartRev;
    exports.PdfOutput = PdfOutput;
    exports.PdfSectionField = PdfSectionField;
    exports.Popup = Popup;
    exports.PriceWidget = PriceWidget;
    exports.PricingRuleContainer = PricingRuleContainer;
    exports.PropertyChangedEvent = PropertyChangedEvent;
    exports.ReferencedConfigurator = ReferencedConfigurator;
    exports.RenderPassExport = RenderPassExport;
    exports.Rule = Rule;
    exports.RuleContainer = RuleContainer;
    exports.SceneRenderOutput = SceneRenderOutput;
    exports.SvgOutput = SvgOutput;
    exports.SvgViewer = SvgViewer;
    exports.Tab = Tab;
    exports.TabControl = TabControl;
    exports.Table = Table;
    exports.Text = Text;
    exports.TextOutput = TextOutput;
    exports.Toolbar = Toolbar;
    exports.UiObject = UiObject;
    exports.Viewer = Viewer;
    exports.WordContainerField = WordContainerField;
    exports.WordImageField = WordImageField;
    exports.WordListField = WordListField;
    exports.WordOutput = WordOutput;
    exports.WordTextField = WordTextField;
    exports.ZipOutput = ZipOutput;
    exports.ZipSectionField = ZipSectionField;
    exports.defaults = defaults;
    exports.glbOutput = glbOutput;
    exports.meta = meta;

    return exports;

}({}, tools));
//# sourceMappingURL=models.js.map
